import { isMaisterchef, brandName, brandNameChat } from './utils/branding';

function applyBranding(obj) {
    if (!isMaisterchef) return obj;
    const result = {};
    for (const key of Object.keys(obj)) {
        const val = obj[key];
        if (typeof val === 'string') {
            result[key] = val
                .replace(/SousChaif/g, brandNameChat)
                .replace(/Souschaif/g, brandName)
                .replace(/Sous-Chaif/g, brandNameChat)
                .replace(/'sous-chaif'/g, brandNameChat)
                .replace(/sous-chaif/g, brandNameChat);
        } else if (typeof val === 'object' && val !== null) {
            result[key] = applyBranding(val);
        } else {
            result[key] = val;
        }
    }
    return result;
}

export const languages = applyBranding({
    portuguese: {
        and: "e",
        validateWeight: "O peso deve estar entre",
        validateHeight: "A altura deve estar entre",
        nutritionGoals: "Objetivos nutricionais",
        safetyAndDisclaimer: "Segurança & Aviso legal",
        safetyAndDisclaimerText: "As metas são estimativas e não substituem aconselhamento médico, nutricional ou dietético profissional. Se tiver problemas de saúde, consulte um profissional de saúde.",
        male: "Masculino",
        female: "Feminino",
        other: "Outro",
        allowed: "Permitido",
        pleaseEnterAWeight: "Por favor insira um peso",
        pleaseEnterAHeight: "Por favor insira uma altura",
        calories: "Calorias",
        protein: "Proteína",
        fat: "Gordura",
        carbs: "Hidratos de carbono",
        sex: "Sexo",
        age: "Idade",
        weight: "Peso",
        height: "Altura",
        activity: "Atividade",
        goal: "Objetivo",
        computeGoals: "Calcular objetivos",
        light: "Leve",
        moderate: "Moderado",
        veryActive: "Muito ativo",
        extraActive: "Extremamente ativo",
        lose: "Perder",
        maintain: "Manter",
        gain: "Ganhar",
        dailyTargets: "Metas diárias",
        unableToFetchPrices: 'Não é possível obter preços para a moeda',
        loadingPrices: 'Carregando preços',
        currency: 'Moeda',
        latestMarketPrices: 'Últimos preços de mercado',
        countryCurrency: 'EUR',
        startScan: 'Iniciar digitalização',
        scanAnother: 'Digitalize outro',
        scanning: 'Digitalização',
        vitaminD: 'Vitamina D',
        salt: 'Sal',
        protein: 'Proteína',
        fiber: 'Fibra',
        addedSugars: 'Açúcares adicionados',
        sugars: 'Açúcares',
        saturatedFat: 'Gordura saturada',
        fat: 'Gordo',
        energy: 'Energia',
        amount: 'Montante',
        productNutrient: 'Nutriente',
        productNutritionalValuesPer100g: 'Valor nutricional (por 100g)',
        productIngredients: 'Ingredientes',
        productNutriScore: 'Nutri-Score',
        productBrand: 'Marca',
        scanYourProductBarcode: 'Digitalize o código de barras do seu produto!',
        productLookupFailed: 'Falha na pesquisa de produto',
        productNotFoundError: 'Producto no encontrado',
        cameraFailedStartError: 'A câmara não pôde iniciar',
        profile: 'Perfil',
        basicInformation: 'Informações Básicas',
        savedRecipes: 'Receitas Guardadas',
        noSavedRecipes: 'Ainda não tem receitas guardadas.',
        userData: 'Dados do Utilizador',
        recipeRemoved: 'A receita {recipeName} foi removida das suas favoritas.',
        username: 'Nome do Utilizador',
        mobileNumber: 'Número de Telemóvel',
        password: 'Palavra-passe',
        saveChanges: 'Guardar Alterações',
        changesSaved: 'As suas alterações foram guardadas.',
        subscriptionInformation: 'Informações da Subscrição',
        lastBillingDate: 'Última Data de Faturação',
        nextBillingDate: 'Próxima Data de Faturação',
        subscriptionStarted: 'Subscrição Iniciada',
        timesBilled: 'Vezes Faturado',
        serviceName: 'Nome do Serviço',
        termsAndConditions: 'Termos e Condições',
        viewTermsAndConditions: 'Ver Termos e Condições',
        pricingInformation: 'Informações de Preços',
        unsubscribe: 'Cancelar Subscrição',
        unsubscribed: 'A sua subscrição foi cancelada.',
        selectLanguage: "Selecione o seu idioma",
        whatToDo: "O que deseja fazer?",
        takePhoto: "Tirar fotografia",
        uploadPhoto: "Carregar foto",
        pleaseAddPhotoFirst: "Por favor adicione uma foto primeiro ou tire uma foto",
        uploading: "A criar as suas receitas personalizadas...", // Changed gerund
        loadingTime: "Isto pode levar até 1 minuto...", // Changed 'Isso' to 'Isto'
        analyzing: "A IA está a analisar a sua foto...", // Changed gerund
        aiAnalysisResult: "Resultado da Análise de IA:",
        uploadError: "Ocorreu um erro ao carregar a imagem.",
        processingError: "Ocorreu um erro ao processar a imagem.",
        numberOfPeople: 'Número de pessoas',
        timeOfDay: 'Hora do dia',
        selectTimeOfDay: 'Selecione a hora do dia',
        breakfast: 'Pequeno Almoço',
        morningSnack: 'Lanche da manhã',
        lunch: 'Almoço',
        afternoonSnack: 'Lanche da tarde',
        dinner: 'Jantar',
        dessert: 'Sobremesa',
        lateNightSnack: 'Lanche noturno',
        preferredCuisine: 'Culinária Preferida',
        selectCuisine: 'Selecione a culinária',
        italian: 'Italiana',
        chinese: 'Chinesa',
        indian: 'Indiana',
        mexican: 'Mexicana',
        french: 'Francesa',
        thai: 'Tailandesa',
        japanese: 'Japonesa',
        mediterranean: 'Mediterrânea',
        spanish: 'Espanhola',
        greek: 'Grega',
        vietnamese: 'Vietnamita',
        american: 'Americana',
        turkish: 'Turca',
        korean: 'Coreana',
        moroccan: 'Marroquina',
        persian: 'Persa',
        allergies: 'Alergias',
        selectAllergies: 'Selecione alergias',
        gluten: 'Glúten',
        nuts: 'Nozes',
        lactose: 'Lactose',
        soy: 'Soja',
        shellfish: 'Marisco',
        fish: 'Peixe',
        eggs: 'Ovos',
        peanuts: 'Amendoim',
        sesame: 'Sementes de Sésamo',
        sulphites: 'Sulfitos',
        mustard: 'Mostarda',
        celery: 'Aipo',
        lupin: 'Tremoço',
        molluscs: 'Moluscos',
        cookingTime: 'Tempo de Preparação', // Changed 'Preparo' to 'Preparação'
        cookingTip: "Dica de Culinária:",
        minutes: 'minutos',
        caloriesPerServing: 'Calorias por porção',
        servings: 'porções',
        allergens: 'Alergénios', // Changed 'Alérgenos' to 'Alergénios'
        ingredients: 'Ingredientes',
        instructions: 'Instruções',
        askQuestion: 'Fazer uma pergunta',
        recipeLibrary: 'Biblioteca de Receitas',
        loadMore: 'Carregar mais',
        loadNewRandomRecipes: 'Carregar mais receitas',
        loadingRecipes: 'A carregar {count} receitas...',
        viewRecipe: 'Ver receita',
        noResultsFound: 'Nenhum resultado encontrado',
        search: 'Carregar Imagem',
        decrease: 'Menos',
        increase: 'Mais',
        uploading: "A carregar", // Changed gerund
        elapsedTime: "Tempo decorrido",
        seconds: "segundos",
        cameraNotSupported: 'Câmara não suportada neste dispositivo', // Changed 'Câmera' to 'Câmara'
        nutritions: "Valores Nutricionais",
        calories: "Calorias",
        protein: "Proteínas",
        carbs: "Carboidratos",
        fat: "Gorduras",
        fiber: "Fibras",
        sugar: "Açúcar",
        sodium: "Sódio",
        vitamina: "Vitamina A",
        vitaminc: "Vitamina C",
        calcium: "Cálcio",
        iron: "Ferro",
        recipeDetails: "Detalhes da Receita",
        loadMore: "Carregar mais receitas",
        recipeAlreadySaved: 'Receita já está salva.',
        recipeSaved: 'Receita foi salva com sucesso.',
        errorSavingRecipe: 'Erro ao salvar a receita. Tente novamente.',
        recipeShared: "Receita compartilhada via {platform}!",
        defaultSaveMessage: "Ação concluída com sucesso!",
        share: "Compartilhar",
        favorite: "Favorito",
        close: "Fechar",
        whatsapp: "WhatsApp",
        facebook: "Facebook",
        twitter: "Twitter",
        email: "E-mail",
        loading: 'A procurar novas receitas...', // Changed 'Buscando' to 'A procurar'
        tetrisTitle: "Jogue Tetris enquanto espera!",
        score: "Pontuação",
        highScore: "Pontuação Máxima", // Changed 'Maior Pontuação' to 'Pontuação Máxima'
        gameOver: "Fim de Jogo",
        playAgain: "Jogar Novamente",
        left: "Esquerda",
        right: "Direita",
        down: "Baixo",
        rotate: "Rodar", // Changed 'Girar' to 'Rodar'
        startTetris: "Jogar Tetris",
        stopOrContinueTetris: "As receitas foram carregadas. Deseja parar o Tetris e ver as receitas?",
        continueTetris: "Continuar Tetris",
        playTetris: "Jogar Tetris",
        viewRecipes: "Ver receitas",
        recipesLoaded: "O SousChaif está pronto com as suas receitas!", // Changed 'suas' to 'as suas'
        capturePhoto: "Tirar fotografia", // Changed 'foto' to 'fotografia'
        closeCamera: "Fechar câmara", // Changed 'câmera' to 'câmara'
        pictureIngredients: "Fotografar Ingredientes",
        previewImage: "Aprovar imagem",
        retake: "Repetir", // Changed 'Refazer' to 'Repetir'
        approve: "Enviar",
        waitingNotice: "Jogue um jogo enquanto espera.",
        profile: "Perfil",
        basicInformation: "Informações Básicas",
        name: "Nome",
        email: "Email", // Changed 'E-mail' to 'Email'
        savedRecipes: "Receitas Guardadas", // Changed 'Salvas' to 'Guardadas'
        noSavedRecipes: "Ainda não tem receitas guardadas.",
        recipeRemoved: "A receita {recipeName} foi removida das suas favoritas.", // Changed 'seus' to 'suas'
        newSearchQuestion: "Procurar novas receitas?", // Changed 'Buscar' to 'Procurar'
        newSearchPrompt: "Deseja procurar novas receitas ou ver os seus resultados anteriores?", // Changed 'buscar' to 'procurar', 'seus' to 'os seus'
        searchNewRecipes: "Procurar novas receitas", // Changed 'Buscar' to 'Procurar'
        seeOldRecipes: "Ver",
        chatBotIntro: "Claro! Estou aqui para ajudar. Como posso auxiliar na sua aventura culinária em português?",
        chatWithSousChaif: "Converse com o SousChaif", // Added 'o'
        typeYourMessage: "Escreva a sua mensagem...", // Changed 'Digite sua' to 'Escreva a sua'
        recipeLoaded: "Receita carregada",
        askAboutRecipe: "Perguntar sobre a receita",
        errorFetchingData: "Ocorreu um erro ao obter os dados.", // Changed 'buscar' to 'obter'
        whatQuestionWouldYouLikeToAsk: "Que pergunta gostaria de fazer?", // Changed 'Qual' to 'Que'
        welcomeBack: "Bem-vindo de volta",
        needHelpWithRecipe: "Precisa de ajuda a cozinhar?", // Changed 'com a culinária' to 'a cozinhar'
        viewRecipesHome: "Faça a sua pergunta",
        popularIngredients: "Ingredientes Populares",
        popularCookbooks: "Livros de Culinária Populares",
        browseByLetter: "Navegar por Letra",
        videoRecipes: "Receitas em Vídeo",
        randomRecipes: "Receitas Aleatórias",
        recipesByLetter: "Receitas por Letra",
        noRecipesFound: "Nenhuma receita encontrada",
        watchVideo: "Ver Vídeo",
        loadMore: "Carregar Mais",
        categories: "Categorias",
        ingredients: "Ingredientes",
        areas: "Áreas",
        filterBy: "Filtrar por",
        all: "Todos",
        // Categories
        beef: "Carne Bovina",
        breakfast: "Café da Manhã",
        chicken: "Frango",
        dessert: "Sobremesa",
        goat: "Cabra",
        lamb: "Cordeiro",
        miscellaneous: "Diversos",
        pasta: "Massa",
        pork: "Carne Suína",
        seafood: "Frutos do Mar",
        side: "Acompanhamento",
        starter: "Entrada",
        vegan: "Vegano",
        vegetarian: "Vegetariano",
        // Ingredients
        avocado: "Abacate",
        bacon: "Bacon",
        bakingPowder: "Fermento em Pó",
        balsamicVinegar: "Vinagre Balsâmico",
        basil: "Manjericão",
        basilLeaves: "Folhas de Manjericão",
        basmatiRice: "Arroz Basmati",
        bayLeaf: "Folha de Louro",
        bayLeaves: "Folhas de Louro",
        beefBrisket: "Peito de Boi",
        beefFillet: "Filé de Boi",
        beefGravy: "Molho de Carne",
        beefStock: "Caldo de Carne",
        bicarbonateOfSoda: "Bicarbonato de Sódio",
        biryaniMasala: "Tempero Biryani",
        blackPepper: "Pimenta Preta",
        blackTreacle: "Melaço Preto",
        // Additional ingredients
        appleCiderVinegar: "Vinagre de Maçã",
        asparagus: "Aspargos",
        aubergine: "Beringela",
        babyPlumTomatoes: "Tomates Cereja",
        // Areas
        american: "Americano",
        british: "Britânico",
        canadian: "Canadense",
        chinese: "Chinês",
        croatian: "Croata",
        dutch: "Holandês",
        egyptian: "Egípcio",
        filipino: "Filipino",
        french: "Francês",
        greek: "Grego",
        indian: "Indiano",
        irish: "Irlandês",
        italian: "Italiano",
        jamaican: "Jamaicano",
        japanese: "Japonês",
        kenyan: "Queniano",
        malaysian: "Malaio",
        mexican: "Mexicano",
        moroccan: "Marroquino",
        polish: "Polonês",
        portuguese: "Português",
        russian: "Russo",
        spanish: "Espanhol",
        syrian: "Sírio",
        thai: "Tailandês",
        tunisian: "Tunisiano",
        turkish: "Turco",
        ukrainian: "Ucraniano",
        uruguayan: "Uruguaio",
        vietnamese: "Vietnamita",
        recipes: "receitas",
        Chicken: "Frango",
        Beef: "Carne Bovina",
        Pork: "Carne Suína",
        Salmon: "Salmão",
        Shrimp: "Camarão",
        Eggs: "Ovos",
        Tofu: "Tofu",
        Tuna: "Atum",
        Potato: "Batata",
        Rice: "Arroz",
        comments: "Comentários",
        addComment: "Deixe um comentário",
        noComments: "Ainda não há comentários. Seja o primeiro!",
        submit: "Submeter", // Changed 'Enviar' to 'Submeter'
        commentSubmitted: "Comentário publicado!",
        errorSubmittingComment: "Erro ao publicar o comentário.",
        backToWaiting: 'Voltar', // Capitalized
        shoppingList: "Lista de Compras",
        addItem: "Adicionar item",
        add: "Adicionar",
        clearList: "Limpar lista",
        addToShoppingList: "Adicionar à lista de compras",
        addedToShoppingList: "Ingredientes adicionados à lista de compras!",
        quantity: "Quantidade",
        diet: "Dieta",
        selectDiet: "Selecione uma dieta",
        keto: "Keto",
        lowCarb: "Baixo Carboidrato",
        vegetarian: "Vegetariana",
        vegan: "Vegana",
        paleo: "Paleo",
        mediterraneanDiet: "Mediterrânea",
        dairyFree: "Sem Laticínios",
        glutenFree: "Sem Glúten",
        lowFat: "Baixa Gordura",
        highProtein: "Rica em Proteínas",
        selectIngredients: "Selecione ingredientes",
        chicken: "Frango",
        beef: "Carne Bovina",
        pork: "Carne Suína",
        salmon: "Salmão",
        shrimp: "Camarão",
        eggs: "Ovos",
        tofu: "Tofu",
        tuna: "Atum",
        potato: "Batata",
        rice: "Arroz",
        savedRecipes: "Receitas Salvas",
        filters: "Filtros",
        resetFilters: "Repor Filtros", // Changed 'Redefinir' to 'Repor'
        tryAgain: "Tentar Novamente",
        searchRecipes: "Procurar receitas...", // Changed 'Buscar' to 'Procurar'
        ingredients: "Ingredientes",
        allergens: "Alergénios", // Changed 'Alérgenos' to 'Alergénios'
        cookingTime: "Tempo de Preparação", // Changed 'Preparo' to 'Preparação'
        addIngredient: "Adicionar ingrediente",
        upTo: "Até",
        errorFetchingRecipes: "Ocorreu um erro ao obter as receitas", // Changed 'buscar' to 'obter'
        // Database Recipes (Library 1) filters
        recipeLibraryTitle: "Biblioteca de Receitas",
        recipesCount: "{count} receitas",
        searchPlaceholder: "Procurar receitas...",
        filterByLetter: "Filtrar por Letra",
        allLetters: "Todas",
        maxCalories: "Calorias Máximas",
        caloriesUnit: "kcal",
        maxCookingTime: "Tempo Máximo",
        minutesUnit: "min",
        servings: "Porções",
        minServings: "Porções Mínimas",
        maxServings: "Porções Máximas",
        selectAllergens: "Selecionar Alergénios",
        typeToSearch: "Digite para procurar...",
        selectNutritions: "Selecionar Nutrientes",
        selectIngredients: "Selecionar Ingredientes",
        clearFilters: "Limpar Filtros",
        noRecipesMatch: "Nenhuma receita corresponde aos filtros",
        dairy: "Laticínios",
        soy: "Soja",
        shellfish: "Marisco",
        fish: "Peixe",
        showFilters: "Mostrar Filtros",
        hideFilters: "Ocultar Filtros",
        viewAllRecipes: "Ver Todas as Receitas",
        budgetFriendlyCooking: "Culinária Económica",
        budgetFriendlyDescription: "Crie refeições deliciosas e económicas com o 'sous-chaif' usando receitas personalizadas baseadas nos seus ingredientes e preferências.", // Added 'o'
        customRecipeSuggestions: "Sugestões de Receitas Personalizadas",
        customRecipeDescription: "Partilhe os seus ingredientes, preferências e objetivos alimentares, e o 'sous-chaif' fornecerá receitas personalizadas especialmente para si.",
        secureAndEasy: "Seguro e Fácil",
        secureAndEasyDescription: "Os seus dados estão seguros connosco. Aproveite o acesso fácil a receitas personalizadas e dicas de culinária.",
        featureWelcomeTitle: "Bem-vindo ao Souschaif!",
        featureWelcomeSubtitle: "Carregue uma foto dos seus ingredientes ou frigorífico e receba receitas de imediato. Pode fechar este ecrã a qualquer momento.",
        featureWelcomeGotIt: "Percebi",
        featureWelcomeMainBadge: "Mais importante",
        featureWelcomePhotoTitle: "Carregar foto de ingredientes ou frigorífico",
        featureWelcomePhotoDescription: "Tire ou carregue uma foto e receba receitas personalizadas com base no que tem em casa.",
        featureWelcomeChatDescription: "Faça perguntas ao nosso chef de IA e receba conselhos de cozinha personalizados.",
        featureWelcomeLibraryDescription: "Explore centenas de receitas e filtre por ingredientes, alergénios e tempo de confeção.",
        featureWelcomeShoppingDescription: "Crie listas de compras automaticamente a partir das suas receitas.",
        smartShoppingList: "Lista de compras inteligente",
        smartShoppingListDescription: "Gere listas de compras com base nas suas receitas favoritas.",
        usernameOrMobile: "Nome de utilizador ou Número de Telemóvel",
        rememberMe: "Lembrar-se de mim", // Changed 'Lembrar de mim' to 'Lembrar-se de mim'
        logIn: "Iniciar sessão", // Changed 'Entrar' to 'Iniciar sessão'
        signingIn: "A iniciar sessão...",
        noAccount: "Não tem uma conta?",
        signUp: "Registar-se", // Changed 'Registe-se' to 'Registar-se'
        next: "Próximo",
        skip: "Saltar", // Changed 'Pular' to 'Saltar'
        notSubscribed: 'Não está subscrito a este serviço', // Changed 'Você não está inscrito' to 'Não está subscrito a'
        loginError: 'Não foi possível verificar a sua subscrição. Tente novamente mais tarde', // Changed 'sua assinatura' to 'a sua subscrição'
        signup: "Registar", // Changed 'Cadastrar' to 'Registar'
        signupIntro: "Crie a sua conta para começar",
        username: "Nome do Utilizador",
        password: "Palavra-passe",
        confirmPassword: "Confirmar palavra-passe", // Changed 'senha' to 'palavra-passe'
        email: "Endereço de email", // Changed 'e-mail' to 'email'
        mobileNumber: "Número de Telemóvel",
        signupButton: "Criar conta",
        signupError: "Erro durante o registo",
        alreadySubscribed: "Já está subscrito?",
        clickHere: "Clique aqui",
        signupSuccess: "Conta criada com sucesso",
        passwordRequirements: "Requisitos da palavra-passe", // Changed 'senha' to 'palavra-passe'
        minLength: "Mínimo de 8 caracteres",
        requireUppercase: "Pelo menos uma letra maiúscula",
        requireLowercase: "Pelo menos uma letra minúscula",
        requireNumber: "Pelo menos um número",
        requireSpecial: "Pelo menos um carácter especial", // Changed 'caractere' to 'carácter'
        passwordsMatch: "As palavras-passe coincidem", // Changed 'Senhas' to 'As palavras-passe'
        passwordRequirementsNotMet: "Cumpra todos os requisitos da palavra-passe", // Changed 'Atenda a todos os requisitos de senha' to 'Cumpra todos os requisitos da palavra-passe'
        profile: "Perfil",
        savedRecipes: "Receitas Guardadas", // Changed 'Salvas' to 'Guardadas'
        userData: "Dados do Utilizador",
        basicInformation: "Informações Básicas",
        username: "Nome do Utilizador",
        email: "Email", // Changed 'E-mail' to 'Email'
        mobileNumber: "Número de Telemóvel",
        password: "Palavra-passe",
        newPassword: "Nova Palavra-passe", // Changed 'Senha' to 'Palavra-passe'
        leaveEmptyToKeep: "Deixe em branco para manter a palavra-passe atual", // Changed 'senha' to 'palavra-passe'
        saveChanges: "Guardar Alterações", // Changed 'Salvar' to 'Guardar'
        changesSaved: "Alterações guardadas com sucesso", // Changed 'salvas' to 'guardadas'
        subscriptionInformation: "Informações da Subscrição",
        sessionId: "ID da Sessão", // Changed 'de' to 'da'
        createdAt: "Conta Criada",
        lastBillingDate: "Última Data de Faturação", // Changed 'Cobrança' to 'Faturação'
        nextBillingDate: "Próxima Data de Faturação", // Changed 'Cobrança' to 'Faturação'
        subscriptionStarted: "Subscrição Iniciada",
        timesBilled: "Vezes Faturado",
        serviceName: "Nome do Serviço",
        termsAndConditions: "Termos e Condições",
        viewTermsAndConditions: "Ver Termos e Condições",
        pricingInformation: "Informações de Preços",
        errorFetchingUserData: "Erro ao obter dados do utilizador", // Changed 'buscar dados do usuário' to 'obter dados do utilizador'
        errorUpdatingUser: "Erro ao atualizar dados do utilizador", // Changed 'atualizar dados do usuário' to 'atualizar dados do utilizador'
        noSavedRecipes: "Ainda não há receitas guardadas", // Changed 'salvas' to 'guardadas'
        minutes: "minutos",
        servings: "porções",
        confirmUnsubscribe: "Confirmar cancelamento",
        confirmUnsubscribeMessage: "Tem a certeza de que deseja cancelar a subscrição?", // Changed 'assinatura' to 'subscrição' and 'Tem certeza' to 'Tem a certeza'
        confirmPasswordChange: "Confirmar alteração de palavra-passe",
        confirmPasswordChangeMessage: "Tem a certeza de que deseja alterar a sua palavra-passe?",
        yes: "Sim",
        cancel: "Cancelar",
        cancellationComplete: "Cancelamento Concluído",
        cancellationSuccessMessage: "A sua subscrição foi cancelada com sucesso! Não receberá mais cobranças. Para mais informações: 707450201",
        processingCancellation: "A processar o cancelamento...",
        wantToCancelService: "Deseja cancelar o serviço?",
        clickHereToCancel: "Pode fazê-lo clicando aqui:",
        cancelSubscription: "Cancelar subscrição",
        continueSubscription: "Continuar subscrição",
        contactUsVia: "Ou pode contactar-nos através de:",
        customerSupportLine: "Linha de Apoio ao Cliente",
        cancellationNoExtraCost: "O cancelamento do serviço é feito sem qualquer custo adicional para o utilizador.",
        termsAndConditions: "Termos e Condições",
        sessionIdNotFound: "Erro: ID da sessão não encontrado. Por favor, faça login novamente.",
        cancellationError: "Erro ao cancelar a subscrição. Por favor, tente novamente ou entre em contato com o suporte ao cliente.",
        back: "Voltar",
        viewAll: "Ver todos",
        likes: "gostos",
        continentEurope: 'Europa',
        continentMiddleEast: 'Médio Oriente',
        continentAsia: 'Ásia',
        continentAfrica: 'África',
        continentNorthAmerica: 'América do Norte',
        continentSouthAmerica: 'América do Sul',
        continentOceania: 'Oceânia',
        backToContinents: 'Voltar aos Continentes',
        downloadRecipe: 'Descarregar receita',
        pdfDownloaded: 'PDF descarregado com sucesso!',
        errorDownloadingPdf: 'Erro ao descarregar o PDF.',
        random: 'Aleatório',
        mostCommented: 'Mais Comentadas',
        mostLiked: 'Mais Curtidas',
        newest: 'Mais Recentes',
        quickest: 'Mais Rápidas',
        lowestCalories: 'Menos Calorias',
        audioFetched: 'O áudio está pronto para reprodução.',
        errorFetchingAudio: 'Erro ao obter o áudio. Tente novamente.',
        loadingAudio: 'A carregar áudio...',
        winePairings: 'Sugestões de Vinhos',
        errorWinePairing: 'Não foi possível obter sugestões de vinhos. Tente novamente.',
        sharedOn: 'Receita partilhada em',
        copiedToClipboard: 'Receita copiada para a área de transferência!',
        shareError: 'Não foi possível partilhar a receita.',
        photoTip: 'Para melhores resultados, carregue uma foto clara dos seus ingredientes ou de um prato.',
        noFoodDetected: 'Não foram detetados alimentos ou ingredientes na sua foto. Tente novamente com uma foto de ingredientes ou de um prato.',
        errorCompressingImage: 'Erro ao comprimir a imagem. Tente uma foto mais pequena.',
        askingAboutCookbook: 'Perguntas sobre o livro de receitas:',
        askingAboutRecipe: 'Perguntas sobre a receita:',
        submit: 'Enviar',
        noComments: 'Ainda sem comentários. Seja o primeiro a comentar!',
        comparePrices: 'Comparar Preços nos Supermercados',
        comparingPrices: 'A comparar preços...',
        pricesFor: 'Preços para',
        priceComparison: 'Comparação de Preços',
        estimate: 'estimativa',
        potentialSavings: 'Poupança potencial',
        cheapestAt: 'Mais barato em',
        cheapest: 'Mais barato',
        priceDisclaimer: 'Os preços são estimativas de IA e podem diferir dos preços reais nas lojas.',
        budget: 'Económico',
        midRange: 'Médio',
        premium: 'Premium',
        clearListConfirmTitle: 'Limpar lista de compras?',
        clearListConfirmText: 'Isto irá remover todos os itens da sua lista. Esta ação não pode ser desfeita.',
        allergyPreferences: 'Preferências de Alergia',
        allergyPreferencesDescription: 'Selecione os seus alérgenos abaixo. Receitas contendo estes serão ocultadas das recomendações.',
        savePreferences: 'Guardar Preferências',
        saving: 'A guardar...',
        preferencesSaved: 'Preferências de alergia guardadas!',
        errorSavingPreferences: 'Erro ao guardar preferências',
    },
    nederlands: {
        and: "en",
        validateWeight: "Het gewicht moet tussen",
        validateHeight: "De lengte moet tussen",
        nutritionGoals: "Voedingsdoelen",
        safetyAndDisclaimer: "Veiligheid & Disclaimer",
        safetyAndDisclaimerText: "De doelstellingen zijn schattingen en vervangen geen professioneel medisch, voedings- of dieetadvies. Raadpleeg bij gezondheidsproblemen een zorgverlener.",
        male: "Man",
        female: "Vrouw",
        other: "Overig",
        allowed: "Toegestaan",
        pleaseEnterAWeight: "Voer een gewicht in",
        pleaseEnterAHeight: "Voer een lengte in",
        calories: "Calorieën",
        protein: "Eiwit",
        fat: "Vet",
        carbs: "Koolhydraten",
        sex: "Geslacht",
        age: "Leeftijd",
        weight: "Gewicht",
        height: "Lengte",
        activity: "Activiteit",
        goal: "Doel",
        computeGoals: "Doelen berekenen",
        light: "Licht",
        moderate: "Gemiddeld",
        veryActive: "Zeer actief",
        extraActive: "Extreem actief",
        lose: "Verliezen",
        maintain: "Behouden",
        gain: "Aankomen",
        dailyTargets: "Dagelijkse doelen",
        unableToFetchPrices: 'Prijzen voor valuta kunnen niet worden opgehaald',
        loadingPrices: 'Prijzen laden',
        currency: 'Munteenheid',
        latestMarketPrices: 'Laatste marktprijzen',
        countryCurrency: 'EUR',
        startScan: 'Scan starten',
        scanAnother: 'Scan een andere',
        scanning: 'Scannen',
        vitaminD: 'Vitamine D',
        salt: 'Zout',
        protein: 'Eiwit',
        fiber: 'Vezel',
        addedSugars: 'Toegevoegde suikers',
        sugars: 'Suikers',
        saturatedFat: 'Verzadigd vet',
        fat: 'Vet',
        energy: 'Energie',
        amount: 'Hoeveelheid',
        productNutrient: 'Voedingsstof',
        productNutritionalValuesPer100g: 'Voedingswaarde (per 100 g)',
        productIngredients: 'Ingrediënten',
        productNutriScore: 'Nutri-Score',
        productBrand: 'Merk',
        scanYourProductBarcode: 'Scan de streepjescode van uw product!',
        productLookupFailed: 'Productopzoeken mislukt',
        productNotFoundError: 'Product niet gevonden',
        cameraFailedStartError: 'Camera kan niet starten',
        profile: 'Profiel',
        basicInformation: 'Basisinformatie',
        savedRecipes: 'Opgeslagen Recepten',
        noSavedRecipes: 'Je hebt geen opgeslagen recepten.',
        userData: 'Gebruikersgegevens',
        recipeRemoved: 'Recept {recipeName} is verwijderd uit je favorieten.',
        username: 'Gebruikersnaam',
        mobileNumber: 'Mobiel Nummer',
        password: 'Wachtwoord',
        saveChanges: 'Wijzigingen Opslaan',
        changesSaved: 'Je wijzigingen zijn opgeslagen.',
        subscriptionInformation: 'Abonnementsinformatie',
        lastBillingDate: 'Laatste Factuurdatum',
        nextBillingDate: 'Volgende Factuurdatum',
        subscriptionStarted: 'Abonnement Gestart',
        timesBilled: 'Keren Gefactureerd',
        serviceName: 'Servicenaam',
        termsAndConditions: 'Algemene Voorwaarden',
        viewTermsAndConditions: 'Bekijk Algemene Voorwaarden',
        pricingInformation: 'Prijsinformatie',
        unsubscribe: 'Afmelden',
        unsubscribed: 'Je bent afgemeld.',
        selectLanguage: "Selecteer uw taal",
        whatToDo: "Wat wil je doen?",
        takePhoto: "Foto nemen",
        uploadPhoto: "Foto uploaden",
        pleaseAddPhotoFirst: "Voeg eerst een foto toe of maak een foto",
        uploading: "Jouw persoonlijke recepten maken...",
        loadingTime: "Dit duurt tot 1 minuut..",
        analyzing: "AI is uw foto aan het analyseren...",
        aiAnalysisResult: "AI Analyse Resultaat:",
        uploadError: "Er is een fout opgetreden bij het uploaden van de afbeelding.",
        processingError: "Er is een fout opgetreden bij het verwerken van de afbeelding.",
        numberOfPeople: 'Aantal personen',
        timeOfDay: 'Dagdeel',
        selectTimeOfDay: 'Selecteer dagdeel',
        breakfast: 'Ontbijt',
        morningSnack: 'Tussendoortje in de ochtend',
        lunch: 'Lunch',
        afternoonSnack: 'Tussendoortje in de middag',
        dinner: 'Avondeten',
        dessert: 'Toetje',
        lateNightSnack: 'Late avond snack',
        // Voeg meer keukens toe indien nodig
        preferredCuisine: 'Voorkeurskeuken',
        selectCuisine: 'Selecteer keuken',
        italian: 'Italiaans',
        chinese: 'Chinees',
        indian: 'Indiaas',
        mexican: 'Mexicaans',
        french: 'Frans',
        thai: 'Thais',
        japanese: 'Japans',
        mediterranean: 'Mediterraans',
        spanish: 'Spaans',
        greek: 'Grieks',
        vietnamese: 'Vietnamees',
        american: 'Amerikaans',
        turkish: 'Turks',
        korean: 'Koreaans',
        moroccan: 'Marokkaans',
        persian: 'Perzisch',
        // Voeg meer keukens toe indien nodig
        allergies: 'Allergieën',
        selectAllergies: 'Selecteer allergieën',
        gluten: 'Gluten',
        nuts: 'Noten',
        lactose: 'Lactose',
        soy: 'Soja',
        shellfish: 'Schaaldieren',
        fish: 'Vis',
        eggs: 'Eieren',
        peanuts: 'Pinda\'s',
        sesame: 'Sesam',
        sulphites: 'Sulfieten',
        mustard: 'Mosterd',
        celery: 'Selderij',
        lupin: 'Lupine',
        molluscs: 'Weekdieren',
        // Voeg meer allergieën toe indien nodig
        // Nieuwe vertalingen
        cookingTime: 'Kooktijd',
        cookingTip: "Kooktip:",
        minutes: 'minuten',
        caloriesPerServing: 'Calorieën per portie',
        servings: 'porties',
        allergens: 'Allergenen',
        ingredients: 'Ingrediënten',
        instructions: 'Instructies',
        askQuestion: 'Stel een vraag',
        recipeLibrary: 'Recepten Bibliotheek',
        loadMore: 'Meer laden',
        loadNewRandomRecipes: 'Laad meer recepten',
        loadingRecipes: 'Laden van {count} recepten...',
        viewRecipe: 'Bekijk recept',
        noResultsFound: 'Geen resultaten gevonden',
        search: 'Afbeelding Uploaden',
        decrease: 'Min',
        increase: 'Plus',
        uploading: "Bezig met uploaden",
        elapsedTime: "Verstreken tijd",
        seconds: "seconden",
        cameraNotSupported: 'Camera niet ondersteund op dit apparaat',
        nutritions: "Voedingswaarden",
        calories: "Calorieën",
        protein: "Eiwitten",
        carbs: "Koolhydraten",
        fat: "Vetten",
        fiber: "Vezels",
        sugar: "Suiker",
        sodium: "Natrium",
        vitamina: "Vitamine A",
        vitaminc: "Vitamine C",
        calcium: "Calcium",
        iron: "IJzer",
        recipeDetails: "Recept Details",
        loadMore: "Meer recepten laden",
        recipeAlreadySaved: 'Recept is al opgeslagen.',
        recipeSaved: 'Recept is succesvol opgeslagen.',
        errorSavingRecipe: 'Fout bij het opslaan van het recept. Probeer het opnieuw.',
        recipeShared: "Recept gedeeld via {platform}!",
        defaultSaveMessage: "Actie succesvol uitgevoerd!",
        share: "Delen",
        favorite: "Favoriet",
        close: "Sluiten",
        whatsapp: "WhatsApp",
        facebook: "Facebook",
        twitter: "Twitter",
        email: "E-mail",
        loading: 'Nieuwe recepten ophalen...',
        // ... minigame ...
        tetrisTitle: "Speel Tetris terwijl je wacht!",
        score: "Score",
        highScore: "Hoogste Score",
        gameOver: "Spel Voorbij",
        playAgain: "Speel Opnieuw",
        left: "Links",
        right: "Rechts",
        down: "Omlaag",
        rotate: "Draaien",
        startTetris: "Speel een potje Tetris",
        stopOrContinueTetris: "Recepten zijn geladen. Wil je stoppen met Tetris en de recepten bekijken?",
        continueTetris: "Doorgaan met Tetris",
        playTetris: "Speel Tetris",
        viewRecipes: "Bekijk recepten",
        recipesLoaded: "SousChaif is klaar met jouw recepten!",
        capturePhoto: "Neem foto",
        closeCamera: "Sluit camera",
        pictureIngredients: "Fotografeer Ingrediënten",
        previewImage: "Afbeelding goedkeuren",
        retake: "Opnieuw maken",
        approve: "Versturen",
        waitingNotice: "Speel een spelletje terwijl je wacht.",
        profile: "Profiel",
        basicInformation: "Basisgegevens",
        name: "Naam",
        email: "E-mail",
        savedRecipes: "Opgeslagen Recepten",
        noSavedRecipes: "Je hebt nog geen recepten opgeslagen.",
        recipeRemoved: "Het recept {recipeName} is verwijderd uit je favorieten.",
        newSearchQuestion: "Nieuwe recepten zoeken?",
        newSearchPrompt: "Wil je nieuwe recepten zoeken of je vorige resultaten bekijken?",
        searchNewRecipes: "Zoek nieuwe recepten",
        seeOldRecipes: "bekijken",
        chatBotIntro: "Welkom, ik ben SousChaif. Hoe kan ik je helpen vandaag?",
        chatWithSousChaif: "Praat met SousChaif",
        typeYourMessage: "Typ je bericht...",
        recipeLoaded: "Recept geladen",
        askAboutRecipe: "Vraag over recept",
        errorFetchingData: "Er was een fout bij het ophalen van de gegevens.",
        whatQuestionWouldYouLikeToAsk: "Welke vraag wil je stellen?",
        welcomeBack: "Welkom terug",
        needHelpWithRecipe: "Hulp nodig met koken?",
        viewRecipesHome: "Stel je vraag",
        popularIngredients: "Populaire Ingrediënten",
        popularCookbooks: "Populaire Kookboeken",
        browseByLetter: "Bladeren op Letter",
        videoRecipes: "Video Recepten",
        randomRecipes: "Willekeurige Recepten",
        recipesByLetter: "Recepten op Letter",
        noRecipesFound: "Geen recepten gevonden",
        watchVideo: "Bekijk Video",
        loadMore: "Laad Meer",
        categories: "Categorieën",
        ingredients: "Ingrediënten",
        areas: "Gebieden",
        filterBy: "Filter op",
        all: "Alle",
        // Categories
        beef: "Rundvlees",
        breakfast: "Ontbijt",
        chicken: "Kip",
        dessert: "Dessert",
        goat: "Geit",
        lamb: "Lam",
        miscellaneous: "Diversen",
        pasta: "Pasta",
        pork: "Varkensvlees",
        seafood: "Zeevruchten",
        side: "Bijgerecht",
        starter: "Voorgerecht",
        vegan: "Vegaans",
        vegetarian: "Vegetarisch",
        // Ingredients
        avocado: "Avocado",
        bacon: "Spek",
        bakingPowder: "Bakpoeder",
        balsamicVinegar: "Balsamico Azijn",
        basil: "Basilicum",
        basilLeaves: "Basilicum Bladeren",
        basmatiRice: "Basmati Rijst",
        bayLeaf: "Laurierblad",
        bayLeaves: "Laurierbladeren",
        beefBrisket: "Runderborst",
        beefFillet: "Runderfilet",
        beefGravy: "Rundvleesjus",
        beefStock: "Rundvleesbouillon",
        bicarbonateOfSoda: "Natriumbicarbonaat",
        biryaniMasala: "Biryani Kruiden",
        blackPepper: "Zwarte Peper",
        blackTreacle: "Zwarte Stroop",
        // Additional ingredients
        appleCiderVinegar: "Appelcider Azijn",
        asparagus: "Asperges",
        aubergine: "Aubergine",
        babyPlumTomatoes: "Cherry Tomaten",
        // Areas
        american: "Amerikaans",
        british: "Brits",
        canadian: "Canadees",
        chinese: "Chinees",
        croatian: "Kroatisch",
        dutch: "Nederlands",
        egyptian: "Egyptisch",
        filipino: "Filipijns",
        french: "Frans",
        greek: "Grieks",
        indian: "Indiaas",
        irish: "Iers",
        italian: "Italiaans",
        jamaican: "Jamaicaans",
        japanese: "Japans",
        kenyan: "Keniaans",
        malaysian: "Maleis",
        mexican: "Mexicaans",
        moroccan: "Marokkaans",
        polish: "Pools",
        portuguese: "Portugees",
        russian: "Russisch",
        spanish: "Spaans",
        syrian: "Syrisch",
        thai: "Thais",
        tunisian: "Tunesisch",
        turkish: "Turks",
        ukrainian: "Oekraïens",
        uruguayan: "Uruguayaans",
        vietnamese: "Vietnamees",
        recipes: "recepten",
        Chicken: "Kip",
        Beef: "Rundvlees",
        Pork: "Varkensvlees",
        Salmon: "Zalm",
        Shrimp: "Garnalen",
        Eggs: "Eieren",
        Tofu: "Tofu",
        Tuna: "Tonijn",
        Potato: "Aardappel",
        Rice: "Rijst",
        comments: "Reacties",
        addComment: "Laat een reactie achter",
        noComments: "Nog geen reacties. Wees de eerste!",
        submit: "Verzenden",
        commentSubmitted: "Reactie geplaatst!",
        errorSubmittingComment: "Fout bij het plaatsen van de reactie.",
        backToWaiting: 'terug',
        shoppingList: "Boodschappenlijst",
        addItem: "Voeg item toe",
        add: "Toevoegen",
        clearList: "Lijst wissen",
        addToShoppingList: "Voeg toe aan boodschappenlijst",
        addedToShoppingList: "Ingrediënten toegevoegd aan boodschappenlijst!",
        quantity: "Hoeveelheid",
        diet: "Dieet",
        selectDiet: "Selecteer een dieet",
        keto: "Keto",
        lowCarb: "Koolhydraatarm",
        vegetarian: "Vegetarisch",
        vegan: "Veganistisch",
        paleo: "Paleo",
        mediterraneanDiet: "Mediterraans",
        dairyFree: "Zuivelvrij",
        glutenFree: "Glutenvrij",
        lowFat: "Vetarm",
        highProtein: "Eiwitrijk",
        selectIngredients: "Selecteer ingrediënten",
        chicken: "Kip",
        beef: "Rundvlees",
        pork: "Varkensvlees",
        salmon: "Zalm",
        shrimp: "Garnalen",
        eggs: "Eieren",
        tofu: "Tofu",
        tuna: "Tonijn",
        potato: "Aardappel",
        rice: "Rijst",
        savedRecipes: "Opgeslagen Recepten",
        filters: "Filters",
        resetFilters: "Filters Resetten",
        tryAgain: "Probeer Opnieuw",
        searchRecipes: "Zoek recepten...",
        ingredients: "Ingrediënten",
        allergens: "Allergenen",
        cookingTime: "Bereidingstijd",
        addIngredient: "Voeg ingredient toe",
        upTo: "Tot",
        errorFetchingRecipes: "Er is een fout opgetreden bij het ophalen van de recepten",
        // Database Recipes (Library 1) filters
        recipeLibraryTitle: "Recepten Bibliotheek",
        recipesCount: "{count} recepten",
        searchPlaceholder: "Zoek recepten...",
        filterByLetter: "Filter op Letter",
        allLetters: "Alle",
        maxCalories: "Max Calorieën",
        caloriesUnit: "kcal",
        maxCookingTime: "Max Tijd",
        minutesUnit: "min",
        servings: "Porties",
        minServings: "Min Porties",
        maxServings: "Max Porties",
        selectAllergens: "Selecteer Allergenen",
        typeToSearch: "Typ om te zoeken...",
        selectNutritions: "Selecteer Voedingsstoffen",
        selectIngredients: "Selecteer Ingrediënten",
        clearFilters: "Filters Wissen",
        noRecipesMatch: "Geen recepten komen overeen met de filters",
        dairy: "Zuivel",
        soy: "Soja",
        shellfish: "Schaaldieren",
        fish: "Vis",
        showFilters: "Toon Filters",
        hideFilters: "Verberg Filters",
        viewAllRecipes: "Bekijk Alle Recepten",
        budgetFriendlyCooking: "Budgetvriendelijk Koken",
        budgetFriendlyDescription: "Maak heerlijke, budgetvriendelijke maaltijden met 'sous-chaif' met behulp van gepersonaliseerde recepten op basis van uw ingrediënten en voorkeuren.",
        customRecipeSuggestions: "Aangepaste Receptsuggesties",
        customRecipeDescription: "Deel uw ingrediënten, voorkeuren en voedingsdoelen, en 'sous-chaif' biedt gepersonaliseerde recepten speciaal voor u.",
        secureAndEasy: "Veilig en Eenvoudig",
        secureAndEasyDescription: "Uw gegevens zijn veilig bij ons. Geniet van eenvoudige toegang tot gepersonaliseerde recepten en kooktips.",
        featureWelcomeTitle: "Welkom bij Souschaif!",
        featureWelcomeSubtitle: "Upload een foto van je ingrediënten of koelkast en krijg meteen recepten. Je kunt dit venster altijd snel sluiten.",
        featureWelcomeGotIt: "Begrepen",
        featureWelcomeMainBadge: "Belangrijkste",
        featureWelcomePhotoTitle: "Foto uploaden van ingrediënten of koelkast",
        featureWelcomePhotoDescription: "Maak of upload een foto en ontvang direct recepten op basis van wat je in huis hebt.",
        featureWelcomeChatDescription: "Stel je kookvragen aan onze AI-chef en krijg direct persoonlijk advies.",
        featureWelcomeLibraryDescription: "Blader door honderden recepten en filter op ingrediënten, allergenen en bereidingstijd.",
        featureWelcomeShoppingDescription: "Maak automatisch een boodschappenlijst op basis van je recepten.",
        smartShoppingList: "Slimme boodschappenlijst",
        smartShoppingListDescription: "Genereer boodschappenlijsten op basis van je favoriete recepten.",
        usernameOrMobile: "Gebruikersnaam of Mobiel Nummer",
        rememberMe: "Onthoud mij",
        logIn: "Inloggen",
        signingIn: "Bezig met inloggen...",
        noAccount: "Nog geen account?",
        signUp: "Registreer",
        next: "Volgende",
        skip: "Overslaan",
        notSubscribed: 'Je bent niet geabonneerd op deze dienst',
        loginError: 'Kan je abonnement niet verifiëren. Probeer het later opnieuw',
        signup: "Registreren",
        signupIntro: "Maak een account aan om te beginnen",
        username: "Gebruikersnaam",
        password: "Wachtwoord",
        confirmPassword: "Bevestig wachtwoord",
        email: "E-mailadres",
        mobileNumber: "Mobiel nummer",
        signupButton: "Account aanmaken",
        signupError: "Fout tijdens registratie",
        alreadySubscribed: "Al ingeschreven?",
        clickHere: "Klik hier",
        signupSuccess: "Account succesvol aangemaakt",
        passwordRequirements: "Wachtwoordvereisten",
        minLength: "Minimaal 8 tekens",
        requireUppercase: "Minimaal één hoofdletter",
        requireLowercase: "Minimaal één kleine letter",
        requireNumber: "Minimaal één cijfer",
        requireSpecial: "Minimaal één speciaal teken",
        passwordsMatch: "Wachtwoorden komen overeen",
        passwordRequirementsNotMet: "Voldoe aan alle wachtwoordvereisten",
        profile: "Profiel",
        savedRecipes: "Opgeslagen Recepten",
        userData: "Gebruikersgegevens",
        basicInformation: "Basisinformatie",
        username: "Gebruikersnaam",
        email: "E-mail",
        mobileNumber: "Mobiel Nummer",
        password: "Wachtwoord",
        newPassword: "Nieuw Wachtwoord",
        leaveEmptyToKeep: "Laat leeg om huidige wachtwoord te behouden",
        saveChanges: "Wijzigingen Opslaan",
        changesSaved: "Wijzigingen succesvol opgeslagen",
        subscriptionInformation: "Abonnement Informatie",
        sessionId: "Sessie ID",
        createdAt: "Account Aangemaakt",
        lastBillingDate: "Laatste Factuurdatum",
        nextBillingDate: "Volgende Factuurdatum",
        subscriptionStarted: "Abonnement Gestart",
        timesBilled: "Keren Gefactureerd",
        serviceName: "Servicenaam",
        termsAndConditions: "Algemene Voorwaarden",
        viewTermsAndConditions: "Bekijk Algemene Voorwaarden",
        pricingInformation: "Prijsinformatie",
        errorFetchingUserData: "Fout bij ophalen gebruikersgegevens",
        errorUpdatingUser: "Fout bij bijwerken gebruikersgegevens",
        noSavedRecipes: "Nog geen recepten opgeslagen",
        minutes: "minuten",
        servings: "porties",
        confirmUnsubscribe: "Bevestig afmelding",
        confirmUnsubscribeMessage: "Weet je zeker dat je wilt afmelden?",
        confirmPasswordChange: "Bevestig wachtwoordwijziging",
        confirmPasswordChangeMessage: "Weet je zeker dat je je wachtwoord wilt wijzigen?",
        yes: "Ja",
        cancel: "Annuleren",
        continentEurope: 'Europa',
        continentMiddleEast: 'Midden-Oosten',
        continentAsia: 'Azië',
        continentAfrica: 'Afrika',
        continentNorthAmerica: 'Noord-Amerika',
        continentSouthAmerica: 'Zuid-Amerika',
        continentOceania: 'Oceanië',
        backToContinents: 'Terug naar Continenten',
        downloadRecipe: 'Recept downloaden',
        pdfDownloaded: 'PDF succesvol gedownload!',
        errorDownloadingPdf: 'Fout bij het downloaden van de PDF.',
        random: 'Willekeurig',
        mostCommented: 'Meest Becommentarieerd',
        mostLiked: 'Meest Geliked',
        newest: 'Nieuwste',
        quickest: 'Snelste',
        lowestCalories: 'Minste Calorieën',
        audioFetched: 'Audio is klaar om af te spelen.',
        errorFetchingAudio: 'Fout bij het ophalen van audio. Probeer het opnieuw.',
        loadingAudio: 'Audio laden...',
        winePairings: 'Wijnsuggesties',
        errorWinePairing: 'Kon geen wijnsuggesties ophalen. Probeer het opnieuw.',
        sharedOn: 'Recept gedeeld via',
        copiedToClipboard: 'Recept gekopieerd naar klembord!',
        shareError: 'Kon recept niet delen.',
        photoTip: 'Upload voor het beste resultaat een duidelijke foto van je ingrediënten of een gerecht.',
        noFoodDetected: 'Geen voedsel of ingrediënten gevonden op je foto. Probeer het opnieuw met een foto van ingrediënten of een gerecht.',
        errorCompressingImage: 'Fout bij het comprimeren van de afbeelding. Probeer een kleinere foto.',
        askingAboutCookbook: 'Vragen over kookboek:',
        askingAboutRecipe: 'Vragen over recept:',
        submit: 'Versturen',
        noComments: 'Nog geen reacties. Wees de eerste die reageert!',
        comparePrices: 'Vergelijk Supermarktprijzen',
        comparingPrices: 'Prijzen vergelijken...',
        pricesFor: 'Prijzen voor',
        priceComparison: 'Prijsvergelijking',
        estimate: 'schatting',
        potentialSavings: 'Mogelijke besparing',
        cheapestAt: 'Goedkoopst bij',
        cheapest: 'Goedkoopst',
        priceDisclaimer: 'Prijzen zijn AI-schattingen en kunnen afwijken van de werkelijke winkelprijzen.',
        budget: 'Budget',
        midRange: 'Middensegment',
        premium: 'Premium',
        clearListConfirmTitle: 'Boodschappenlijst wissen?',
        clearListConfirmText: 'Hiermee worden alle items van je lijst verwijderd. Dit kan niet ongedaan worden gemaakt.',
        allergyPreferences: 'Allergievoorkeuren',
        allergyPreferencesDescription: 'Selecteer je allergenen hieronder. Recepten met deze ingrediënten worden verborgen in aanbevelingen.',
        savePreferences: 'Voorkeuren opslaan',
        saving: 'Opslaan...',
        preferencesSaved: 'Allergievoorkeuren opgeslagen!',
        errorSavingPreferences: 'Fout bij opslaan voorkeuren',
    },
    english: {
        and: "and",
        validateWeight: "Weight must be between",
        validateHeight: "Height must be between",
        nutritionGoals: "Nutrition goals",
        safetyAndDisclaimer: "Safety & Disclaimer",
        safetyAndDisclaimerText: "The targets are estimates and do not replace professional medical, nutrition, or dietary advice. If you have health concerns, consult a healthcare professional.",
        male: "Male",
        female: "Female",
        other: "Other",
        allowed: "Allowed",
        pleaseEnterAWeight: "Please enter a weight",
        pleaseEnterAHeight: "Please enter a height",
        calories: "Calories",
        protein: "Protein",
        fat: "Fat",
        carbs: "Carbs",
        sex: "Sex",
        age: "Age",
        weight: "Weight",
        height: "Height",
        activity: "Activity",
        goal: "Goal",
        computeGoals: "Compute goals",
        light: "Light",
        moderate: "Moderate",
        veryActive: "Very active",
        extraActive: "Extra active",
        lose: "Lose",
        maintain: "Maintain",
        gain: "Gain",
        dailyTargets: "Daily targets",
        unableToFetchPrices: 'Unable to fetch prices for currency',
        loadingPrices: 'Loading Prices',
        currency: 'Currency',
        latestMarketPrices: 'Latest Market Prices',
        startScan: 'Start Scan',
        scanAnother: 'Scan Another',
        scanning: 'Scanning',
        vitaminD: 'Vitamin D',
        salt: 'Salt',
        protein: 'Protein',
        fiber: 'Fiber',
        addedSugars: 'Added Sugars',
        sugars: 'Sugars',
        saturatedFat: 'Saturated Fat',
        fat: 'Fat',
        energy: 'Energy',
        amount: 'Amount',
        productNutrient: 'Nutrient',
        productNutritionalValuesPer100g: 'Nutritional Value (per 100g)',
        productIngredients: 'Ingredients',
        productNutriScore: 'Nutri-Score',
        productBrand: 'Brand',
        scanYourProductBarcode: 'Scan Your Product Barcode!',
        productLookupFailed: 'Product Lookup failed',
        productNotFoundError: 'Product not found',
        cameraFailedStartError: 'Camera failed to start',
        profile: 'Profile',
        basicInformation: 'Basic Information',
        savedRecipes: 'Saved Recipes',
        noSavedRecipes: 'You have no saved recipes.',
        userData: 'User Data',
        recipeRemoved: 'Recipe {recipeName} has been removed from your favorites.',
        username: 'Username',
        mobileNumber: 'Mobile Number',
        password: 'Password',
        saveChanges: 'Save Changes',
        changesSaved: 'Your changes have been saved.',
        subscriptionInformation: 'Subscription Information',
        lastBillingDate: 'Last Billing Date',
        nextBillingDate: 'Next Billing Date',
        subscriptionStarted: 'Subscription Started',
        timesBilled: 'Times Billed',
        serviceName: 'Service Name',
        termsAndConditions: 'Terms & Conditions',
        viewTermsAndConditions: 'View Terms & Conditions',
        pricingInformation: 'Pricing Information',
        unsubscribe: 'Unsubscribe',
        unsubscribed: 'You have been unsubscribed.',
        selectLanguage: 'Select your language',
        whatToDo: 'What do you want to do?',
        takePhoto: 'Take Photo',
        uploadPhoto: 'Upload Photo',
        pleaseAddPhotoFirst: 'Please add a photo first or take a photo',
        uploading: 'Creating your personalized recipes...',
        loadingTime: 'This may take up to 1 minute...',
        analyzing: 'AI is analyzing your photo...',
        aiAnalysisResult: 'AI Analysis Result:',
        uploadError: 'An error occurred while uploading the image.',
        processingError: 'An error occurred while processing the image.',
        numberOfPeople: 'Number of People',
        timeOfDay: 'Time of Day',
        selectTimeOfDay: 'Select Time of Day',
        breakfast: 'Breakfast',
        morningSnack: 'Morning Snack',
        lunch: 'Lunch',
        afternoonSnack: 'Afternoon Snack',
        dinner: 'Dinner',
        dessert: 'Dessert',
        lateNightSnack: 'Late Night Snack',
        preferredCuisine: 'Preferred Cuisine',
        selectCuisine: 'Select Cuisine',
        italian: 'Italian',
        chinese: 'Chinese',
        indian: 'Indian',
        mexican: 'Mexican',
        french: 'French',
        thai: 'Thai',
        japanese: 'Japanese',
        mediterranean: 'Mediterranean',
        spanish: 'Spanish',
        greek: 'Greek',
        vietnamese: 'Vietnamese',
        american: 'American',
        turkish: 'Turkish',
        korean: 'Korean',
        moroccan: 'Moroccan',
        persian: 'Persian',
        allergies: 'Allergies',
        selectAllergies: 'Select Allergies',
        gluten: 'Gluten',
        nuts: 'Nuts',
        lactose: 'Lactose',
        soy: 'Soy',
        shellfish: 'Shellfish',
        fish: 'Fish',
        eggs: 'Eggs',
        peanuts: 'Peanuts',
        sesame: 'Sesame',
        sulphites: 'Sulphites',
        mustard: 'Mustard',
        celery: 'Celery',
        lupin: 'Lupin',
        molluscs: 'Molluscs',
        cookingTime: 'Cooking Time',
        cookingTip: 'Cooking Tip:',
        minutes: 'minutes',
        caloriesPerServing: 'Calories per Serving',
        servings: 'servings',
        allergens: 'Allergens',
        ingredients: 'Ingredients',
        instructions: 'Instructions',
        noResultsFound: 'No results found',
        search: 'Upload Image',
        decrease: 'Minus',
        increase: 'Plus',
        uploading: 'Uploading',
        elapsedTime: 'Elapsed Time',
        seconds: 'seconds',
        cameraNotSupported: 'Camera not supported on this device',
        nutritions: 'Nutritional Values',
        calories: 'Calories',
        protein: 'Protein',
        carbs: 'Carbohydrates',
        fat: 'Fat',
        fiber: 'Fiber',
        sugar: 'Sugar',
        sodium: 'Sodium',
        vitamina: 'Vitamin A',
        vitaminc: 'Vitamin C',
        calcium: 'Calcium',
        iron: 'Iron',
        recipeDetails: 'Recipe Details',
        loadMore: 'Load more recipes',
        recipeAlreadySaved: 'Recipe is already saved.',
        recipeSaved: 'Recipe has been successfully saved.',
        errorSavingRecipe: 'Error saving the recipe. Please try again.',
        recipeShared: 'Recipe shared via {platform}!',
        defaultSaveMessage: 'Action completed successfully!',
        pleaseLogin: 'Please login to continue',
        noIngredientsFound: 'No ingredients found to add to shopping list',
        noValidIngredients: 'No valid ingredients found to add',
        addedToShoppingList: 'Added',
        toShoppingList: 'to shopping list',
        errorAddingToShoppingList: 'Error adding to shopping list',
        noImageAvailable: 'No image available',
        instructions: 'Instructions',
        askQuestion: 'Ask Question',
        recipeLibrary: 'Recipe Library',
        loadMore: 'Load More',
        loadNewRandomRecipes: 'Load More Recipes',
        loadingRecipes: 'Loading {count} recipes...',
        viewRecipe: 'View Recipe',
        share: 'Share',
        favorite: 'Favorite',
        close: 'Close',
        whatsapp: 'WhatsApp',
        facebook: 'Facebook',
        twitter: 'Twitter',
        email: 'Email',
        loading: 'Fetching new recipes...',
        // ... minigame ...
        tetrisTitle: 'Play Tetris while you wait!',
        score: 'Score',
        highScore: 'High Score',
        gameOver: 'Game Over',
        playAgain: 'Play Again',
        left: 'Left',
        right: 'Right',
        down: 'Down',
        rotate: 'Rotate',
        startTetris: 'Play a game of Tetris',
        stopOrContinueTetris:
            'Recipes are loaded. Do you want to stop Tetris and view the recipes?',
        continueTetris: 'Continue Tetris',
        playTetris: 'Play Tetris',
        viewRecipes: 'View Recipes',
        recipesLoaded: 'SousChaif is ready with your recipes!',
        capturePhoto: 'Take Photo',
        closeCamera: 'Close Camera',
        pictureIngredients: 'Photograph Ingredients',
        previewImage: 'Approve Image',
        retake: 'Retake',
        approve: 'Send',
        waitingNotice: 'Play a game while you wait.',
        profile: 'Profile',
        basicInformation: 'Basic Information',
        name: 'Name',
        email: 'Email',
        savedRecipes: 'Saved Recipes',
        noSavedRecipes: 'You have no saved recipes yet.',
        recipeRemoved:
            'The recipe {recipeName} has been removed from your favorites.',
        newSearchQuestion: 'Search for new recipes?',
        newSearchPrompt:
            'Would you like to search for new recipes or view your previous results?',
        searchNewRecipes: 'Search new recipes',
        seeOldRecipes: 'View',
        chatBotIntro: 'Welcome, I am SousChaif. How can I assist you today?',
        chatWithSousChaif: 'Chat with SousChaif',
        typeYourMessage: 'Type your message...',
        recipeLoaded: 'Recipe loaded',
        askAboutRecipe: 'Ask about recipe',
        errorFetchingData: 'There was an error fetching the data.',
        whatQuestionWouldYouLikeToAsk: 'What question would you like to ask?',
        welcomeBack: 'Welcome back',
        needHelpWithRecipe: 'Need help with cooking?',
        viewRecipesHome: 'Ask your question',
        popularIngredients: 'Popular Ingredients',
        popularCookbooks: 'Popular Cookbooks',
        browseByLetter: 'Browse by Letter',
        videoRecipes: 'Video Recipes',
        randomRecipes: 'Random Recipes',
        recipesByLetter: 'Recipes by Letter',
        noRecipesFound: 'No recipes found',
        watchVideo: 'Watch Video',
        loadMore: 'Load More',
        categories: 'Categories',
        ingredients: 'Ingredients',
        areas: 'Areas',
        filterBy: 'Filter by',
        all: 'All',
        // Categories
        beef: 'Beef',
        breakfast: 'Breakfast',
        chicken: 'Chicken',
        dessert: 'Dessert',
        goat: 'Goat',
        lamb: 'Lamb',
        miscellaneous: 'Miscellaneous',
        pasta: 'Pasta',
        pork: 'Pork',
        seafood: 'Seafood',
        side: 'Side',
        starter: 'Starter',
        vegan: 'Vegan',
        vegetarian: 'Vegetarian',
        // Ingredients
        avocado: 'Avocado',
        bacon: 'Bacon',
        bakingPowder: 'Baking Powder',
        balsamicVinegar: 'Balsamic Vinegar',
        basil: 'Basil',
        basilLeaves: 'Basil Leaves',
        basmatiRice: 'Basmati Rice',
        bayLeaf: 'Bay Leaf',
        bayLeaves: 'Bay Leaves',
        beefBrisket: 'Beef Brisket',
        beefFillet: 'Beef Fillet',
        beefGravy: 'Beef Gravy',
        beefStock: 'Beef Stock',
        bicarbonateOfSoda: 'Bicarbonate Of Soda',
        biryaniMasala: 'Biryani Masala',
        blackPepper: 'Black Pepper',
        blackTreacle: 'Black Treacle',
        // Additional ingredients
        appleCiderVinegar: 'Apple Cider Vinegar',
        asparagus: 'Asparagus',
        aubergine: 'Aubergine',
        babyPlumTomatoes: 'Baby Plum Tomatoes',
        // Areas
        american: 'American',
        british: 'British',
        canadian: 'Canadian',
        chinese: 'Chinese',
        croatian: 'Croatian',
        dutch: 'Dutch',
        egyptian: 'Egyptian',
        filipino: 'Filipino',
        french: 'French',
        greek: 'Greek',
        indian: 'Indian',
        irish: 'Irish',
        italian: 'Italian',
        jamaican: 'Jamaican',
        japanese: 'Japanese',
        kenyan: 'Kenyan',
        malaysian: 'Malaysian',
        mexican: 'Mexican',
        moroccan: 'Moroccan',
        polish: 'Polish',
        portuguese: 'Portuguese',
        russian: 'Russian',
        spanish: 'Spanish',
        syrian: 'Syrian',
        thai: 'Thai',
        tunisian: 'Tunisian',
        turkish: 'Turkish',
        ukrainian: 'Ukrainian',
        uruguayan: 'Uruguayan',
        vietnamese: 'Vietnamese',
        recipes: 'recipes',
        Chicken: 'Chicken',
        Beef: 'Beef',
        Pork: 'Pork',
        Salmon: 'Salmon',
        Shrimp: 'Shrimp',
        Eggs: 'Eggs',
        Tofu: 'Tofu',
        Tuna: 'Tuna',
        Potato: 'Potato',
        Rice: 'Rice',
        comments: 'Comments',
        addComment: 'Leave a comment',
        noComments: 'No comments yet. Be the first!',
        submit: 'Submit',
        commentSubmitted: 'Comment posted!',
        errorSubmittingComment: 'Error posting the comment.',
        backToWaiting: 'Back',
        shoppingList: 'Shopping List',
        addItem: 'Add item',
        add: 'Add',
        clearList: 'Clear list',
        addToShoppingList: 'Add to shopping list',
        addedToShoppingList: 'Ingredients added to shopping list!',
        quantity: 'Quantity',
        diet: 'Diet',
        selectDiet: 'Select a diet',
        keto: 'Keto',
        lowCarb: 'Low Carb',
        vegetarian: 'Vegetarian',
        vegan: 'Vegan',
        paleo: 'Paleo',
        mediterraneanDiet: 'Mediterranean',
        dairyFree: 'Dairy-Free',
        glutenFree: 'Gluten-Free',
        lowFat: 'Low Fat',
        highProtein: 'High Protein',
        selectIngredients: 'Select ingredients',
        chicken: 'Chicken',
        beef: 'Beef',
        pork: 'Pork',
        salmon: 'Salmon',
        shrimp: 'Shrimp',
        eggs: 'Eggs',
        tofu: 'Tofu',
        tuna: 'Tuna',
        potato: 'Potato',
        rice: 'Rice',
        savedRecipes: "Saved Recipes",
        filters: "Filters",
        resetFilters: "Reset Filters",
        tryAgain: "Try Again",
        searchRecipes: "Search recipes...",
        ingredients: "Ingredients",
        allergens: "Allergens",
        cookingTime: "Cooking Time",
        addIngredient: "Add ingredient",
        upTo: "Up to",
        errorFetchingRecipes: "An error occurred while fetching recipes",
        // Database Recipes (Library 1) filters
        recipeLibraryTitle: "Recipe Library",
        recipesCount: "{count} recipes",
        searchPlaceholder: "Search recipes...",
        filterByLetter: "Filter by Letter",
        allLetters: "All",
        maxCalories: "Max Calories",
        caloriesUnit: "kcal",
        maxCookingTime: "Max Time",
        minutesUnit: "min",
        servings: "Servings",
        minServings: "Min Servings",
        maxServings: "Max Servings",
        selectAllergens: "Select Allergens",
        typeToSearch: "Type to search...",
        selectNutritions: "Select Nutritions",
        selectIngredients: "Select Ingredients",
        clearFilters: "Clear Filters",
        noRecipesMatch: "No recipes match the filters",
        dairy: "Dairy",
        soy: "Soy",
        shellfish: "Shellfish",
        fish: "Fish",
        showFilters: "Show Filters",
        hideFilters: "Hide Filters",
        viewAllRecipes: "View All Recipes",
        budgetFriendlyCooking: "Budget-Friendly Cooking",
        budgetFriendlyDescription: "Create delicious, budget-friendly meals with 'sous-chaif' using personalized recipes based on your ingredients and preferences.",
        customRecipeSuggestions: "Custom Recipe Suggestions",
        customRecipeDescription: "Share your ingredients, preferences, and dietary goals, and 'sous-chaif' will provide personalized recipes just for you.",
        secureAndEasy: "Secure and Easy",
        secureAndEasyDescription: "Your data is secure with us. Enjoy easy access to personalized recipes and cooking tips.",
        featureWelcomeTitle: "Welcome to Souschaif!",
        featureWelcomeSubtitle: "Upload a photo of your ingredients or fridge and get recipes instantly. You can close this window anytime.",
        featureWelcomeGotIt: "Got it",
        featureWelcomeMainBadge: "Most important",
        featureWelcomePhotoTitle: "Upload a photo of ingredients or your fridge",
        featureWelcomePhotoDescription: "Take or upload a photo and instantly receive recipes based on what you have at home.",
        featureWelcomeChatDescription: "Ask our AI chef your cooking questions and get instant personalised advice.",
        featureWelcomeLibraryDescription: "Browse hundreds of recipes and filter by ingredients, allergens and cooking time.",
        featureWelcomeShoppingDescription: "Automatically build a shopping list from your recipes.",
        smartShoppingList: "Smart shopping list",
        smartShoppingListDescription: "Generate shopping lists based on your favourite recipes.",
        usernameOrMobile: "Username or Mobile Number",
        rememberMe: "Remember me",
        logIn: "Log In",
        signingIn: "Signing in...",
        noAccount: "Don't have an account?",
        signUp: "Sign Up",
        next: "Next",
        skip: "Skip",
        defaultNotSubscribed: 'You are not subscribed to this service',
        defaultLoginError: 'Unable to verify your subscription. Please try again later',
        signup: "Sign Up",
        signupIntro: "Create your account to get started",
        username: "Username",
        password: "Password",
        confirmPassword: "Confirm Password",
        email: "Email address",
        mobileNumber: "Mobile number",
        signupButton: "Create Account",
        signupError: "Error during signup",
        alreadySubscribed: "Already subscribed?",
        clickHere: "Click here",
        signupSuccess: "Account created successfully",
        passwordRequirements: "Password Requirements",
        minLength: "Minimum 8 characters",
        requireUppercase: "At least one uppercase letter",
        requireLowercase: "At least one lowercase letter",
        requireNumber: "At least one number",
        requireSpecial: "At least one special character",
        passwordsMatch: "Passwords match",
        passwordRequirementsNotMet: "Please meet all password requirements",
        profile: "Profile",
        savedRecipes: "Saved Recipes",
        userData: "User Data",
        basicInformation: "Basic Information",
        username: "Username",
        email: "Email",
        mobileNumber: "Mobile Number",
        password: "Password",
        newPassword: "New Password",
        leaveEmptyToKeep: "Leave empty to keep current password",
        saveChanges: "Save Changes",
        changesSaved: "Changes saved successfully",
        subscriptionInformation: "Subscription Information",
        sessionId: "Session ID",
        createdAt: "Account Created",
        lastBillingDate: "Last Billing Date",
        nextBillingDate: "Next Billing Date",
        subscriptionStarted: "Subscription Started",
        timesBilled: "Times Billed",
        serviceName: "Service Name",
        termsAndConditions: "Terms & Conditions",
        viewTermsAndConditions: "View Terms & Conditions",
        pricingInformation: "Pricing Information",
        errorFetchingUserData: "Error fetching user data",
        errorUpdatingUser: "Error updating user data",
        noSavedRecipes: "No saved recipes yet",
        minutes: "minutes",
        servings: "servings",
        confirmUnsubscribe: "Confirm Unsubscription",
        confirmUnsubscribeMessage: "Are you sure you want to unsubscribe?",
        confirmPasswordChange: "Confirm Password Change",
        confirmPasswordChangeMessage: "Are you sure you want to change your password?",
        yes: "Yes",
        cancel: "Cancel",
        continentEurope: 'Europe',
        continentMiddleEast: 'Middle East',
        continentAsia: 'Asia',
        continentAfrica: 'Africa',
        continentNorthAmerica: 'North America',
        continentSouthAmerica: 'South America',
        continentOceania: 'Oceania',
        backToContinents: 'Back to Continents',
        downloadRecipe: 'Download recipe',
        pdfDownloaded: 'PDF downloaded successfully!',
        errorDownloadingPdf: 'Error downloading PDF.',
        random: 'Random',
        mostCommented: 'Most Commented',
        mostLiked: 'Most Liked',
        newest: 'Newest',
        quickest: 'Quickest',
        lowestCalories: 'Lowest Calories',
        audioFetched: 'Audio is ready to play.',
        errorFetchingAudio: 'Error fetching audio. Please try again.',
        loadingAudio: 'Loading audio...',
        winePairings: 'Wine Pairings',
        errorWinePairing: 'Could not get wine pairings. Please try again.',
        sharedOn: 'Recipe shared on',
        copiedToClipboard: 'Recipe copied to clipboard!',
        shareError: 'Could not share recipe.',
        photoTip: 'For best results, upload a clear photo of your ingredients or a dish.',
        noFoodDetected: 'No food or ingredients were detected in your photo. Please try again with a photo of ingredients or a dish.',
        errorCompressingImage: 'Error compressing image. Please try a smaller photo.',
        askingAboutCookbook: 'Questions about cookbook:',
        askingAboutRecipe: 'Asking about recipe:',
        submit: 'Submit',
        noComments: 'No comments yet. Be the first to comment!',
        comparePrices: 'Compare Supermarket Prices',
        comparingPrices: 'Comparing prices...',
        pricesFor: 'Prices for',
        priceComparison: 'Price Comparison',
        estimate: 'estimate',
        potentialSavings: 'Potential savings',
        cheapestAt: 'Cheapest at',
        cheapest: 'Cheapest',
        priceDisclaimer: 'Prices are AI estimates and may differ from actual store prices.',
        budget: 'Budget',
        midRange: 'Mid-range',
        premium: 'Premium',
        clearListConfirmTitle: 'Clear shopping list?',
        clearListConfirmText: 'This will remove all items from your list. This cannot be undone.',
        allergyPreferences: 'Allergy Preferences',
        allergyPreferencesDescription: 'Select your allergens below. Recipes containing these will be hidden from recommendations.',
        savePreferences: 'Save Preferences',
        saving: 'Saving...',
        preferencesSaved: 'Allergy preferences saved!',
        errorSavingPreferences: 'Error saving preferences',
    },
    deutsch: {
        and: "und",
        validateWeight: "Das Gewicht muss zwischen",
        validateHeight: "Die Größe muss zwischen",
        nutritionGoals: "Ernährungsziele",
        safetyAndDisclaimer: "Sicherheit & Haftungsausschluss",
        safetyAndDisclaimerText: "Die Ziele sind Schätzungen und ersetzen keine professionelle medizinische, ernährungs- oder diätetische Beratung. Wenn Sie gesundheitliche Bedenken haben, konsultieren Sie einen Arzt.",
        male: "Männlich",
        female: "Weiblich",
        other: "Andere",
        allowed: "Erlaubt",
        pleaseEnterAWeight: "Bitte geben Sie ein Gewicht ein",
        pleaseEnterAHeight: "Bitte geben Sie eine Körpergröße ein",
        calories: "Kalorien",
        protein: "Protein",
        fat: "Fett",
        carbs: "Kohlenhydrate",
        sex: "Geschlecht",
        age: "Alter",
        weight: "Gewicht",
        height: "Größe",
        activity: "Aktivität",
        goal: "Ziel",
        computeGoals: "Ziele berechnen",
        light: "Leicht",
        moderate: "Mittel",
        veryActive: "Sehr aktiv",
        extraActive: "Extrem aktiv",
        lose: "Abnehmen",
        maintain: "Halten",
        gain: "Zunehmen",
        dailyTargets: "Tägliche Ziele",
        unableToFetchPrices: 'Preise für Währung konnten nicht abgerufen werden',
        loadingPrices: 'Preise werden geladen',
        currency: 'Währung',
        latestMarketPrices: 'Aktuelle Marktpreise',
        countryCurrency: 'EUR',
        startScan: 'Scan starten',
        scanAnother: 'Scannen Sie einen anderen',
        scanning: 'Scannen',
        vitaminD: 'Vitamin D',
        salt: 'Salz',
        protein: 'Protein',
        fiber: 'Faser',
        addedSugars: 'Zuckerzusatz',
        sugars: 'Zucker',
        saturatedFat: 'Gesättigte Fettsäuren',
        fat: 'Fett',
        energy: 'Energie',
        amount: 'Menge',
        productNutrient: 'Nährstoff',
        productNutritionalValuesPer100g: 'Nährwert (pro 100g)',
        productIngredients: 'Zutaten',
        productNutriScore: 'Nutri-Score',
        productBrand: 'Marke',
        scanYourProductBarcode: 'Scannen Sie den Barcode Ihres Produkts!',
        productLookupFailed: 'Produktsuche fehlgeschlagen',
        productNotFoundError: 'Produkt nicht gefunden',
        cameraFailedStartError: 'Kamera konnte nicht gestartet werden',
        profile: 'Profil',
        basicInformation: 'Grundinformationen',
        savedRecipes: 'Gespeicherte Rezepte',
        noSavedRecipes: 'Sie haben keine gespeicherten Rezepte.',
        userData: 'Benutzerdaten',
        recipeRemoved:
            'Rezept {recipeName} wurde aus Ihren Favoriten entfernt.',
        username: 'Benutzername',
        mobileNumber: 'Handynummer',
        password: 'Passwort',
        saveChanges: 'Änderungen speichern',
        changesSaved: 'Ihre Änderungen wurden gespeichert.',
        subscriptionInformation: 'Abonnementinformationen',
        lastBillingDate: 'Letztes Rechnungsdatum',
        nextBillingDate: 'Nächstes Rechnungsdatum',
        subscriptionStarted: 'Abonnement Gestartet',
        timesBilled: 'Mal Abgerechnet',
        serviceName: 'Service-Name',
        termsAndConditions: 'Allgemeine Geschäftsbedingungen',
        viewTermsAndConditions: 'AGB anzeigen',
        pricingInformation: 'Preisinformationen',
        unsubscribe: 'Abmelden',
        unsubscribed: 'Sie wurden abgemeldet.',
        selectLanguage: 'Wählen Sie Ihre Sprache',
        whatToDo: 'Was möchten Sie tun?',
        takePhoto: 'Foto aufnehmen',
        uploadPhoto: 'Foto hochladen',
        pleaseAddPhotoFirst: 'Bitte fügen Sie zuerst ein Foto hinzu oder machen Sie ein Foto',
        uploading: 'Ihre personalisierten Rezepte werden erstellt...',
        loadingTime: 'Dies kann bis zu 1 Minute dauern...',
        analyzing: 'Die KI analysiert Ihr Foto...',
        aiAnalysisResult: 'KI-Analyseergebnis:',
        uploadError: 'Beim Hochladen des Bildes ist ein Fehler aufgetreten.',
        processingError: 'Beim Verarbeiten des Bildes ist ein Fehler aufgetreten.',
        numberOfPeople: 'Anzahl der Personen',
        timeOfDay: 'Tageszeit',
        selectTimeOfDay: 'Tageszeit auswählen',
        breakfast: 'Frühstück',
        morningSnack: 'Vormittagssnack',
        lunch: 'Mittagessen',
        afternoonSnack: 'Nachmittagssnack',
        dinner: 'Abendessen',
        dessert: 'Dessert',
        lateNightSnack: 'Mitternachtssnack',
        preferredCuisine: 'Bevorzugte Küche',
        selectCuisine: 'Küche auswählen',
        italian: 'Italienisch',
        chinese: 'Chinesisch',
        indian: 'Indisch',
        mexican: 'Mexikanisch',
        french: 'Französisch',
        thai: 'Thailändisch',
        japanese: 'Japanisch',
        mediterranean: 'Mediterran',
        spanish: 'Spanisch',
        greek: 'Griechisch',
        vietnamese: 'Vietnamesisch',
        american: 'Amerikanisch',
        turkish: 'Türkisch',
        korean: 'Koreanisch',
        moroccan: 'Marokkanisch',
        persian: 'Persisch',
        allergies: 'Allergien',
        selectAllergies: 'Allergien auswählen',
        gluten: 'Gluten',
        nuts: 'Nüsse',
        lactose: 'Laktose',
        soy: 'Soja',
        shellfish: 'Schalentiere',
        fish: 'Fisch',
        eggs: 'Eier',
        peanuts: 'Erdnüsse',
        sesame: 'Sesam',
        sulphites: 'Sulfite',
        mustard: 'Senf',
        celery: 'Sellerie',
        lupin: 'Lupine',
        molluscs: 'Weichtiere',
        cookingTime: 'Kochzeit',
        cookingTip: 'Kochtipp:',
        minutes: 'Minuten',
        caloriesPerServing: 'Kalorien pro Portion',
        servings: 'Portionen',
        allergens: 'Allergene',
        ingredients: 'Zutaten',
        instructions: 'Anleitung',
        askQuestion: 'Eine Frage stellen',
        recipeLibrary: 'Rezept-Bibliothek',
        loadMore: 'Mehr laden',
        loadNewRandomRecipes: 'Mehr Rezepte laden',
        loadingRecipes: 'Lade {count} Rezepte...',
        viewRecipe: 'Rezept ansehen',
        noResultsFound: 'Keine Ergebnisse gefunden',
        search: 'Bild hochladen',
        decrease: 'Minus',
        increase: 'Plus',
        uploading: 'Wird hochgeladen',
        elapsedTime: 'Verstrichene Zeit',
        seconds: 'Sekunden',
        cameraNotSupported: 'Kamera auf diesem Gerät nicht unterstützt',
        nutritions: 'Nährwerte',
        calories: 'Kalorien',
        protein: 'Protein',
        carbs: 'Kohlenhydrate',
        fat: 'Fett',
        fiber: 'Ballaststoffe',
        sugar: 'Zucker',
        sodium: 'Natrium',
        vitamina: 'Vitamin A',
        vitaminc: 'Vitamin C',
        calcium: 'Kalzium',
        iron: 'Eisen',
        recipeDetails: 'Rezeptdetails',
        loadMore: 'Weitere Rezepte laden',
        recipeAlreadySaved: 'Rezept ist bereits gespeichert.',
        recipeSaved: 'Rezept wurde erfolgreich gespeichert.',
        errorSavingRecipe:
            'Fehler beim Speichern des Rezepts. Bitte versuchen Sie es erneut.',
        recipeShared: 'Rezept geteilt über {platform}!',
        defaultSaveMessage: 'Aktion erfolgreich durchgeführt!',
        share: 'Teilen',
        favorite: 'Favorit',
        close: 'Schließen',
        whatsapp: 'WhatsApp',
        facebook: 'Facebook',
        twitter: 'Twitter',
        email: 'E-Mail',
        loading: 'Neue Rezepte werden abgerufen...',
        // ... minigame ...
        tetrisTitle: 'Spielen Sie Tetris, während Sie warten!',
        score: 'Punktzahl',
        highScore: 'Höchste Punktzahl',
        gameOver: 'Spiel vorbei',
        playAgain: 'Nochmal spielen',
        left: 'Links',
        right: 'Rechts',
        down: 'Unten',
        rotate: 'Drehen',
        startTetris: 'Eine Runde Tetris spielen',
        stopOrContinueTetris:
            'Rezepte sind geladen. Möchten Sie Tetris beenden und die Rezepte ansehen?',
        continueTetris: 'Mit Tetris fortfahren',
        playTetris: 'Tetris spielen',
        viewRecipes: 'Rezepte ansehen',
        recipesLoaded: 'SousChaif hat Ihre Rezepte fertig!',
        capturePhoto: 'Foto aufnehmen',
        closeCamera: 'Kamera schließen',
        pictureIngredients: 'Zutaten fotografieren',
        previewImage: 'Bild genehmigen',
        retake: 'Erneut aufnehmen',
        approve: 'Senden',
        waitingNotice: 'Spielen Sie ein Spiel, während Sie warten.',
        profile: 'Profil',
        basicInformation: 'Grunddaten',
        name: 'Name',
        email: 'E-Mail',
        savedRecipes: 'Gespeicherte Rezepte',
        noSavedRecipes: 'Sie haben noch keine Rezepte gespeichert.',
        recipeRemoved:
            'Das Rezept {recipeName} wurde aus Ihren Favoriten entfernt.',
        newSearchQuestion: 'Neue Rezepte suchen?',
        newSearchPrompt:
            'Möchten Sie nach neuen Rezepten suchen oder Ihre vorherigen Ergebnisse anzeigen?',
        searchNewRecipes: 'Neue Rezepte suchen',
        seeOldRecipes: 'Ansehen',
        chatBotIntro: 'Willkommen, ich bin SousChaif. Wie kann ich Ihnen heute helfen?',
        chatWithSousChaif: 'Mit SousChaif chatten',
        typeYourMessage: 'Geben Sie Ihre Nachricht ein...',
        recipeLoaded: 'Rezept geladen',
        askAboutRecipe: 'Fragen zum Rezept',
        errorFetchingData: 'Beim Abrufen der Daten ist ein Fehler aufgetreten.',
        whatQuestionWouldYouLikeToAsk: 'Welche Frage möchten Sie stellen?',
        welcomeBack: 'Willkommen zurück',
        needHelpWithRecipe: 'Brauchen Sie Hilfe beim Kochen?',
        viewRecipesHome: 'Stellen Sie Ihre Frage',
        popularIngredients: 'Beliebte Zutaten',
        popularCookbooks: 'Beliebte Kochbücher',
        browseByLetter: 'Nach Buchstabe durchsuchen',
        videoRecipes: 'Video Rezepte',
        recipesByLetter: 'Rezepte nach Buchstabe',
        noRecipesFound: 'Keine Rezepte gefunden',
        watchVideo: 'Video ansehen',
        loadMore: 'Mehr laden',
        categories: 'Kategorien',
        ingredients: 'Zutaten',
        filterBy: 'Filtern nach',
        all: 'Alle',
        // Categories
        beef: 'Rindfleisch',
        breakfast: 'Frühstück',
        chicken: 'Hähnchen',
        dessert: 'Dessert',
        goat: 'Ziege',
        lamb: 'Lamm',
        miscellaneous: 'Verschiedenes',
        pasta: 'Pasta',
        pork: 'Schweinefleisch',
        seafood: 'Meeresfrüchte',
        side: 'Beilage',
        starter: 'Vorspeise',
        vegan: 'Vegan',
        vegetarian: 'Vegetarisch',
        // Ingredients
        avocado: 'Avocado',
        bacon: 'Speck',
        bakingPowder: 'Backpulver',
        balsamicVinegar: 'Balsamico-Essig',
        basil: 'Basilikum',
        basilLeaves: 'Basilikumblätter',
        basmatiRice: 'Basmati-Reis',
        bayLeaf: 'Lorbeerblatt',
        bayLeaves: 'Lorbeerblätter',
        beefBrisket: 'Rinderbrust',
        beefFillet: 'Rinderfilet',
        beefGravy: 'Rinderbrühe',
        beefStock: 'Rinderfond',
        bicarbonateOfSoda: 'Natron',
        biryaniMasala: 'Biryani-Gewürz',
        blackPepper: 'Schwarzer Pfeffer',
        blackTreacle: 'Schwarzer Sirup',
        recipes: 'Rezepte',
        Chicken: 'Hähnchen',
        Beef: 'Rindfleisch',
        Pork: 'Schweinefleisch',
        Salmon: 'Lachs',
        Shrimp: 'Garnelen',
        Eggs: 'Eier',
        Tofu: 'Tofu',
        Tuna: 'Thunfisch',
        Potato: 'Kartoffel',
        Rice: 'Reis',
        comments: 'Kommentare',
        addComment: 'Hinterlassen Sie einen Kommentar',
        noComments: 'Noch keine Kommentare. Seien Sie der Erste!',
        submit: 'Absenden',
        commentSubmitted: 'Kommentar gepostet!',
        errorSubmittingComment: 'Fehler beim Posten des Kommentars.',
        backToWaiting: 'Zurück',
        shoppingList: 'Einkaufsliste',
        addItem: 'Artikel hinzufügen',
        add: 'Hinzufügen',
        clearList: 'Liste leeren',
        addToShoppingList: 'Zur Einkaufsliste hinzufügen',
        addedToShoppingList: 'Zutaten zur Einkaufsliste hinzugefügt!',
        quantity: 'Menge',
        diet: 'Diät',
        selectDiet: 'Wählen Sie eine Diät',
        keto: 'Keto',
        lowCarb: 'Low Carb',
        vegetarian: 'Vegetarisch',
        vegan: 'Vegan',
        paleo: 'Paleo',
        mediterraneanDiet: 'Mediterran',
        dairyFree: 'Laktosefrei',
        glutenFree: 'Glutenfrei',
        lowFat: 'Fettarm',
        highProtein: 'Proteinreich',
        selectIngredients: 'Zutaten auswählen',
        chicken: 'Hähnchen',
        beef: 'Rindfleisch',
        pork: 'Schweinefleisch',
        salmon: 'Lachs',
        shrimp: 'Garnelen',
        eggs: 'Eier',
        tofu: 'Tofu',
        tuna: 'Thunfisch',
        potato: 'Kartoffel',
        rice: 'Reis',
        savedRecipes: "Gespeicherte Rezepte",
        filters: "Filter",
        resetFilters: "Filter Zurücksetzen",
        tryAgain: "Erneut Versuchen",
        searchRecipes: "Rezepte suchen...",
        ingredients: "Zutaten",
        allergens: "Allergene",
        cookingTime: "Kochzeit",
        addIngredient: "Zutat hinzufügen",
        upTo: "Bis zu",
        errorFetchingRecipes: "Beim Abrufen der Rezepte ist ein Fehler aufgetreten",
        // Database Recipes (Library 1) filters
        recipeLibraryTitle: "Rezept-Bibliothek",
        recipesCount: "{count} Rezepte",
        searchPlaceholder: "Rezepte suchen...",
        filterByLetter: "Nach Buchstabe filtern",
        allLetters: "Alle",
        maxCalories: "Max Kalorien",
        caloriesUnit: "kcal",
        maxCookingTime: "Max Zeit",
        minutesUnit: "Min",
        servings: "Portionen",
        minServings: "Min Portionen",
        maxServings: "Max Portionen",
        selectAllergens: "Allergene auswählen",
        typeToSearch: "Zum Suchen tippen...",
        selectNutritions: "Nährstoffe auswählen",
        selectIngredients: "Zutaten auswählen",
        clearFilters: "Filter löschen",
        noRecipesMatch: "Keine Rezepte entsprechen den Filtern",
        dairy: "Milchprodukte",
        soy: "Soja",
        shellfish: "Schalentiere",
        fish: "Fisch",
        showFilters: "Filter Anzeigen",
        hideFilters: "Filter Ausblenden",
        viewAllRecipes: "Alle Rezepte Anzeigen",
        budgetFriendlyCooking: "Kostengünstiges Kochen",
        budgetFriendlyDescription: "Erstellen Sie köstliche, kostengünstige Mahlzeiten mit 'sous-chaif' anhand personalisierter Rezepte basierend auf Ihren Zutaten und Vorlieben.",
        customRecipeSuggestions: "Personalisierte Rezeptvorschläge",
        customRecipeDescription: "Teilen Sie Ihre Zutaten, Vorlieben und Ernährungsziele, und 'sous-chaif' stellt Ihnen personalisierte Rezepte zur Verfügung.",
        secureAndEasy: "Sicher und Einfach",
        secureAndEasyDescription: "Ihre Daten sind bei uns sicher. Genießen Sie einfachen Zugang zu personalisierten Rezepten und Kochtipps.",
        featureWelcomeTitle: "Willkommen bei Souschaif!",
        featureWelcomeSubtitle: "Laden Sie ein Foto Ihrer Zutaten oder Ihres Kühlschranks hoch und erhalten Sie sofort Rezepte. Sie können dieses Fenster jederzeit schließen.",
        featureWelcomeGotIt: "Verstanden",
        featureWelcomeMainBadge: "Wichtigste Funktion",
        featureWelcomePhotoTitle: "Foto von Zutaten oder Kühlschrank hochladen",
        featureWelcomePhotoDescription: "Machen oder laden Sie ein Foto hoch und erhalten Sie sofort Rezepte basierend auf dem, was Sie zu Hause haben.",
        featureWelcomeChatDescription: "Stellen Sie unserem KI-Koch Ihre Fragen und erhalten Sie sofort persönliche Tipps.",
        featureWelcomeLibraryDescription: "Durchsuchen Sie Hunderte Rezepte und filtern Sie nach Zutaten, Allergenen und Kochzeit.",
        featureWelcomeShoppingDescription: "Erstellen Sie automatisch Einkaufslisten aus Ihren Rezepten.",
        smartShoppingList: "Intelligente Einkaufsliste",
        smartShoppingListDescription: "Erstellen Sie Einkaufslisten basierend auf Ihren Lieblingsrezepten.",
        usernameOrMobile: "Benutzername oder Handynummer",
        rememberMe: "Angemeldet bleiben",
        logIn: "Anmelden",
        signingIn: "Anmeldung läuft...",
        noAccount: "Noch kein Konto?",
        signUp: "Registrieren",
        next: "Weiter",
        skip: "Überspringen",
        notSubscribed: 'Sie haben kein aktives Abonnement für diesen Dienst',
        loginError: 'Ihr Abonnement konnte nicht überprüft werden. Bitte versuchen Sie es später erneut',
        signup: "Registrieren",
        signupIntro: "Erstellen Sie ein Konto, um loszulegen",
        username: "Benutzername",
        password: "Passwort",
        confirmPassword: "Passwort bestätigen",
        email: "E-Mail-Adresse",
        mobileNumber: "Handynummer",
        signupButton: "Konto erstellen",
        signupError: "Fehler bei der Registrierung",
        alreadySubscribed: "Bereits angemeldet?",
        clickHere: "Hier klicken",
        signupSuccess: "Konto erfolgreich erstellt",
        passwordRequirements: "Passwortanforderungen",
        minLength: "Mindestens 8 Zeichen",
        requireUppercase: "Mindestens ein Großbuchstabe",
        requireLowercase: "Mindestens ein Kleinbuchstabe",
        requireNumber: "Mindestens eine Zahl",
        requireSpecial: "Mindestens ein Sonderzeichen",
        passwordsMatch: "Passwörter stimmen überein",
        passwordRequirementsNotMet: "Bitte erfüllen Sie alle Passwortanforderungen",
        profile: "Profil",
        savedRecipes: "Gespeicherte Rezepte",
        userData: "Benutzerdaten",
        basicInformation: "Grundinformationen",
        username: "Benutzername",
        email: "E-Mail",
        mobileNumber: "Mobilnummer",
        password: "Passwort",
        newPassword: "Neues Passwort",
        leaveEmptyToKeep: "Leer lassen um aktuelles Passwort zu behalten",
        saveChanges: "Änderungen Speichern",
        changesSaved: "Änderungen erfolgreich gespeichert",
        subscriptionInformation: "Abonnement-Informationen",
        sessionId: "Sitzungs-ID",
        createdAt: "Konto Erstellt",
        lastBillingDate: "Letztes Rechnungsdatum",
        nextBillingDate: "Nächstes Rechnungsdatum",
        subscriptionStarted: "Abonnement Gestartet",
        timesBilled: "Mal Abgerechnet",
        serviceName: "Service-Name",
        termsAndConditions: "Allgemeine Geschäftsbedingungen",
        viewTermsAndConditions: "AGB anzeigen",
        pricingInformation: "Preisinformationen",
        errorFetchingUserData: "Fehler beim Abrufen der Benutzerdaten",
        errorUpdatingUser: "Fehler beim Aktualisieren der Benutzerdaten",
        noSavedRecipes: "Noch keine Rezepte gespeichert",
        minutes: "Minuten",
        servings: "Portionen",
        confirmUnsubscribe: "Abbestellung bestätigen",
        confirmUnsubscribeMessage: "Bist du sicher, dass du dich abmelden möchtest?",
        confirmPasswordChange: "Passwortänderung bestätigen",
        confirmPasswordChangeMessage: "Bist du sicher, dass du dein Passwort ändern möchtest?",
        yes: "Ja",
        cancel: "Abbrechen",
        continentEurope: 'Europa',
        continentMiddleEast: 'Naher Osten',
        continentAsia: 'Asien',
        continentAfrica: 'Afrika',
        continentNorthAmerica: 'Nordamerika',
        continentSouthAmerica: 'Südamerika',
        continentOceania: 'Ozeanien',
        backToContinents: 'Zurück zu Kontinenten',
        downloadRecipe: 'Rezept herunterladen',
        pdfDownloaded: 'PDF erfolgreich heruntergeladen!',
        errorDownloadingPdf: 'Fehler beim Herunterladen der PDF.',
        random: 'Zufällig',
        mostCommented: 'Meistkommentiert',
        mostLiked: 'Meistgeliked',
        newest: 'Neueste',
        quickest: 'Schnellste',
        lowestCalories: 'Wenigste Kalorien',
        audioFetched: 'Audio ist bereit zum Abspielen.',
        errorFetchingAudio: 'Fehler beim Abrufen des Audios. Bitte versuche es erneut.',
        loadingAudio: 'Audio wird geladen...',
        winePairings: 'Weinempfehlungen',
        errorWinePairing: 'Weinempfehlungen konnten nicht abgerufen werden. Bitte versuche es erneut.',
        sharedOn: 'Rezept geteilt über',
        copiedToClipboard: 'Rezept in die Zwischenablage kopiert!',
        shareError: 'Rezept konnte nicht geteilt werden.',
        photoTip: 'Lade für beste Ergebnisse ein klares Foto deiner Zutaten oder eines Gerichts hoch.',
        noFoodDetected: 'Es wurden keine Lebensmittel oder Zutaten auf deinem Foto erkannt. Versuche es erneut mit einem Foto von Zutaten oder einem Gericht.',
        errorCompressingImage: 'Fehler beim Komprimieren des Bildes. Versuche ein kleineres Foto.',
        askingAboutCookbook: 'Fragen zum Kochbuch:',
        askingAboutRecipe: 'Fragen zum Rezept:',
        submit: 'Absenden',
        noComments: 'Noch keine Kommentare. Sei der Erste!',
        comparePrices: 'Supermarktpreise vergleichen',
        comparingPrices: 'Preise vergleichen...',
        pricesFor: 'Preise für',
        priceComparison: 'Preisvergleich',
        estimate: 'Schätzung',
        potentialSavings: 'Mögliche Ersparnis',
        cheapestAt: 'Am günstigsten bei',
        cheapest: 'Günstigster',
        priceDisclaimer: 'Preise sind KI-Schätzungen und können von den tatsächlichen Ladenpreisen abweichen.',
        budget: 'Günstig',
        midRange: 'Mittelklasse',
        premium: 'Premium',
        clearListConfirmTitle: 'Einkaufsliste löschen?',
        clearListConfirmText: 'Alle Artikel werden von deiner Liste entfernt. Dies kann nicht rückgängig gemacht werden.',
        allergyPreferences: 'Allergieeinstellungen',
        allergyPreferencesDescription: 'Wähle deine Allergene unten aus. Rezepte mit diesen Zutaten werden in Empfehlungen ausgeblendet.',
        savePreferences: 'Einstellungen speichern',
        saving: 'Speichern...',
        preferencesSaved: 'Allergieeinstellungen gespeichert!',
        errorSavingPreferences: 'Fehler beim Speichern der Einstellungen',
    },
    spanish: {
        and: "y",
        validateWeight: "El peso debe estar entre",
        validateHeight: "La altura debe estar entre",
        nutritionGoals: "Objetivos nutricionales",
        safetyAndDisclaimer: "Seguridad & Descargo de responsabilidad",
        safetyAndDisclaimerText: "Los objetivos son estimaciones y no reemplazan el asesoramiento médico, nutricional o dietético profesional. Si tiene preocupaciones de salud, consulte a un profesional sanitario.",
        male: "Masculino",
        female: "Femenino",
        other: "Otro",
        allowed: "Permitido",
        pleaseEnterAWeight: "Por favor, introduzca un peso",
        pleaseEnterAHeight: "Por favor, introduzca una altura",
        calories: "Calorías",
        protein: "Proteína",
        fat: "Grasa",
        carbs: "Carbohidratos",
        sex: "Sexo",
        age: "Edad",
        weight: "Peso",
        height: "Altura",
        activity: "Actividad",
        goal: "Objetivo",
        computeGoals: "Calcular objetivos",
        light: "Ligero",
        moderate: "Moderado",
        veryActive: "Muy activo",
        extraActive: "Extra activo",
        lose: "Perder",
        maintain: "Mantener",
        gain: "Ganar",
        dailyTargets: "Objetivos diarios",
        unableToFetchPrices: 'No se pueden obtener los precios de la moneda',
        loadingPrices: 'Cargando precios',
        currency: 'Divisa',
        latestMarketPrices: 'Últimos precios del mercado',
        countryCurrency: 'EUR',
        startScan: 'Iniciar escaneo',
        scanAnother: 'Escanear otro',
        scanning: 'Exploración',
        vitaminD: 'Vitamina D',
        salt: 'Sal',
        protein: 'Proteína',
        fiber: 'Fibra',
        addedSugars: 'Azúcares añadidos',
        sugars: 'Azúcares',
        saturatedFat: 'Grasas saturadas',
        fat: 'Gordo',
        energy: 'Energía',
        amount: 'Cantidad',
        productNutrient: 'Nutritivo',
        productNutritionalValuesPer100g: 'Valor nutricional (por 100g)',
        productIngredients: 'Ingredientes',
        productNutriScore: 'Nutri-Score',
        productBrand: 'Marca',
        scanYourProductBarcode: '¡Escanee el código de barras de su producto!',
        productLookupFailed: 'Error en la búsqueda del producto',
        productNotFoundError: 'Producto no encontrado',
        cameraFailedStartError: 'La cámara no se pudo iniciar',
        profile: 'Perfil',
        basicInformation: 'Información básica',
        savedRecipes: 'Recetas guardadas',
        noSavedRecipes: 'No tienes recetas guardadas.',
        userData: 'Datos del usuario',
        recipeRemoved: 'La receta {recipeName} ha sido eliminada de tus favoritos.',
        username: 'Nombre de usuario',
        mobileNumber: 'Número de móvil',
        password: 'Contraseña',
        saveChanges: 'Guardar cambios',
        changesSaved: 'Tus cambios han sido guardados.',
        subscriptionInformation: 'Información de suscripción',
        lastBillingDate: 'Última fecha de facturación',
        nextBillingDate: 'Próxima fecha de facturación',
        subscriptionStarted: 'Suscripción Iniciada',
        timesBilled: 'Veces Facturado',
        serviceName: 'Nombre del Servicio',
        termsAndConditions: 'Términos y Condiciones',
        viewTermsAndConditions: 'Ver Términos y Condiciones',
        pricingInformation: 'Información de Precios',
        unsubscribe: 'Darse de baja',
        unsubscribed: 'Te has dado de baja.',
        selectLanguage: 'Selecciona tu idioma',
        whatToDo: '¿Qué quieres hacer?',
        takePhoto: 'Tomar foto',
        uploadPhoto: 'Subir foto',
        pleaseAddPhotoFirst: 'Por favor añade una foto primero o toma una foto',
        uploading: 'Creando tus recetas personalizadas...',
        loadingTime: 'Esto puede tardar hasta 1 minuto...',
        analyzing: 'La IA está analizando tu foto...',
        aiAnalysisResult: 'Resultado del análisis de IA:',
        uploadError: 'Se produjo un error al subir la imagen.',
        processingError: 'Se produjo un error al procesar la imagen.',
        numberOfPeople: 'Número de personas',
        timeOfDay: 'Hora del día',
        selectTimeOfDay: 'Selecciona la hora del día',
        breakfast: 'Desayuno',
        morningSnack: 'Tentempié de la mañana',
        lunch: 'Almuerzo',
        afternoonSnack: 'Tentempié de la tarde',
        dinner: 'Cena',
        dessert: 'Postre',
        lateNightSnack: 'Tentempié nocturno',
        preferredCuisine: 'Cocina preferida',
        selectCuisine: 'Selecciona una cocina',
        italian: 'Italiana',
        chinese: 'China',
        indian: 'India',
        mexican: 'Mexicana',
        french: 'Francesa',
        thai: 'Tailandesa',
        japanese: 'Japonesa',
        mediterranean: 'Mediterránea',
        spanish: 'Española',
        greek: 'Griega',
        vietnamese: 'Vietnamita',
        american: 'Americana',
        turkish: 'Turca',
        korean: 'Coreana',
        moroccan: 'Marroquí',
        persian: 'Persa',
        allergies: 'Alergias',
        selectAllergies: 'Selecciona alergias',
        gluten: 'Gluten',
        nuts: 'Frutos secos',
        lactose: 'Lactosa',
        soy: 'Soja',
        shellfish: 'Mariscos',
        fish: 'Pescado',
        eggs: 'Huevos',
        peanuts: 'Cacahuetes',
        sesame: 'Sésamo',
        sulphites: 'Sulfitos',
        mustard: 'Mostaza',
        celery: 'Apio',
        lupin: 'Altramuces',
        molluscs: 'Moluscos',
        cookingTime: 'Tiempo de cocción',
        cookingTip: 'Consejo de cocina:',
        minutes: 'minutos',
        caloriesPerServing: 'Calorías por porción',
        servings: 'porciones',
        allergens: 'Alérgenos',
        ingredients: 'Ingredientes',
        instructions: 'Instrucciones',
        askQuestion: 'Hacer una pregunta',
        recipeLibrary: 'Biblioteca de Recetas',
        loadMore: 'Cargar más',
        loadNewRandomRecipes: 'Cargar más recetas',
        loadingRecipes: 'Cargando {count} recetas...',
        viewRecipe: 'Ver receta',
        noResultsFound: 'No se encontraron resultados',
        search: 'Subir imagen',
        decrease: 'Menos',
        increase: 'Más',
        uploading: 'Subiendo',
        elapsedTime: 'Tiempo transcurrido',
        seconds: 'segundos',
        cameraNotSupported: 'Cámara no soportada en este dispositivo',
        nutritions: 'Valores nutricionales',
        calories: 'Calorías',
        protein: 'Proteínas',
        carbs: 'Carbohidratos',
        fat: 'Grasas',
        fiber: 'Fibra',
        sugar: 'Azúcar',
        sodium: 'Sodio',
        vitamina: 'Vitamina A',
        vitaminc: 'Vitamina C',
        calcium: 'Calcio',
        iron: 'Hierro',
        recipeDetails: 'Detalles de la receta',
        loadMore: 'Cargar más recetas',
        recipeAlreadySaved: 'La receta ya está guardada.',
        recipeSaved: 'La receta se ha guardado con éxito.',
        errorSavingRecipe: 'Error al guardar la receta. Por favor, inténtalo de nuevo.',
        recipeShared: '¡Receta compartida a través de {platform}!',
        defaultSaveMessage: '¡Acción completada con éxito!',
        share: 'Compartir',
        favorite: 'Favorito',
        close: 'Cerrar',
        whatsapp: 'WhatsApp',
        facebook: 'Facebook',
        twitter: 'Twitter',
        email: 'Correo electrónico',
        loading: 'Obteniendo nuevas recetas...',
        // ... minigame ...
        tetrisTitle: '¡Juega al Tetris mientras esperas!',
        score: 'Puntuación',
        highScore: 'Puntuación más alta',
        gameOver: 'Juego terminado',
        playAgain: 'Jugar de nuevo',
        left: 'Izquierda',
        right: 'Derecha',
        down: 'Abajo',
        rotate: 'Girar',
        startTetris: 'Jugar una partida de Tetris',
        stopOrContinueTetris:
            'Las recetas están cargadas. ¿Quieres detener Tetris y ver las recetas?',
        continueTetris: 'Continuar con Tetris',
        playTetris: 'Jugar Tetris',
        viewRecipes: 'Ver recetas',
        recipesLoaded: '¡SousChaif ha terminado con tus recetas!',
        capturePhoto: 'Tomar foto',
        closeCamera: 'Cerrar cámara',
        pictureIngredients: 'Fotografiar ingredientes',
        previewImage: 'Aprobar imagen',
        retake: 'Repetir',
        approve: 'Enviar',
        waitingNotice: 'Juega un juego mientras esperas.',
        profile: 'Perfil',
        basicInformation: 'Información básica',
        name: 'Nombre',
        email: 'Correo electrónico',
        savedRecipes: 'Recetas guardadas',
        noSavedRecipes: 'Aún no tienes recetas guardadas.',
        recipeRemoved:
            'La receta {recipeName} ha sido eliminada de tus favoritos.',
        newSearchQuestion: '¿Buscar nuevas recetas?',
        newSearchPrompt:
            '¿Quieres buscar nuevas recetas o ver tus resultados anteriores?',
        searchNewRecipes: 'Buscar nuevas recetas',
        seeOldRecipes: 'Ver',
        chatBotIntro: 'Bienvenido, soy SousChaif. ¿En qué puedo ayudarte hoy?',
        chatWithSousChaif: 'Chatea con SousChaif',
        typeYourMessage: 'Escribe tu mensaje...',
        recipeLoaded: 'Receta cargada',
        askAboutRecipe: 'Preguntar sobre la receta',
        errorFetchingData: 'Hubo un error al obtener los datos.',
        whatQuestionWouldYouLikeToAsk: '¿Qué pregunta te gustaría hacer?',
        welcomeBack: 'Bienvenido de nuevo',
        needHelpWithRecipe: '¿Necesitas ayuda con la cocina?',
        viewRecipesHome: 'Haz tu pregunta',
        popularIngredients: 'Ingredientes populares',
        popularCookbooks: 'Libros de cocina populares',
        browseByLetter: 'Navegar por Letra',
        videoRecipes: 'Recetas en Video',
        recipesByLetter: 'Recetas por Letra',
        noRecipesFound: 'No se encontraron recetas',
        watchVideo: 'Ver Video',
        loadMore: 'Cargar Más',
        categories: 'Categorías',
        ingredients: 'Ingredientes',
        filterBy: 'Filtrar por',
        all: 'Todos',
        // Categories
        beef: 'Carne de Res',
        breakfast: 'Desayuno',
        chicken: 'Pollo',
        dessert: 'Postre',
        goat: 'Cabra',
        lamb: 'Cordero',
        miscellaneous: 'Misceláneo',
        pasta: 'Pasta',
        pork: 'Cerdo',
        seafood: 'Mariscos',
        side: 'Acompañamiento',
        starter: 'Entrada',
        vegan: 'Vegano',
        vegetarian: 'Vegetariano',
        // Ingredients
        avocado: 'Aguacate',
        bacon: 'Tocino',
        bakingPowder: 'Polvo de Hornear',
        balsamicVinegar: 'Vinagre Balsámico',
        basil: 'Albahaca',
        basilLeaves: 'Hojas de Albahaca',
        basmatiRice: 'Arroz Basmati',
        bayLeaf: 'Hoja de Laurel',
        bayLeaves: 'Hojas de Laurel',
        beefBrisket: 'Pecho de Res',
        beefFillet: 'Filete de Res',
        beefGravy: 'Salsa de Carne',
        beefStock: 'Caldo de Carne',
        bicarbonateOfSoda: 'Bicarbonato de Sodio',
        biryaniMasala: 'Especias Biryani',
        blackPepper: 'Pimienta Negra',
        blackTreacle: 'Melaza Negra',
        recipes: 'recetas',
        Chicken: 'Pollo',
        Beef: 'Carne de res',
        Pork: 'Cerdo',
        Salmon: 'Salmón',
        Shrimp: 'Camarones',
        Eggs: 'Huevos',
        Tofu: 'Tofu',
        Tuna: 'Atún',
        Potato: 'Patata',
        Rice: 'Arroz',
        comments: 'Comentarios',
        addComment: 'Deja un comentario',
        noComments: 'Aún no hay comentarios. ¡Sé el primero!',
        submit: 'Enviar',
        commentSubmitted: '¡Comentario publicado!',
        errorSubmittingComment: 'Error al publicar el comentario.',
        backToWaiting: 'Atrás',
        shoppingList: 'Lista de compras',
        addItem: 'Agregar artículo',
        add: 'Agregar',
        clearList: 'Limpiar lista',
        addToShoppingList: 'Agregar a la lista de compras',
        addedToShoppingList: '¡Ingredientes agregados a la lista de compras!',
        quantity: 'Cantidad',
        diet: 'Dieta',
        selectDiet: 'Selecciona una dieta',
        keto: 'Keto',
        lowCarb: 'Baja en carbohidratos',
        vegetarian: 'Vegetariana',
        vegan: 'Vegana',
        paleo: 'Paleo',
        mediterraneanDiet: 'Mediterránea',
        dairyFree: 'Sin lácteos',
        glutenFree: 'Sin gluten',
        lowFat: 'Baja en grasas',
        highProtein: 'Alta en proteínas',
        selectIngredients: 'Selecciona ingredientes',
        chicken: 'Pollo',
        beef: 'Carne de res',
        pork: 'Cerdo',
        salmon: 'Salmón',
        shrimp: 'Camarones',
        eggs: 'Huevos',
        tofu: 'Tofu',
        tuna: 'Atún',
        potato: 'Patata',
        rice: 'Arroz',
        savedRecipes: "Recetas Guardadas",
        filters: "Filtros",
        resetFilters: "Restablecer Filtros",
        tryAgain: "Intentar de Nuevo",
        searchRecipes: "Buscar recetas...",
        ingredients: "Ingredientes",
        allergens: "Alérgenos",
        cookingTime: "Tiempo de Cocción",
        addIngredient: "Añadir ingrediente",
        upTo: "Hasta",
        errorFetchingRecipes: "Se produjo un error al obtener las recetas",
        // Database Recipes (Library 1) filters
        recipeLibraryTitle: "Biblioteca de Recetas",
        recipesCount: "{count} recetas",
        searchPlaceholder: "Buscar recetas...",
        filterByLetter: "Filtrar por Letra",
        allLetters: "Todas",
        maxCalories: "Calorías Máximas",
        caloriesUnit: "kcal",
        maxCookingTime: "Tiempo Máximo",
        minutesUnit: "min",
        servings: "Porciones",
        minServings: "Porciones Mínimas",
        maxServings: "Porciones Máximas",
        selectAllergens: "Seleccionar Alérgenos",
        typeToSearch: "Escribe para buscar...",
        selectNutritions: "Seleccionar Nutrientes",
        selectIngredients: "Seleccionar Ingredientes",
        clearFilters: "Limpiar Filtros",
        noRecipesMatch: "No hay recetas que coincidan con los filtros",
        dairy: "Lácteos",
        soy: "Soja",
        shellfish: "Mariscos",
        fish: "Pescado",
        showFilters: "Mostrar Filtros",
        hideFilters: "Ocultar Filtros",
        viewAllRecipes: "Ver Todas las Recetas",
        budgetFriendlyCooking: "Cocina Económica",
        budgetFriendlyDescription: "Crea deliciosas comidas económicas con 'sous-chaif' usando recetas personalizadas basadas en tus ingredientes y preferencias.",
        customRecipeSuggestions: "Sugerencias de Recetas Personalizadas",
        customRecipeDescription: "Comparte tus ingredientes, preferencias y objetivos dietéticos, y 'sous-chaif' te proporcionará recetas personalizadas.",
        secureAndEasy: "Seguro y Fácil",
        secureAndEasyDescription: "Tus datos están seguros con nosotros. Disfruta de acceso fácil a recetas personalizadas y consejos de cocina.",
        featureWelcomeTitle: "¡Bienvenido a Souschaif!",
        featureWelcomeSubtitle: "Sube una foto de tus ingredientes o nevera y recibe recetas al instante. Puedes cerrar esta ventana en cualquier momento.",
        featureWelcomeGotIt: "Entendido",
        featureWelcomeMainBadge: "Lo más importante",
        featureWelcomePhotoTitle: "Subir foto de ingredientes o nevera",
        featureWelcomePhotoDescription: "Haz o sube una foto y recibe recetas personalizadas según lo que tengas en casa.",
        featureWelcomeChatDescription: "Haz preguntas a nuestro chef de IA y recibe consejos personalizados al instante.",
        featureWelcomeLibraryDescription: "Explora cientos de recetas y filtra por ingredientes, alérgenos y tiempo de cocción.",
        featureWelcomeShoppingDescription: "Crea listas de la compra automáticamente a partir de tus recetas.",
        smartShoppingList: "Lista de la compra inteligente",
        smartShoppingListDescription: "Genera listas de la compra basadas en tus recetas favoritas.",
        usernameOrMobile: "Nombre de usuario o Número móvil",
        rememberMe: "Recordarme",
        logIn: "Iniciar Sesión",
        signingIn: "Iniciando sesión...",
        noAccount: "¿No tienes una cuenta?",
        signUp: "Regístrate",
        next: "Siguiente",
        skip: "Saltar",
        notSubscribed: 'No estás suscrito a este servicio',
        loginError: 'No se pudo verificar tu suscripción. Por favor, inténtalo más tarde',
        signup: "Registrarse",
        signupIntro: "Crea tu cuenta para empezar",
        username: "Nombre de usuario",
        password: "Contraseña",
        confirmPassword: "Confirmar contraseña",
        email: "Correo electrónico",
        mobileNumber: "Número móvil",
        signupButton: "Crear cuenta",
        signupError: "Error durante el registro",
        alreadySubscribed: "¿Ya estás suscrito?",
        clickHere: "Haz clic aquí",
        signupSuccess: "Cuenta creada con éxito",
        passwordRequirements: "Requisitos de contraseña",
        minLength: "Mínimo 8 caracteres",
        requireUppercase: "Al menos una letra mayúscula",
        requireLowercase: "Al menos una letra minúscula",
        requireNumber: "Al menos un número",
        requireSpecial: "Al menos un carácter especial",
        passwordsMatch: "Las contraseñas coinciden",
        passwordRequirementsNotMet: "Cumple todos los requisitos de contraseña",
        profile: "Perfil",
        savedRecipes: "Recetas Guardadas",
        userData: "Datos del Usuario",
        basicInformation: "Información Básica",
        username: "Nombre de Usuario",
        email: "Correo Electrónico",
        mobileNumber: "Número Móvil",
        password: "Contraseña",
        newPassword: "Nueva Contraseña",
        leaveEmptyToKeep: "Dejar vacío para mantener la contraseña actual",
        saveChanges: "Guardar Cambios",
        changesSaved: "Cambios guardados exitosamente",
        subscriptionInformation: "Información de Suscripción",
        sessionId: "ID de Sesión",
        createdAt: "Cuenta Creada",
        lastBillingDate: "Última Fecha de Facturación",
        nextBillingDate: "Próxima Fecha de Facturación",
        subscriptionStarted: "Suscripción Iniciada",
        timesBilled: "Veces Facturado",
        serviceName: "Nombre del Servicio",
        termsAndConditions: "Términos y Condiciones",
        viewTermsAndConditions: "Ver Términos y Condiciones",
        pricingInformation: "Información de Precios",
        errorFetchingUserData: "Error al obtener datos del usuario",
        errorUpdatingUser: "Error al actualizar datos del usuario",
        noSavedRecipes: "Aún no hay recetas guardadas",
        minutes: "minutos",
        servings: "porciones",
        confirmUnsubscribe: "Confirmar baja",
        confirmUnsubscribeMessage: "¿Estás seguro de que deseas darte de baja?",
        confirmPasswordChange: "Confirmar cambio de contraseña",
        confirmPasswordChangeMessage: "¿Estás seguro de que deseas cambiar tu contraseña?",
        yes: "Sí",
        cancel: "Cancelar",
        continentEurope: 'Europa',
        continentMiddleEast: 'Oriente Medio',
        continentAsia: 'Asia',
        continentAfrica: 'África',
        continentNorthAmerica: 'América del Norte',
        continentSouthAmerica: 'América del Sur',
        continentOceania: 'Oceanía',
        backToContinents: 'Volver a Continentes',
        downloadRecipe: 'Descargar receta',
        pdfDownloaded: '¡PDF descargado con éxito!',
        errorDownloadingPdf: 'Error al descargar el PDF.',
        random: 'Aleatorio',
        mostCommented: 'Más Comentadas',
        mostLiked: 'Más Gustadas',
        newest: 'Más Recientes',
        quickest: 'Más Rápidas',
        lowestCalories: 'Menos Calorías',
        audioFetched: 'El audio está listo para reproducir.',
        errorFetchingAudio: 'Error al obtener el audio. Inténtalo de nuevo.',
        loadingAudio: 'Cargando audio...',
        winePairings: 'Maridaje de Vinos',
        errorWinePairing: 'No se pudieron obtener las sugerencias de vino. Inténtalo de nuevo.',
        sharedOn: 'Receta compartida en',
        copiedToClipboard: '¡Receta copiada al portapapeles!',
        shareError: 'No se pudo compartir la receta.',
        photoTip: 'Para mejores resultados, sube una foto clara de tus ingredientes o un platillo.',
        noFoodDetected: 'No se detectaron alimentos ni ingredientes en tu foto. Inténtalo de nuevo con una foto de ingredientes o un platillo.',
        errorCompressingImage: 'Error al comprimir la imagen. Prueba con una foto más pequeña.',
        askingAboutCookbook: 'Preguntas sobre el recetario:',
        askingAboutRecipe: 'Preguntas sobre la receta:',
        submit: 'Enviar',
        noComments: '¡Aún no hay comentarios. Sé el primero en comentar!',
        comparePrices: 'Comparar Precios de Supermercados',
        comparingPrices: 'Comparando precios...',
        pricesFor: 'Precios para',
        priceComparison: 'Comparación de Precios',
        estimate: 'estimación',
        potentialSavings: 'Ahorro potencial',
        cheapestAt: 'Más barato en',
        cheapest: 'Más barato',
        priceDisclaimer: 'Los precios son estimaciones de IA y pueden diferir de los precios reales en tienda.',
        budget: 'Económico',
        midRange: 'Gama media',
        premium: 'Premium',
        clearListConfirmTitle: '¿Borrar lista de compras?',
        clearListConfirmText: 'Esto eliminará todos los artículos de tu lista. No se puede deshacer.',
        allergyPreferences: 'Preferencias de Alergia',
        allergyPreferencesDescription: 'Selecciona tus alérgenos a continuación. Las recetas que los contengan se ocultarán de las recomendaciones.',
        savePreferences: 'Guardar Preferencias',
        saving: 'Guardando...',
        preferencesSaved: '¡Preferencias de alergia guardadas!',
        errorSavingPreferences: 'Error al guardar preferencias',
    },
    'mx-es': {
        and: "y",
        validateWeight: "El peso debe estar entre",
        validateHeight: "La altura debe estar entre",
        nutritionGoals: "Objetivos nutricionales",
        safetyAndDisclaimer: "Seguridad y Aviso Legal",
        safetyAndDisclaimerText: "Los objetivos son estimaciones y no reemplazan el asesoramiento médico, nutricional o dietético profesional. Si tienes preocupaciones de salud, consulta a un profesional.",
        male: "Masculino",
        female: "Femenino",
        other: "Otro",
        allowed: "Permitido",
        pleaseEnterAWeight: "Por favor, ingresa un peso",
        pleaseEnterAHeight: "Por favor, ingresa una altura",
        calories: "Calorías",
        protein: "Proteína",
        fat: "Grasa",
        carbs: "Carbohidratos",
        sex: "Sexo",
        age: "Edad",
        weight: "Peso",
        height: "Altura",
        activity: "Actividad",
        goal: "Objetivo",
        computeGoals: "Calcular objetivos",
        light: "Ligero",
        moderate: "Moderado",
        veryActive: "Muy activo",
        extraActive: "Extra activo",
        lose: "Bajar",
        maintain: "Mantener",
        gain: "Subir",
        dailyTargets: "Objetivos diarios",
        unableToFetchPrices: 'No se pueden obtener los precios',
        loadingPrices: 'Cargando precios',
        currency: 'Moneda',
        latestMarketPrices: 'Últimos precios del mercado',
        countryCurrency: 'MXN',
        startScan: 'Iniciar escaneo',
        scanAnother: 'Escanear otro',
        scanning: 'Escaneando',
        vitaminD: 'Vitamina D',
        salt: 'Sal',
        fiber: 'Fibra',
        addedSugars: 'Azúcares añadidos',
        sugars: 'Azúcares',
        saturatedFat: 'Grasas saturadas',
        energy: 'Energía',
        amount: 'Cantidad',
        productNutrient: 'Nutrientes',
        productNutritionalValuesPer100g: 'Valor nutricional (por 100g)',
        productIngredients: 'Ingredientes',
        productNutriScore: 'Nutri-Score',
        productBrand: 'Marca',
        scanYourProductBarcode: '¡Escanea el código de barras de tu producto!',
        productLookupFailed: 'Error en la búsqueda del producto',
        productNotFoundError: 'Producto no encontrado',
        cameraFailedStartError: 'No se pudo iniciar la cámara',
        profile: 'Perfil',
        basicInformation: 'Información básica',
        savedRecipes: 'Recetas guardadas',
        noSavedRecipes: 'No tienes recetas guardadas.',
        userData: 'Datos del usuario',
        recipeRemoved: 'La receta {recipeName} ha sido eliminada de tus favoritos.',
        username: 'Nombre de usuario',
        mobileNumber: 'Número de celular',
        password: 'Contraseña',
        saveChanges: 'Guardar cambios',
        changesSaved: 'Tus cambios han sido guardados.',
        subscriptionInformation: 'Información de suscripción',
        lastBillingDate: 'Última fecha de facturación',
        nextBillingDate: 'Próxima fecha de facturación',
        subscriptionStarted: 'Suscripción iniciada',
        timesBilled: 'Veces facturado',
        serviceName: 'Nombre del servicio',
        termsAndConditions: 'Términos y Condiciones',
        viewTermsAndConditions: 'Ver Términos y Condiciones',
        pricingInformation: 'Información de precios',
        unsubscribe: 'Darse de baja',
        unsubscribed: 'Te has dado de baja exitosamente.',
        selectLanguage: 'Selecciona tu idioma',
        whatToDo: '¿Qué quieres hacer?',
        takePhoto: 'Tomar foto',
        uploadPhoto: 'Subir foto',
        pleaseAddPhotoFirst: 'Por favor agrega una foto primero o toma una foto',
        uploading: 'Creando tus recetas personalizadas...',
        loadingTime: 'Esto puede tardar hasta 1 minuto...',
        analyzing: 'La IA está analizando tu foto...',
        aiAnalysisResult: 'Resultado del análisis de IA:',
        uploadError: 'Ocurrió un error al subir la imagen.',
        processingError: 'Ocurrió un error al procesar la imagen.',
        numberOfPeople: 'Número de personas',
        timeOfDay: 'Hora del día',
        selectTimeOfDay: 'Selecciona la hora del día',
        breakfast: 'Desayuno',
        morningSnack: 'Colación de la mañana',
        lunch: 'Comida',
        afternoonSnack: 'Colación de la tarde',
        dinner: 'Cena',
        dessert: 'Postre',
        lateNightSnack: 'Antojo nocturno',
        preferredCuisine: 'Cocina preferida',
        selectCuisine: 'Selecciona una cocina',
        italian: 'Italiana',
        chinese: 'China',
        indian: 'India',
        mexican: 'Mexicana',
        french: 'Francesa',
        thai: 'Tailandesa',
        japanese: 'Japonesa',
        mediterranean: 'Mediterránea',
        spanish: 'Española',
        greek: 'Griega',
        vietnamese: 'Vietnamita',
        american: 'Americana',
        turkish: 'Turca',
        korean: 'Coreana',
        moroccan: 'Marroquí',
        persian: 'Persa',
        allergies: 'Alergias',
        selectAllergies: 'Selecciona alergias',
        gluten: 'Gluten',
        nuts: 'Nueces',
        lactose: 'Lactosa',
        soy: 'Soya',
        shellfish: 'Mariscos',
        fish: 'Pescado',
        eggs: 'Huevos',
        peanuts: 'Cacahuates',
        sesame: 'Ajonjolí',
        sulphites: 'Sulfitos',
        mustard: 'Mostaza',
        celery: 'Apio',
        lupin: 'Altramuz',
        molluscs: 'Moluscos',
        cookingTime: 'Tiempo de cocción',
        cookingTip: 'Tip de cocina:',
        minutes: 'minutos',
        caloriesPerServing: 'Calorías por porción',
        servings: 'porciones',
        allergens: 'Alérgenos',
        ingredients: 'Ingredientes',
        instructions: 'Instrucciones',
        askQuestion: 'Hacer una pregunta',
        recipeLibrary: 'Biblioteca de Recetas',
        loadMore: 'Cargar más',
        loadNewRandomRecipes: 'Cargar más recetas',
        loadingRecipes: 'Cargando {count} recetas...',
        viewRecipe: 'Ver receta',
        noResultsFound: 'No se encontraron resultados',
        search: 'Subir imagen',
        decrease: 'Menos',
        increase: 'Más',
        elapsedTime: 'Tiempo transcurrido',
        seconds: 'segundos',
        cameraNotSupported: 'Cámara no soportada en este dispositivo',
        nutritions: 'Valores nutricionales',
        vitamina: 'Vitamina A',
        vitaminc: 'Vitamina C',
        calcium: 'Calcio',
        iron: 'Hierro',
        sugar: 'Azúcar',
        sodium: 'Sodio',
        recipeDetails: 'Detalles de la receta',
        recipeAlreadySaved: 'La receta ya está guardada.',
        recipeSaved: 'La receta se ha guardado exitosamente.',
        errorSavingRecipe: 'Error al guardar la receta. Por favor, inténtalo de nuevo.',
        recipeShared: '¡Receta compartida a través de {platform}!',
        defaultSaveMessage: '¡Listo!',
        share: 'Compartir',
        favorite: 'Favorito',
        close: 'Cerrar',
        whatsapp: 'WhatsApp',
        facebook: 'Facebook',
        twitter: 'Twitter',
        email: 'Correo electrónico',
        loading: 'Obteniendo nuevas recetas...',
        tetrisTitle: '¡Juega Tetris mientras esperas!',
        score: 'Puntuación',
        highScore: 'Puntuación más alta',
        gameOver: 'Game Over',
        playAgain: 'Jugar de nuevo',
        left: 'Izquierda',
        right: 'Derecha',
        down: 'Abajo',
        rotate: 'Girar',
        startTetris: 'Jugar una partida de Tetris',
        stopOrContinueTetris: 'Las recetas están listas. ¿Quieres dejar Tetris y ver las recetas?',
        continueTetris: 'Seguir con Tetris',
        playTetris: 'Jugar Tetris',
        viewRecipes: 'Ver recetas',
        recipesLoaded: '¡SousChaif terminó con tus recetas!',
        capturePhoto: 'Tomar foto',
        closeCamera: 'Cerrar cámara',
        pictureIngredients: 'Fotografiar ingredientes',
        previewImage: 'Aprobar imagen',
        retake: 'Repetir',
        approve: 'Enviar',
        waitingNotice: 'Juega un juego mientras esperas.',
        name: 'Nombre',
        newSearchQuestion: '¿Buscar nuevas recetas?',
        newSearchPrompt: '¿Quieres buscar nuevas recetas o ver tus resultados anteriores?',
        searchNewRecipes: 'Buscar nuevas recetas',
        seeOldRecipes: 'Ver',
        chatBotIntro: '¡Hola! Soy SousChaif. ¿En qué te puedo ayudar hoy?',
        chatWithSousChaif: 'Chatea con SousChaif',
        typeYourMessage: 'Escribe tu mensaje...',
        recipeLoaded: 'Receta cargada',
        askAboutRecipe: 'Preguntar sobre la receta',
        errorFetchingData: 'Hubo un error al obtener los datos.',
        whatQuestionWouldYouLikeToAsk: '¿Qué pregunta te gustaría hacer?',
        welcomeBack: '¡Bienvenido de vuelta!',
        needHelpWithRecipe: '¿Necesitas ayuda con la cocina?',
        viewRecipesHome: 'Haz tu pregunta',
        popularIngredients: 'Ingredientes populares',
        popularCookbooks: 'Libros de cocina populares',
        browseByLetter: 'Buscar por Letra',
        videoRecipes: 'Recetas en Video',
        recipesByLetter: 'Recetas por Letra',
        noRecipesFound: 'No se encontraron recetas',
        watchVideo: 'Ver Video',
        categories: 'Categorías',
        filterBy: 'Filtrar por',
        all: 'Todos',
        beef: 'Res',
        chicken: 'Pollo',
        goat: 'Cabra',
        lamb: 'Cordero',
        miscellaneous: 'Varios',
        pasta: 'Pasta',
        pork: 'Puerco',
        seafood: 'Mariscos',
        side: 'Guarnición',
        starter: 'Entrada',
        vegan: 'Vegano',
        vegetarian: 'Vegetariano',
        avocado: 'Aguacate',
        bacon: 'Tocino',
        bakingPowder: 'Polvo para hornear',
        balsamicVinegar: 'Vinagre balsámico',
        basil: 'Albahaca',
        basilLeaves: 'Hojas de albahaca',
        basmatiRice: 'Arroz basmati',
        bayLeaf: 'Hoja de laurel',
        bayLeaves: 'Hojas de laurel',
        beefBrisket: 'Pecho de res',
        beefFillet: 'Filete de res',
        beefGravy: 'Salsa de carne',
        beefStock: 'Caldo de res',
        bicarbonateOfSoda: 'Bicarbonato de sodio',
        biryaniMasala: 'Especias Biryani',
        blackPepper: 'Pimienta negra',
        blackTreacle: 'Melaza',
        recipes: 'recetas',
        Chicken: 'Pollo',
        Beef: 'Res',
        Pork: 'Puerco',
        Salmon: 'Salmón',
        Shrimp: 'Camarones',
        Eggs: 'Huevos',
        Tofu: 'Tofu',
        Tuna: 'Atún',
        Potato: 'Papa',
        Rice: 'Arroz',
        comments: 'Comentarios',
        addComment: 'Deja un comentario',
        noComments: '¡Aún no hay comentarios. ¡Sé el primero!',
        submit: 'Enviar',
        commentSubmitted: '¡Comentario publicado!',
        errorSubmittingComment: 'Error al publicar el comentario.',
        backToWaiting: 'Atrás',
        shoppingList: 'Lista del súper',
        addItem: 'Agregar producto',
        add: 'Agregar',
        clearList: 'Limpiar lista',
        addToShoppingList: 'Agregar a la lista del súper',
        addedToShoppingList: '¡Ingredientes agregados a la lista del súper!',
        quantity: 'Cantidad',
        diet: 'Dieta',
        selectDiet: 'Selecciona una dieta',
        keto: 'Keto',
        lowCarb: 'Baja en carbohidratos',
        paleo: 'Paleo',
        mediterraneanDiet: 'Mediterránea',
        dairyFree: 'Sin lácteos',
        glutenFree: 'Sin gluten',
        lowFat: 'Baja en grasas',
        highProtein: 'Alta en proteínas',
        selectIngredients: 'Selecciona ingredientes',
        salmon: 'Salmón',
        shrimp: 'Camarones',
        tofu: 'Tofu',
        tuna: 'Atún',
        potato: 'Papa',
        rice: 'Arroz',
        filters: "Filtros",
        resetFilters: "Restablecer filtros",
        tryAgain: "Intentar de nuevo",
        searchRecipes: "Buscar recetas...",
        selectAllergens: "Seleccionar alérgenos",
        typeToSearch: "Escribe para buscar...",
        selectNutritions: "Seleccionar nutrientes",
        clearFilters: "Limpiar filtros",
        noRecipesMatch: "No hay recetas que coincidan con los filtros",
        dairy: "Lácteos",
        showFilters: "Mostrar filtros",
        hideFilters: "Ocultar filtros",
        viewAllRecipes: "Ver todas las recetas",
        budgetFriendlyCooking: "Cocina económica",
        budgetFriendlyDescription: "Prepara platillos deliciosos y económicos con SousChaif usando recetas personalizadas basadas en tus ingredientes y preferencias.",
        customRecipeSuggestions: "Sugerencias de recetas personalizadas",
        customRecipeDescription: "Comparte tus ingredientes, preferencias y objetivos dietéticos, y SousChaif te dará recetas a tu medida.",
        secureAndEasy: "Seguro y fácil",
        secureAndEasyDescription: "Tus datos están seguros con nosotros. Disfruta de acceso fácil a recetas personalizadas y tips de cocina.",
        featureWelcomeTitle: "¡Bienvenido a Souschaif!",
        featureWelcomeSubtitle: "Sube una foto de tus ingredientes o refrigerador y recibe recetas al instante. Puedes cerrar esta ventana en cualquier momento.",
        featureWelcomeGotIt: "Entendido",
        featureWelcomeMainBadge: "Lo más importante",
        featureWelcomePhotoTitle: "Subir foto de ingredientes o refrigerador",
        featureWelcomePhotoDescription: "Toma o sube una foto y recibe recetas personalizadas según lo que tengas en casa.",
        featureWelcomeChatDescription: "Haz preguntas a nuestro chef de IA y recibe consejos personalizados al instante.",
        featureWelcomeLibraryDescription: "Explora cientos de recetas y filtra por ingredientes, alérgenos y tiempo de cocción.",
        featureWelcomeShoppingDescription: "Crea listas de compras automáticamente a partir de tus recetas.",
        smartShoppingList: "Lista de compras inteligente",
        smartShoppingListDescription: "Genera listas de compras basadas en tus recetas favoritas.",
        usernameOrMobile: "Usuario o número de celular",
        rememberMe: "Recordarme",
        logIn: "Iniciar sesión",
        signingIn: "Iniciando sesión...",
        noAccount: "¿No tienes una cuenta?",
        signUp: "Regístrate",
        next: "Siguiente",
        skip: "Saltar",
        notSubscribed: 'No estás suscrito a este servicio',
        loginError: 'No se pudo verificar tu suscripción. Inténtalo más tarde',
        signup: "Registrarse",
        signupIntro: "Crea tu cuenta para empezar",
        confirmPassword: "Confirmar contraseña",
        signupButton: "Crear cuenta",
        signupError: "Error durante el registro",
        alreadySubscribed: "¿Ya estás suscrito?",
        clickHere: "Da clic aquí",
        signupSuccess: "Cuenta creada exitosamente",
        passwordRequirements: "Requisitos de contraseña",
        minLength: "Mínimo 8 caracteres",
        requireUppercase: "Al menos una letra mayúscula",
        requireLowercase: "Al menos una letra minúscula",
        requireNumber: "Al menos un número",
        requireSpecial: "Al menos un carácter especial",
        passwordsMatch: "Las contraseñas coinciden",
        passwordRequirementsNotMet: "Cumple todos los requisitos de contraseña",
        newPassword: "Nueva contraseña",
        leaveEmptyToKeep: "Dejar vacío para mantener la contraseña actual",
        sessionId: "ID de sesión",
        createdAt: "Cuenta creada",
        errorFetchingUserData: "Error al obtener datos del usuario",
        errorUpdatingUser: "Error al actualizar datos del usuario",
        confirmUnsubscribe: "Confirmar baja",
        confirmUnsubscribeMessage: "¿Estás seguro de que deseas darte de baja?",
        confirmPasswordChange: "Confirmar cambio de contraseña",
        confirmPasswordChangeMessage: "¿Estás seguro de que deseas cambiar tu contraseña?",
        yes: "Sí",
        cancel: "Cancelar",
        continentEurope: 'Europa',
        continentMiddleEast: 'Medio Oriente',
        continentAsia: 'Asia',
        continentAfrica: 'África',
        continentNorthAmerica: 'Norteamérica',
        continentSouthAmerica: 'Sudamérica',
        continentOceania: 'Oceanía',
        backToContinents: 'Volver a Continentes',
        downloadRecipe: 'Descargar receta',
        pdfDownloaded: '¡PDF descargado!',
        errorDownloadingPdf: 'Error al descargar el PDF.',
        recipeLibraryTitle: "Biblioteca de Recetas",
        recipesCount: "{count} recetas",
        searchPlaceholder: "Buscar recetas...",
        filterByLetter: "Filtrar por letra",
        allLetters: "Todas",
        maxCalories: "Calorías máximas",
        caloriesUnit: "kcal",
        maxCookingTime: "Tiempo máximo",
        minutesUnit: "min",
        minServings: "Porciones mínimas",
        maxServings: "Porciones máximas",
        addIngredient: "Añadir ingrediente",
        upTo: "Hasta",
        errorFetchingRecipes: "Ocurrió un error al obtener las recetas",
        random: 'Aleatorio',
        mostCommented: 'Más comentadas',
        mostLiked: 'Más gustadas',
        newest: 'Más recientes',
        quickest: 'Más rápidas',
        lowestCalories: 'Menos calorías',
        audioFetched: 'El audio está listo.',
        errorFetchingAudio: 'Error al obtener el audio. Inténtalo de nuevo.',
        loadingAudio: 'Cargando audio...',
        winePairings: 'Maridaje de Vinos',
        errorWinePairing: 'No se pudieron obtener las sugerencias de vino. Inténtalo de nuevo.',
        sharedOn: 'Receta compartida en',
        copiedToClipboard: '¡Receta copiada al portapapeles!',
        shareError: 'No se pudo compartir la receta.',
        photoTip: 'Para mejores resultados, sube una foto clara de tus ingredientes o de un platillo.',
        noFoodDetected: 'No se detectaron alimentos ni ingredientes en tu foto. Inténtalo con una foto de ingredientes o un platillo.',
        errorCompressingImage: 'Error al comprimir la imagen. Prueba con una foto más pequeña.',
        askingAboutCookbook: 'Preguntas sobre el recetario:',
        askingAboutRecipe: 'Preguntas sobre la receta:',
        comparePrices: 'Comparar precios en súpers',
        comparingPrices: 'Comparando precios...',
        pricesFor: 'Precios para',
        priceComparison: 'Comparación de precios',
        estimate: 'estimación',
        potentialSavings: 'Ahorro potencial',
        cheapestAt: 'Más barato en',
        cheapest: 'Más barato',
        priceDisclaimer: 'Los precios son estimaciones de IA y pueden variar respecto a los precios reales en tienda.',
        budget: 'Económico',
        midRange: 'Gama media',
        premium: 'Premium',
        clearListConfirmTitle: '¿Borrar lista del súper?',
        clearListConfirmText: 'Esto eliminará todos los productos de tu lista. No se puede deshacer.',
        allergyPreferences: 'Preferencias de Alergia',
        allergyPreferencesDescription: 'Selecciona tus alérgenos abajo. Las recetas que los contengan se ocultarán de las recomendaciones.',
        savePreferences: 'Guardar preferencias',
        saving: 'Guardando...',
        preferencesSaved: '¡Preferencias de alergia guardadas!',
        errorSavingPreferences: 'Error al guardar preferencias',
    },
    french: {
        and: "et",
        validateWeight: "Le poids doit être entre",
        validateHeight: "La taille doit être entre",
        nutritionGoals: "Objectifs nutritionnels",
        safetyAndDisclaimer: "Sécurité & Avertissement",
        safetyAndDisclaimerText: "Les objectifs sont des estimations et ne remplacent pas un avis médical, nutritionnel ou diététique professionnel. Si vous avez des problèmes de santé, consultez un professionnel de santé.",
        male: "Homme",
        female: "Femme",
        other: "Autre",
        allowed: "Autorisé",
        pleaseEnterAWeight: "Veuillez saisir un poids",
        pleaseEnterAHeight: "Veuillez saisir une taille",
        calories: "Calories",
        protein: "Protéines",
        fat: "Graisse",
        carbs: "Glucides",
        sex: "Sexe",
        age: "Âge",
        weight: "Poids",
        height: "Taille",
        activity: "Activité",
        goal: "Objectif",
        computeGoals: "Calculer les objectifs",
        light: "Léger",
        moderate: "Modéré",
        veryActive: "Très actif",
        extraActive: "Extrêmement actif",
        lose: "Perdre",
        maintain: "Maintenir",
        gain: "Gagner",
        dailyTargets: "Objectifs quotidiens",
        unableToFetchPrices: 'Impossible de récupérer les prix des devises',
        loadingPrices: 'Chargement de tarifs',
        currency: 'Devise',
        latestMarketPrices: 'Derniers prix du marché',
        countryCurrency: 'EUR',
        startScan: "Démarrer l'analyse",
        scanAnother: 'Scanner un autre',
        scanning: 'Balayage',
        vitaminD: 'Vitamine D',
        salt: 'Sel',
        protein: 'Protéine',
        fiber: 'Fibre',
        addedSugars: 'Sucres ajoutés',
        sugars: 'Sucres',
        saturatedFat: 'Graisses saturées',
        fat: 'Gras',
        energy: 'Énergie',
        amount: 'Montant',
        productNutrient: 'Nutritif',
        productNutritionalValuesPer100g: 'Valeur nutritionnelle (pour 100 g)',
        productIngredients: 'Ingrédients',
        productNutriScore: 'Nutri-Score',
        productBrand: 'Marque',
        scanYourProductBarcode: 'Scannez le code-barres de votre produit !',
        productLookupFailed: 'La recherche de produit a échoué',
        productNotFoundError: 'Produit non trouvé',
        cameraFailedStartError: "La caméra n'a pas pu démarrer",
        profile: 'Profil',
        basicInformation: 'Informations de base',
        savedRecipes: 'Recettes sauvegardées',
        noSavedRecipes: "Vous n'avez pas de recettes sauvegardées.",
        userData: 'Données utilisateur',
        recipeRemoved: 'La recette {recipeName} a été retirée de vos favoris.',
        username: "Nom d'utilisateur",
        mobileNumber: 'Numéro de mobile',
        password: 'Mot de passe',
        saveChanges: 'Enregistrer les modifications',
        changesSaved: 'Vos modifications ont été enregistrées.',
        subscriptionInformation: "Informations sur l'abonnement",
        lastBillingDate: 'Date de la dernière facturation',
        nextBillingDate: 'Date de la prochaine facturation',
        subscriptionStarted: 'Abonnement Démarré',
        timesBilled: 'Fois Facturé',
        serviceName: 'Nom du Service',
        termsAndConditions: 'Termes et Conditions',
        viewTermsAndConditions: 'Voir les Termes et Conditions',
        unsubscribe: 'Se désabonner',
        unsubscribed: 'Vous vous êtes désabonné.',
        selectLanguage: 'Sélectionnez votre langue',
        whatToDo: 'Que voulez-vous faire ?',
        takePhoto: 'Prendre une photo',
        uploadPhoto: 'Télécharger une photo',
        pleaseAddPhotoFirst: 'Veuillez d\'abord ajouter une photo ou prendre une photo',
        uploading: 'Création de vos recettes personnalisées...',
        loadingTime: "Cela peut prendre jusqu'à 1 minute...",
        analyzing: 'L’IA analyse votre photo...',
        aiAnalysisResult: "Résultat de l'analyse de l'IA :",
        uploadError: "Une erreur s'est produite lors du téléchargement de l'image.",
        processingError: "Une erreur s'est produite lors du traitement de l'image.",
        numberOfPeople: 'Nombre de personnes',
        timeOfDay: 'Moment de la journée',
        selectTimeOfDay: 'Sélectionnez le moment de la journée',
        breakfast: 'Petit-déjeuner',
        morningSnack: 'Collation du matin',
        lunch: 'Déjeuner',
        afternoonSnack: "Collation de l'après-midi",
        dinner: 'Dîner',
        dessert: 'Dessert',
        lateNightSnack: 'Collation de fin de soirée',
        preferredCuisine: 'Cuisine préférée',
        selectCuisine: 'Sélectionnez une cuisine',
        italian: 'Italienne',
        chinese: 'Chinoise',
        indian: 'Indienne',
        mexican: 'Mexicaine',
        french: 'Française',
        thai: 'Thaïlandaise',
        japanese: 'Japonaise',
        mediterranean: 'Méditerranéenne',
        spanish: 'Espagnole',
        greek: 'Grecque',
        vietnamese: 'Vietnamienne',
        american: 'Américaine',
        turkish: 'Turque',
        korean: 'Coréenne',
        moroccan: 'Marocaine',
        persian: 'Perse',
        allergies: 'Allergies',
        selectAllergies: 'Sélectionnez les allergies',
        gluten: 'Gluten',
        nuts: 'Noix',
        lactose: 'Lactose',
        soy: 'Soja',
        shellfish: 'Crustacés',
        fish: 'Poisson',
        eggs: 'Œufs',
        peanuts: 'Arachides',
        sesame: 'Sésame',
        sulphites: 'Sulfites',
        mustard: 'Moutarde',
        celery: 'Céleri',
        lupin: 'Lupin',
        molluscs: 'Mollusques',
        cookingTime: 'Temps de cuisson',
        cookingTip: 'Astuce de cuisine :',
        minutes: 'minutes',
        caloriesPerServing: 'Calories par portion',
        servings: 'portions',
        allergens: 'Allergènes',
        ingredients: 'Ingrédients',
        instructions: 'Instructions',
        askQuestion: 'Poser une question',
        recipeLibrary: 'Bibliothèque de Recettes',
        loadMore: 'Charger plus',
        loadNewRandomRecipes: 'Charger plus de recettes',
        loadingRecipes: 'Chargement de {count} recettes...',
        viewRecipe: 'Voir la recette',
        noResultsFound: 'Aucun résultat trouvé',
        search: 'Télécharger une image',
        decrease: 'Moins',
        increase: 'Plus',
        uploading: 'Téléchargement',
        elapsedTime: 'Temps écoulé',
        seconds: 'secondes',
        cameraNotSupported: 'Caméra non prise en charge sur cet appareil',
        nutritions: 'Valeurs nutritionnelles',
        calories: 'Calories',
        protein: 'Protéines',
        carbs: 'Glucides',
        fat: 'Graisses',
        fiber: 'Fibres',
        sugar: 'Sucre',
        sodium: 'Sodium',
        vitamina: 'Vitamine A',
        vitaminc: 'Vitamine C',
        calcium: 'Calcium',
        iron: 'Fer',
        recipeDetails: 'Détails de la recette',
        loadMore: 'Charger plus de recettes',
        recipeAlreadySaved: 'La recette est déjà enregistrée.',
        recipeSaved: 'La recette a été enregistrée avec succès.',
        errorSavingRecipe: "Erreur lors de l'enregistrement de la recette. Veuillez réessayer.",
        recipeShared: 'Recette partagée via {platform} !',
        defaultSaveMessage: 'Action effectuée avec succès !',
        share: 'Partager',
        favorite: 'Favori',
        close: 'Fermer',
        whatsapp: 'WhatsApp',
        facebook: 'Facebook',
        twitter: 'Twitter',
        email: 'E-mail',
        loading: 'Récupération de nouvelles recettes...',
        // ... minigame ...
        tetrisTitle: 'Jouez à Tetris pendant que vous attendez !',
        score: 'Score',
        highScore: 'Meilleur score',
        gameOver: 'Jeu terminé',
        playAgain: 'Rejouer',
        left: 'Gauche',
        right: 'Droite',
        down: 'Bas',
        rotate: 'Tourner',
        startTetris: 'Jouer une partie de Tetris',
        stopOrContinueTetris: 'Les recettes sont chargées. Voulez-vous arrêter Tetris et voir les recettes ?',
        continueTetris: 'Continuer Tetris',
        playTetris: 'Jouer à Tetris',
        viewRecipes: 'Voir les recettes',
        recipesLoaded: 'SousChaif a terminé vos recettes !',
        capturePhoto: 'Prendre une photo',
        closeCamera: 'Fermer la caméra',
        pictureIngredients: 'Photographier les ingrédients',
        previewImage: "Approuver l'image",
        retake: 'Reprendre',
        approve: 'Envoyer',
        waitingNotice: 'Jouez à un jeu pendant que vous attendez.',
        profile: 'Profil',
        basicInformation: 'Informations de base',
        name: 'Nom',
        email: 'E-mail',
        savedRecipes: 'Recettes sauvegardées',
        noSavedRecipes: "Vous n'avez pas encore de recettes sauvegardées.",
        recipeRemoved: 'La recette {recipeName} a été retirée de vos favoris.',
        newSearchQuestion: 'Rechercher de nouvelles recettes ?',
        newSearchPrompt: 'Voulez-vous rechercher de nouvelles recettes ou voir vos résultats précédents ?',
        searchNewRecipes: 'Rechercher de nouvelles recettes',
        seeOldRecipes: 'Voir',
        chatBotIntro: "Bienvenue, je suis SousChaif. Comment puis-je vous aider aujourd'hui ?",
        chatWithSousChaif: 'Discuter avec SousChaif',
        typeYourMessage: 'Tapez votre message...',
        recipeLoaded: 'Recette chargée',
        askAboutRecipe: 'Poser une question sur la recette',
        errorFetchingData: "Une erreur s'est produite lors de la récupération des données.",
        whatQuestionWouldYouLikeToAsk: 'Quelle question souhaitez-vous poser ?',
        welcomeBack: 'Bon retour',
        needHelpWithRecipe: 'Besoin d’aide pour cuisiner ?',
        viewRecipesHome: 'Posez votre question',
        popularIngredients: 'Ingrédients populaires',
        popularCookbooks: 'Livres de cuisine populaires',
        browseByLetter: 'Parcourir par Lettre',
        videoRecipes: 'Recettes en Vidéo',
        recipesByLetter: 'Recettes par Lettre',
        noRecipesFound: 'Aucune recette trouvée',
        watchVideo: 'Regarder la Vidéo',
        loadMore: 'Charger Plus',
        categories: 'Catégories',
        ingredients: 'Ingrédients',
        filterBy: 'Filtrer par',
        all: 'Tous',
        recipes: 'recettes',
        Chicken: 'Poulet',
        Beef: 'Bœuf',
        Pork: 'Porc',
        Salmon: 'Saumon',
        Shrimp: 'Crevettes',
        Eggs: 'Œufs',
        Tofu: 'Tofu',
        Tuna: 'Thon',
        Potato: 'Pomme de terre',
        Rice: 'Riz',
        comments: 'Commentaires',
        addComment: 'Laissez un commentaire',
        noComments: 'Pas encore de commentaires. Soyez le premier !',
        submit: 'Envoyer',
        commentSubmitted: 'Commentaire publié !',
        errorSubmittingComment: "Erreur lors de la publication du commentaire.",
        backToWaiting: 'Retour',
        shoppingList: 'Liste de courses',
        addItem: 'Ajouter un article',
        add: 'Ajouter',
        clearList: 'Effacer la liste',
        addToShoppingList: 'Ajouter à la liste de courses',
        addedToShoppingList: 'Ingrédients ajoutés à la liste de courses !',
        quantity: 'Quantité',
        diet: 'Régime',
        selectDiet: 'Sélectionnez un régime',
        keto: 'Kéto',
        lowCarb: 'Faible en glucides',
        vegetarian: 'Végétarien',
        vegan: 'Végan',
        paleo: 'Paléo',
        mediterraneanDiet: 'Méditerranéen',
        dairyFree: 'Sans produits laitiers',
        glutenFree: 'Sans gluten',
        lowFat: 'Faible en matières grasses',
        highProtein: 'Riche en protéines',
        selectIngredients: 'Sélectionnez des ingrédients',
        chicken: 'Poulet',
        beef: 'Bœuf',
        pork: 'Porc',
        salmon: 'Saumon',
        shrimp: 'Crevettes',
        eggs: 'Œufs',
        tofu: 'Tofu',
        tuna: 'Thon',
        potato: 'Pomme de terre',
        rice: 'Riz',
        savedRecipes: "Recettes Enregistrées",
        filters: "Filtres",
        resetFilters: "Réinitialiser les Filtres",
        tryAgain: "Réessayer",
        searchRecipes: "Rechercher des recettes...",
        ingredients: "Ingrédients",
        allergens: "Allergènes",
        cookingTime: "Temps de Cuisson",
        addIngredient: "Ajouter un ingrédient",
        upTo: "Jusqu'à",
        errorFetchingRecipes: "Une erreur s'est produite lors de la récupération des recettes",
        // Database Recipes (Library 1) filters
        recipeLibraryTitle: "Bibliothèque de Recettes",
        recipesCount: "{count} recettes",
        searchPlaceholder: "Rechercher des recettes...",
        filterByLetter: "Filtrer par Lettre",
        allLetters: "Toutes",
        maxCalories: "Calories Max",
        caloriesUnit: "kcal",
        maxCookingTime: "Temps Max",
        minutesUnit: "min",
        servings: "Portions",
        minServings: "Portions Min",
        maxServings: "Portions Max",
        selectAllergens: "Sélectionner des Allergènes",
        typeToSearch: "Tapez pour rechercher...",
        selectNutritions: "Sélectionner des Nutriments",
        selectIngredients: "Sélectionner des Ingrédients",
        clearFilters: "Effacer les Filtres",
        noRecipesMatch: "Aucune recette ne correspond aux filtres",
        dairy: "Produits laitiers",
        soy: "Soja",
        shellfish: "Fruits de mer",
        fish: "Poisson",
        showFilters: "Afficher les Filtres",
        hideFilters: "Masquer les Filtres",
        viewAllRecipes: "Voir Toutes les Recettes",
        budgetFriendlyCooking: "Cuisine Économique",
        budgetFriendlyDescription: "Créez des repas délicieux et économiques avec 'sous-chaif' en utilisant des recettes personnalisées basées sur vos ingrédients et préférences.",
        customRecipeSuggestions: "Suggestions de Recettes Personnalisées",
        customRecipeDescription: "Partagez vos ingrédients, préférences et objectifs alimentaires, et 'sous-chaif' vous fournira des recettes personnalisées.",
        secureAndEasy: "Sécurisé et Facile",
        secureAndEasyDescription: "Vos données sont sécurisées avec nous. Profitez d'un accès facile aux recettes personnalisées et aux conseils de cuisine.",
        featureWelcomeTitle: "Bienvenue sur Souschaif !",
        featureWelcomeSubtitle: "Téléchargez une photo de vos ingrédients ou de votre frigo et recevez des recettes instantanément. Vous pouvez fermer cette fenêtre à tout moment.",
        featureWelcomeGotIt: "Compris",
        featureWelcomeMainBadge: "Le plus important",
        featureWelcomePhotoTitle: "Télécharger une photo d'ingrédients ou de frigo",
        featureWelcomePhotoDescription: "Prenez ou téléchargez une photo et recevez des recettes personnalisées selon ce que vous avez chez vous.",
        featureWelcomeChatDescription: "Posez vos questions de cuisine à notre chef IA et recevez des conseils personnalisés instantanément.",
        featureWelcomeLibraryDescription: "Parcourez des centaines de recettes et filtrez par ingrédients, allergènes et temps de cuisson.",
        featureWelcomeShoppingDescription: "Créez automatiquement une liste de courses à partir de vos recettes.",
        smartShoppingList: "Liste de courses intelligente",
        smartShoppingListDescription: "Générez des listes de courses à partir de vos recettes favorites.",
        usernameOrMobile: "Nom d'utilisateur ou Numéro mobile",
        rememberMe: "Se souvenir de moi",
        logIn: "Connexion",
        signingIn: "Connexion en cours...",
        noAccount: "Vous n'avez pas de compte ?",
        signUp: "S'inscrire",
        next: "Suivant",
        skip: "Passer",
        notSubscribed: "Vous n'êtes pas abonné à ce service",
        loginError: "Impossible de vérifier votre abonnement. Veuillez réessayer plus tard",
        signup: "S'inscrire",
        signupIntro: "Créez votre compte pour commencer",
        username: "Nom d'utilisateur",
        password: "Mot de passe",
        confirmPassword: "Confirmer le mot de passe",
        email: "Adresse e-mail",
        mobileNumber: "Numéro mobile",
        signupButton: "Créer un compte",
        signupError: "Erreur lors de l'inscription",
        alreadySubscribed: "Déjà abonné?",
        clickHere: "Cliquez ici",
        signupSuccess: "Compte créé avec succès",
        passwordRequirements: "Exigences du mot de passe",
        minLength: "Minimum 8 caractères",
        requireUppercase: "Au moins une lettre majuscule",
        requireLowercase: "Au moins une lettre minuscule",
        requireNumber: "Au moins un chiffre",
        requireSpecial: "Au moins un caractère spécial",
        passwordsMatch: "Les mots de passe correspondent",
        passwordRequirementsNotMet: "Veuillez respecter toutes les exigences du mot de passe",
        profile: "Profil",
        savedRecipes: "Recettes Sauvegardées",
        userData: "Données Utilisateur",
        basicInformation: "Informations de Base",
        username: "Nom d'Utilisateur",
        email: "E-mail",
        mobileNumber: "Numéro Mobile",
        password: "Mot de Passe",
        newPassword: "Nouveau Mot de Passe",
        leaveEmptyToKeep: "Laisser vide pour garder le mot de passe actuel",
        saveChanges: "Enregistrer les Modifications",
        changesSaved: "Modifications enregistrées avec succès",
        subscriptionInformation: "Informations d'Abonnement",
        sessionId: "ID de Session",
        createdAt: "Compte Créé",
        lastBillingDate: "Dernière Date de Facturation",
        nextBillingDate: "Prochaine Date de Facturation",
        subscriptionStarted: "Abonnement Démarré",
        timesBilled: "Fois Facturé",
        serviceName: "Nom du Service",
        termsAndConditions: "Termes et Conditions",
        viewTermsAndConditions: "Voir les Termes et Conditions",
        errorFetchingUserData: "Erreur lors de la récupération des données",
        errorUpdatingUser: "Erreur lors de la mise à jour des données",
        noSavedRecipes: "Pas encore de recettes sauvegardées",
        minutes: "minutes",
        servings: "portions",
        confirmUnsubscribe: "Confirmer la désinscription",
        confirmUnsubscribeMessage: "Êtes-vous sûr de vouloir vous désabonner ?",
        confirmPasswordChange: "Confirmer le changement de mot de passe",
        confirmPasswordChangeMessage: "Êtes-vous sûr de vouloir changer votre mot de passe ?",
        yes: "Oui",
        cancel: "Annuler",
        continentEurope: 'Europe',
        continentMiddleEast: 'Moyen-Orient',
        continentAsia: 'Asie',
        continentAfrica: 'Afrique',
        continentNorthAmerica: 'Amérique du Nord',
        continentSouthAmerica: 'Amérique du Sud',
        continentOceania: 'Océanie',
        backToContinents: 'Retour aux Continents',
        downloadRecipe: 'Télécharger la recette',
        pdfDownloaded: 'PDF téléchargé avec succès !',
        errorDownloadingPdf: 'Erreur lors du téléchargement du PDF.',
        random: 'Aléatoire',
        mostCommented: 'Plus Commentées',
        mostLiked: 'Plus Aimées',
        newest: 'Plus Récentes',
        quickest: 'Plus Rapides',
        lowestCalories: 'Moins de Calories',
        audioFetched: "L'audio est prêt à être lu.",
        errorFetchingAudio: "Erreur lors de la récupération de l'audio. Veuillez réessayer.",
        loadingAudio: "Chargement de l'audio...",
        winePairings: 'Accords Mets-Vins',
        errorWinePairing: "Impossible d'obtenir les suggestions de vins. Veuillez réessayer.",
        sharedOn: 'Recette partagée sur',
        copiedToClipboard: 'Recette copiée dans le presse-papiers !',
        shareError: 'Impossible de partager la recette.',
        photoTip: 'Pour de meilleurs résultats, téléchargez une photo claire de vos ingrédients ou d\'un plat.',
        noFoodDetected: "Aucun aliment ou ingrédient n'a été détecté sur votre photo. Veuillez réessayer avec une photo d'ingrédients ou d'un plat.",
        errorCompressingImage: "Erreur lors de la compression de l'image. Essayez une photo plus petite.",
        askingAboutCookbook: 'Questions sur le livre de cuisine :',
        askingAboutRecipe: 'Questions sur la recette :',
        submit: 'Envoyer',
        noComments: 'Pas encore de commentaires. Soyez le premier !',
        comparePrices: 'Comparer les Prix des Supermarchés',
        comparingPrices: 'Comparaison des prix...',
        pricesFor: 'Prix pour',
        priceComparison: 'Comparaison de Prix',
        estimate: 'estimation',
        potentialSavings: 'Économie potentielle',
        cheapestAt: 'Moins cher chez',
        cheapest: 'Moins cher',
        priceDisclaimer: 'Les prix sont des estimations IA et peuvent différer des prix réels en magasin.',
        budget: 'Économique',
        midRange: 'Milieu de gamme',
        premium: 'Premium',
        clearListConfirmTitle: 'Vider la liste de courses ?',
        clearListConfirmText: 'Cela supprimera tous les articles de votre liste. Cette action est irréversible.',
        allergyPreferences: 'Préférences d\'allergie',
        allergyPreferencesDescription: 'Sélectionnez vos allergènes ci-dessous. Les recettes les contenant seront masquées des recommandations.',
        savePreferences: 'Enregistrer les préférences',
        saving: 'Enregistrement...',
        preferencesSaved: 'Préférences d\'allergie enregistrées !',
        errorSavingPreferences: 'Erreur lors de l\'enregistrement des préférences',
    },
    serbian: {
        and: "i",
        validateWeight: "Težina mora biti između",
        validateHeight: "Visina mora biti između",
        nutritionGoals: "Nutricioni ciljevi",
        safetyAndDisclaimer: "Sigurnost & Odricanje od odgovornosti",
        safetyAndDisclaimerText: "Ciljevi su procene i ne zamenjuju profesionalni medicinski, nutricionistički ili dijetetski savet. Ako imate zdravstvenih problema, obratite se zdravstvenom stručnjaku.",
        male: "Muško",
        female: "Žensko",
        other: "Ostalo",
        allowed: "Dozvoljeno",
        pleaseEnterAWeight: "Unesite težinu",
        pleaseEnterAHeight: "Unesite visinu",
        calories: "Kalorije",
        protein: "Proteini",
        fat: "Masti",
        carbs: "Ugljeni hidrati",
        sex: "Pol",
        age: "Godine",
        weight: "Težina",
        height: "Visina",
        activity: "Aktivnost",
        goal: "Cilj",
        computeGoals: "Izračunaj ciljeve",
        light: "Lagano",
        moderate: "Umereno",
        veryActive: "Vrlo aktivno",
        extraActive: "Izuzetno aktivno",
        lose: "Izgubiti",
        maintain: "Održavati",
        gain: "Dobiti",
        dailyTargets: "Dnevni ciljevi",
        unableToFetchPrices: 'Није могуће преузети цене за валуту',
        loadingPrices: 'Учитавање цена',
        currency: 'Валута',
        latestMarketPrices: 'Најновије тржишне цене',
        countryCurrency: 'RSD',
        startScan: 'Покрени скенирање',
        scanAnother: 'Скенирај још један',
        scanning: 'Скенирање',
        vitaminD: 'Витамин Д',
        salt: 'Со',
        protein: 'Протеини',
        fiber: 'Влакна',
        addedSugars: 'Додати шећери',
        sugars: 'Шећери',
        saturatedFat: 'Засићене масти',
        fat: 'Дебело',
        energy: 'Енергија',
        amount: 'Износ',
        productNutrient: 'Хранљива материја',
        productNutritionalValuesPer100g: 'Нутритивна вредност (на 100 г)',
        productIngredients: 'Састојци',
        productNutriScore: 'Нутри-скор',
        productBrand: 'Бренд',
        scanYourProductBarcode: 'Скенирајте баркод вашег производа!',
        productLookupFailed: 'Претрага производа није успела',
        productNotFoundError: 'Производ није пронађен',
        cameraFailedStartError: 'Камера се није покренула',
        profile: 'Profil',
        basicInformation: 'Osnovne informacije',
        savedRecipes: 'Sačuvani recepti',
        noSavedRecipes: 'Nemate sačuvanih recepata.',
        userData: 'Korisnički podaci',
        recipeRemoved: 'Recept {recipeName} je uklonjen iz vaših favorita.',
        username: 'Korisničko ime',
        mobileNumber: 'Broj telefona',
        password: 'Lozinka',
        saveChanges: 'Sačuvaj promene',
        changesSaved: 'Vaše promene su sačuvane.',
        subscriptionInformation: 'Informacije o pretplati',
        lastBillingDate: 'Datum poslednjeg plaćanja',
        nextBillingDate: 'Datum sledećeg plaćanja',
        unsubscribe: 'Otkaži pretplatu',
        unsubscribed: 'Pretplata je otkazana.',
        selectLanguage: 'Izaberite jezik',
        whatToDo: 'Šta želite da uradite?',
        takePhoto: 'Fotografiši',
        uploadPhoto: 'Otpremi fotografiju',
        pleaseAddPhotoFirst: 'Molimo prvo dodajte fotografiju ili napravite fotografiju',
        uploading: 'Kreiramo vaše personalizovane recepte...',
        loadingTime: 'Ovo može potrajati do 1 minut...',
        analyzing: 'AI analizira vašu fotografiju...',
        aiAnalysisResult: 'Rezultat AI analize:',
        uploadError: 'Došlo je do greške prilikom otpremanja slike.',
        processingError: 'Došlo je do greške prilikom obrade slike.',
        numberOfPeople: 'Broj osoba',
        timeOfDay: 'Doba dana',
        selectTimeOfDay: 'Izaberite doba dana',
        breakfast: 'Doručak',
        morningSnack: 'Jutarnja užina',
        lunch: 'Ručak',
        afternoonSnack: 'Popodnevna užina',
        dinner: 'Večera',
        dessert: 'Desert',
        lateNightSnack: 'Kasna večera',
        preferredCuisine: 'Željena kuhinja',
        selectCuisine: 'Izaberite kuhinju',
        italian: 'Italijanska',
        chinese: 'Kineska',
        indian: 'Indijska',
        mexican: 'Meksička',
        french: 'Francuska',
        thai: 'Tajlandska',
        japanese: 'Japanska',
        mediterranean: 'Mediteranska',
        spanish: 'Španska',
        greek: 'Grčka',
        vietnamese: 'Vijetnamska',
        american: 'Američka',
        turkish: 'Turska',
        korean: 'Korejska',
        moroccan: 'Marokanska',
        persian: 'Persijska',
        allergies: 'Alergije',
        selectAllergies: 'Izaberite alergije',
        gluten: 'Gluten',
        nuts: 'Orašasti plodovi',
        lactose: 'Laktoza',
        soy: 'Soja',
        shellfish: 'Školjke',
        fish: 'Riba',
        eggs: 'Jaja',
        peanuts: 'Kikiriki',
        sesame: 'Susam',
        sulphites: 'Sulfiti',
        mustard: 'Senf',
        celery: 'Celer',
        lupin: 'Lupina',
        molluscs: 'Mekušci',
        cookingTime: 'Vreme pripreme',
        cookingTip: 'Savet za kuvanje:',
        minutes: 'minuta',
        caloriesPerServing: 'Kalorije po porciji',
        servings: 'porcije',
        allergens: 'Alergeni',
        ingredients: 'Sastojci',
        instructions: 'Uputstva',
        askQuestion: 'Postaviti pitanje',
        recipeLibrary: 'Biblioteka recepata',
        loadMore: 'Učitaj više',
        loadNewRandomRecipes: 'Učitaj više recepata',
        loadingRecipes: 'Učitavanje {count} recepata...',
        viewRecipe: 'Pogledaj recept',
        noResultsFound: 'Nema pronađenih rezultata',
        search: 'Otpremi sliku',
        decrease: 'Smanji',
        increase: 'Povećaj',
        uploading: 'Otpremanje',
        elapsedTime: 'Proteklo vreme',
        seconds: 'sekundi',
        cameraNotSupported: 'Kamera nije podržana na ovom uređaju',
        nutritions: 'Nutritivne vrednosti',
        calories: 'Kalorije',
        protein: 'Proteini',
        carbs: 'Ugljeni hidrati',
        fat: 'Masti',
        fiber: 'Vlakna',
        sugar: 'Šećer',
        sodium: 'Natrijum',
        vitamina: 'Vitamin A',
        vitaminc: 'Vitamin C',
        calcium: 'Kalcijum',
        iron: 'Gvožđe',
        recipeDetails: 'Detalji recepta',
        loadMore: 'Učitaj još recepata',
        recipeAlreadySaved: 'Recept je već sačuvan.',
        recipeSaved: 'Recept je uspešno sačuvan.',
        errorSavingRecipe: 'Greška pri čuvanju recepta. Pokušajte ponovo.',
        recipeShared: 'Recept je podeljen putem {platform}!',
        defaultSaveMessage: 'Akcija je uspešno završena!',
        share: 'Podeli',
        favorite: 'Omiljeno',
        close: 'Zatvori',
        whatsapp: 'WhatsApp',
        facebook: 'Facebook',
        twitter: 'Twitter',
        email: 'Email',
        loading: 'Učitavanje novih recepata...',
        tetrisTitle: 'Igrajte Tetris dok čekate!',
        score: 'Rezultat',
        highScore: 'Najbolji rezultat',
        gameOver: 'Kraj igre',
        playAgain: 'Igraj ponovo',
        left: 'Levo',
        right: 'Desno',
        down: 'Dole',
        rotate: 'Rotiraj',
        startTetris: 'Igraj Tetris',
        stopOrContinueTetris: 'Recepti su učitani. Želite li da prekinete Tetris i pogledate recepte?',
        continueTetris: 'Nastavi Tetris',
        playTetris: 'Igraj Tetris',
        viewRecipes: 'Pogledaj recepte',
        recipesLoaded: 'SousChaif je spreman sa vašim receptima!',
        capturePhoto: 'Fotografiši',
        closeCamera: 'Zatvori kameru',
        pictureIngredients: 'Fotografiši sastojke',
        previewImage: 'Odobri sliku',
        retake: 'Ponovi',
        approve: 'Pošalji',
        waitingNotice: 'Igrajte igru dok čekate.',
        name: 'Ime',
        email: 'Email',
        newSearchQuestion: 'Pretraži nove recepte?',
        newSearchPrompt: 'Želite li da pretražite nove recepte ili pogledate prethodne rezultate?',
        searchNewRecipes: 'Pretraži nove recepte',
        seeOldRecipes: 'Pogledaj',
        chatBotIntro: 'Dobrodošli, ja sam SousChaif. Kako vam mogu pomoći danas?',
        chatWithSousChaif: 'Razgovarajte sa SousChaif-om',
        typeYourMessage: 'Upišite vašu poruku...',
        recipeLoaded: 'Recept je učitan',
        askAboutRecipe: 'Pitajte o receptu',
        errorFetchingData: 'Došlo je do greške pri preuzimanju podataka.',
        whatQuestionWouldYouLikeToAsk: 'Koje pitanje želite da postavite?',
        welcomeBack: 'Dobrodošli nazad',
        needHelpWithRecipe: 'Potrebna pomoć pri kuvanju?',
        viewRecipesHome: 'Postavite pitanje',
        popularIngredients: 'Popularni sastojci',
        popularCookbooks: 'Popularne kuvarice',
        browseByLetter: 'Pretraži po slovu',
        videoRecipes: 'Video Recepti',
        recipesByLetter: 'Recepti po slovu',
        noRecipesFound: 'Nema pronađenih recepata',
        watchVideo: 'Pogledaj video',
        loadMore: 'Učitaj Više',
        categories: 'Kategorije',
        ingredients: 'Sastojci',
        filterBy: 'Filtriraj po',
        all: 'Svi',
        recipes: 'recepti',
        comments: 'Komentari',
        addComment: 'Ostavite komentar',
        noComments: 'Još nema komentara. Budite prvi!',
        submit: 'Pošalji',
        commentSubmitted: 'Komentar je objavljen!',
        errorSubmittingComment: 'Greška pri objavljivanju komentara.',
        backToWaiting: 'Nazad',
        shoppingList: 'Lista za kupovinu',
        addItem: 'Dodaj stavku',
        add: 'Dodaj',
        clearList: 'Očisti listu',
        addToShoppingList: 'Dodaj na listu za kupovinu',
        addedToShoppingList: 'Sastojci su dodati na listu za kupovinu!',
        quantity: 'Količina',
        diet: 'Ishrana',
        selectDiet: 'Izaberite režim ishrane',
        keto: 'Keto',
        lowCarb: 'Nizak unos ugljenih hidrata',
        vegetarian: 'Vegetarijanska',
        vegan: 'Veganska',
        paleo: 'Paleo',
        mediterraneanDiet: 'Mediteranska',
        dairyFree: 'Bez mlečnih proizvoda',
        glutenFree: 'Bez glutena',
        lowFat: 'Nizak unos masti',
        highProtein: 'Visok unos proteina',
        selectIngredients: 'Izaberite sastojke',
        chicken: 'Piletina',
        beef: 'Govedina',
        pork: 'Svinjetina',
        salmon: 'Losos',
        shrimp: 'Škampi',
        tofu: 'Tofu',
        tuna: 'Tuna',
        potato: 'Krompir',
        rice: 'Pirinač',
        savedRecipes: "Sačuvani recepti",
        filters: "Filteri",
        resetFilters: "Resetuj filtere",
        tryAgain: "Pokušaj ponovo",
        searchRecipes: "Pretraži recepte...",
        ingredients: "Sastojci",
        allergens: "Alergeni",
        cookingTime: "Vreme pripreme",
        addIngredient: "Dodaj sastojak",
        upTo: "Do",
        errorFetchingRecipes: "Došlo je do greške pri preuzimanju recepata",
        budgetFriendlyCooking: "Kuvanje za mali budžet",
        budgetFriendlyDescription: "Napravite ukusne, pristupačne obroke sa 'sous-chaif' koristeći personalizovane recepte zasnovane na vašim sastojcima i preferencijama.",
        customRecipeSuggestions: "Prilagođeni predlozi recepata",
        customRecipeDescription: "Podelite svoje sastojke, preferencije i ciljeve u ishrani, a 'sous-chaif' će vam pružiti personalizovane recepte.",
        secureAndEasy: "Sigurno i jednostavno",
        secureAndEasyDescription: "Vaši podaci su sigurni kod nas. Uživajte u lakom pristupu personalizovanim receptima i savetima za kuvanje.",
        featureWelcomeTitle: "Dobrodošli u Souschaif!",
        featureWelcomeSubtitle: "Otpremite fotografiju sastojaka ili frižidera i odmah dobijte recepte. Možete zatvoriti ovaj prozor u bilo kom trenutku.",
        featureWelcomeGotIt: "Razumem",
        featureWelcomeMainBadge: "Najvažnije",
        featureWelcomePhotoTitle: "Otpremite fotografiju sastojaka ili frižidera",
        featureWelcomePhotoDescription: "Slikajte ili otpremite fotografiju i odmah dobijte recepte na osnovu onoga što imate kod kuće.",
        featureWelcomeChatDescription: "Postavite pitanja našem AI kuvaru i odmah dobijte personalizovane savete.",
        featureWelcomeLibraryDescription: "Pregledajte stotine recepata i filtrirajte po sastojcima, alergenima i vremenu kuvanja.",
        featureWelcomeShoppingDescription: "Automatski napravite listu za kupovinu na osnovu vaših recepata.",
        smartShoppingList: "Pametna lista za kupovinu",
        smartShoppingListDescription: "Generišite liste za kupovinu na osnovu vaših omiljenih recepata.",
        usernameOrMobile: "Korisničko ime ili broj telefona",
        rememberMe: "Zapamti me",
        logIn: "Prijava",
        noAccount: "Nemate nalog?",
        signUp: "Registrujte se",
        next: "Dalje",
        skip: "Preskoči",
        notSubscribed: 'Niste pretplaćeni na ovu uslugu',
        loginError: 'Nije moguće verifikovati vašu pretplatu. Pokušajte ponovo kasnije',
        signup: "Registracija",
        signupIntro: "Napravite nalog da biste započeli",
        username: "Korisničko ime",
        password: "Lozinka",
        confirmPassword: "Potvrdi lozinku",
        email: "Imejl adresa",
        mobileNumber: "Mobilni broj",
        signupButton: "Napravi nalog",
        signupError: "Greška pri registraciji",
        alreadySubscribed: "Već ste prijavljeni?",
        clickHere: "Kliknite ovde",
        signupSuccess: "Nalog uspešno kreiran",
        passwordRequirements: "Zahtevi za lozinku",
        minLength: "Najmanje 8 karaktera",
        requireUppercase: "Najmanje jedno veliko slovo",
        requireLowercase: "Najmanje jedno malo slovo",
        requireNumber: "Najmanje jedan broj",
        requireSpecial: "Najmanje jedan specijalni karakter",
        passwordsMatch: "Lozinke se podudaraju",
        passwordRequirementsNotMet: "Ispunite sve zahteve za lozinku",
        profile: "Profil",
        savedRecipes: "Sačuvani Recepti",
        userData: "Korisnički Podaci",
        basicInformation: "Osnovne Informacije",
        username: "Korisničko Ime",
        email: "Email",
        mobileNumber: "Mobilni Broj",
        password: "Lozinka",
        newPassword: "Nova Lozinka",
        leaveEmptyToKeep: "Ostavite prazno da zadržite trenutnu lozinku",
        saveChanges: "Sačuvaj Izmene",
        changesSaved: "Izmene uspešno sačuvane",
        subscriptionInformation: "Informacije o Pretplati",
        sessionId: "ID Sesije",
        createdAt: "Nalog Kreiran",
        lastBillingDate: "Datum Poslednje Naplate",
        nextBillingDate: "Datum Sledeće Naplate",
        errorFetchingUserData: "Greška pri preuzimanju podataka",
        errorUpdatingUser: "Greška pri ažuriranju podataka",
        noSavedRecipes: "Još nema sačuvanih recepata",
        minutes: "minuta",
        servings: "porcija",
        confirmUnsubscribe: "Potvrdi odjavu",
        confirmUnsubscribeMessage: "Da li ste sigurni da želite da se odjavite?",
        confirmPasswordChange: "Potvrdi promenu lozinke",
        confirmPasswordChangeMessage: "Da li ste sigurni da želite da promenite lozinku?",
        yes: "Da",
        cancel: "Otkaži",
        continentEurope: 'Evropa',
        continentMiddleEast: 'Bliski Istok',
        continentAsia: 'Azija',
        continentAfrica: 'Afrika',
        continentNorthAmerica: 'Severna Amerika',
        continentSouthAmerica: 'Južna Amerika',
        continentOceania: 'Okeanija',
        backToContinents: 'Nazad na Kontinente',
        // Database Recipes (Library 1) filters
        recipeLibraryTitle: "Biblioteka Recepata",
        recipesCount: "{count} recepata",
        searchPlaceholder: "Pretraži recepte...",
        filterByLetter: "Filtriraj po Slovu",
        allLetters: "Svi",
        maxCalories: "Max Kalorije",
        caloriesUnit: "kcal",
        maxCookingTime: "Max Vreme",
        minutesUnit: "min",
        minServings: "Min Porcije",
        maxServings: "Max Porcije",
        selectAllergens: "Izaberi Alergene",
        typeToSearch: "Kucaj za pretragu...",
        selectNutritions: "Izaberi Nutritivne vrednosti",
        selectIngredients: "Izaberi Sastojke",
        clearFilters: "Obriši Filtere",
        noRecipesMatch: "Nema recepata koji odgovaraju filterima",
        dairy: "Mlečni proizvodi",
        showFilters: "Prikaži Filtere",
        hideFilters: "Sakrij Filtere",
        viewAllRecipes: "Prikaži Sve Recepte",
        filters: "Filteri",
        resetFilters: "Resetuj Filtere",
        tryAgain: "Pokušaj Ponovo",
        searchRecipes: "Pretraži recepte...",
        addIngredient: "Dodaj sastojak",
        upTo: "Do",
        errorFetchingRecipes: "Greška prilikom preuzimanja recepata",
        downloadRecipe: 'Preuzmi recept',
        pdfDownloaded: 'PDF uspješno preuzet!',
        errorDownloadingPdf: 'Greška prilikom preuzimanja PDF-a.',
        random: 'Nasumično',
        mostCommented: 'Najkomentarisanije',
        mostLiked: 'Najomiljenije',
        newest: 'Najnovije',
        quickest: 'Najbrže',
        lowestCalories: 'Najmanje Kalorija',
        audioFetched: 'Audio je spreman za reprodukciju.',
        errorFetchingAudio: 'Greška pri preuzimanju zvuka. Pokušajte ponovo.',
        loadingAudio: 'Učitavanje zvuka...',
        winePairings: 'Preporuke Vina',
        errorWinePairing: 'Nije moguće dobiti preporuke vina. Pokušajte ponovo.',
        sharedOn: 'Recept podeljen na',
        copiedToClipboard: 'Recept kopiran u međuspremnik!',
        shareError: 'Nije moguće podeliti recept.',
        photoTip: 'Za najbolje rezultate, otpremite jasnu fotografiju sastojaka ili jela.',
        noFoodDetected: 'Na vašoj fotografiji nisu otkriveni hrana ili sastojci. Pokušajte ponovo sa fotografijom sastojaka ili jela.',
        errorCompressingImage: 'Greška pri kompresiji slike. Pokušajte sa manjom fotografijom.',
        askingAboutCookbook: 'Pitanja o knjizi recepata:',
        askingAboutRecipe: 'Pitanja o receptu:',
        submit: 'Pošalji',
        noComments: 'Još nema komentara. Budite prvi koji komentariše!',
        comparePrices: 'Uporedi Cene u Supermarketima',
        comparingPrices: 'Upoređivanje cena...',
        pricesFor: 'Cene za',
        priceComparison: 'Poređenje Cena',
        estimate: 'procena',
        potentialSavings: 'Moguća ušteda',
        cheapestAt: 'Najjeftinije u',
        cheapest: 'Najjeftinije',
        priceDisclaimer: 'Cene su AI procene i mogu se razlikovati od stvarnih cena u prodavnicama.',
        budget: 'Povoljno',
        midRange: 'Srednji rang',
        premium: 'Premium',
        clearListConfirmTitle: 'Obrisati listu za kupovinu?',
        clearListConfirmText: 'Ovo će ukloniti sve stavke sa vaše liste. Ova radnja se ne može poništiti.',
        allergyPreferences: 'Podešavanja alergija',
        allergyPreferencesDescription: 'Izaberite alergene ispod. Recepti koji ih sadrže biće sakriveni iz preporuka.',
        savePreferences: 'Sačuvaj podešavanja',
        saving: 'Čuvanje...',
        preferencesSaved: 'Podešavanja alergija sačuvana!',
        errorSavingPreferences: 'Greška pri čuvanju podešavanja',
    },
    romanian: {
        and: "și",
        validateWeight: "Greutatea trebuie să fie între",
        validateHeight: "Înălțimea trebuie să fie între",
        nutritionGoals: "Obiective nutriționale",
        safetyAndDisclaimer: "Siguranță & Declarație de limitare a răspunderii",
        safetyAndDisclaimerText: "Țintele sunt estimări și nu înlocuiesc sfatul medical, nutrițional sau dietetic profesionist. Dacă aveți probleme de sănătate, consultați un profesionist din domeniul sănătății.",
        male: "Masculin",
        female: "Feminin",
        other: "Altul",
        allowed: "Permis",
        pleaseEnterAWeight: "Vă rugăm introduceți o greutate",
        pleaseEnterAHeight: "Vă rugăm introduceți o înălțime",
        calories: "Calorii",
        protein: "Proteine",
        fat: "Grăsimi",
        carbs: "Carbohidrați",
        sex: "Sex",
        age: "Vârstă",
        weight: "Greutate",
        height: "Înălțime",
        activity: "Activitate",
        goal: "Obiectiv",
        computeGoals: "Calculează obiectivele",
        light: "Ușor",
        moderate: "Moderat",
        veryActive: "Foarte activ",
        extraActive: "Extrem de activ",
        lose: "Slăbi",
        maintain: "Menține",
        gain: "Câștigă",
        dailyTargets: "Ținte zilnice",
        unableToFetchPrices: 'Nem sikerült lekérni az árakat a pénznemhez',
        loadingPrices: 'Se încarcă prețurile',
        currency: 'Valută',
        latestMarketPrices: 'Ultimele prețuri de piață',
        countryCurrency: 'RON',
        startScan: 'Începeți scanarea',
        scanAnother: 'Scanează altul',
        scanning: 'Scanare',
        vitaminD: 'Vitamina D',
        salt: 'Sare',
        protein: 'Proteină',
        fiber: 'Fibră',
        addedSugars: 'Zaharuri adăugate',
        sugars: 'Zaharuri',
        saturatedFat: 'Grăsimi saturate',
        fat: 'Grăsime',
        energy: 'Energie',
        amount: 'Cantitate',
        productNutrient: 'Nutrient',
        productNutritionalValuesPer100g: 'Valoare nutrițională (la 100g)',
        productIngredients: 'Ingrediente',
        productNutriScore: 'Nutri-Score',
        productBrand: 'Marca',
        scanYourProductBarcode: 'Scanați codul de bare al produsului dvs.!',
        productLookupFailed: 'Căutarea produsului a eșuat',
        productNotFoundError: 'Produs negăsit',
        cameraFailedStartError: 'Camera nu a putut porni',
        profile: 'Profil',
        basicInformation: 'Informații de bază',
        savedRecipes: 'Rețete salvate',
        noSavedRecipes: 'Nu aveți rețete salvate.',
        userData: 'Date utilizator',
        recipeRemoved: 'Rețeta {recipeName} a fost eliminată din favorite.',
        username: 'Nume utilizator',
        mobileNumber: 'Număr de telefon',
        password: 'Parolă',
        saveChanges: 'Salvează modificările',
        changesSaved: 'Modificările au fost salvate.',
        subscriptionInformation: 'Informații despre abonament',
        lastBillingDate: 'Ultima dată de facturare',
        nextBillingDate: 'Următoarea dată de facturare',
        unsubscribe: 'Dezabonare',
        unsubscribed: 'V-ați dezabonat.',
        selectLanguage: 'Selectați limba',
        whatToDo: 'Ce doriți să faceți?',
        takePhoto: 'Faceți o fotografie',
        uploadPhoto: 'Încărcați o fotografie',
        pleaseAddPhotoFirst: 'Vă rugăm să adăugați mai întâi o fotografie sau să faceți o fotografie',
        uploading: 'Se creează rețetele personalizate...',
        loadingTime: 'Acest lucru poate dura până la 1 minut...',
        analyzing: 'AI analizează fotografia...',
        aiAnalysisResult: 'Rezultatul analizei AI:',
        uploadError: 'A apărut o eroare la încărcarea imaginii.',
        processingError: 'A apărut o eroare la procesarea imaginii.',
        numberOfPeople: 'Număr de persoane',
        timeOfDay: 'Momentul zilei',
        selectTimeOfDay: 'Selectați momentul zilei',
        breakfast: 'Mic dejun',
        morningSnack: 'Gustare de dimineață',
        lunch: 'Prânz',
        afternoonSnack: 'Gustare de după-amiază',
        dinner: 'Cină',
        dessert: 'Desert',
        lateNightSnack: 'Gustare de noapte',
        preferredCuisine: 'Bucătărie preferată',
        selectCuisine: 'Selectați bucătăria',
        italian: 'Italiană',
        chinese: 'Chineză',
        indian: 'Indiană',
        mexican: 'Mexicană',
        french: 'Franceză',
        thai: 'Thailandeză',
        japanese: 'Japoneză',
        mediterranean: 'Mediteraneană',
        spanish: 'Spaniolă',
        greek: 'Grecească',
        vietnamese: 'Vietnameză',
        american: 'Americană',
        turkish: 'Turcească',
        korean: 'Coreeană',
        moroccan: 'Marocană',
        persian: 'Persană',
        allergies: 'Alergii',
        selectAllergies: 'Selectați alergiile',
        gluten: 'Gluten',
        nuts: 'Nuci',
        lactose: 'Lactoză',
        soy: 'Soia',
        shellfish: 'Crustacee',
        fish: 'Pește',
        eggs: 'Ouă',
        peanuts: 'Arahide',
        sesame: 'Susan',
        sulphites: 'Sulfiți',
        mustard: 'Muștar',
        celery: 'Țelină',
        lupin: 'Lupin',
        molluscs: 'Moluște',
        cookingTime: 'Timp de preparare',
        cookingTip: 'Sfat de gătit:',
        minutes: 'minute',
        caloriesPerServing: 'Calorii per porție',
        servings: 'porții',
        allergens: 'Alergeni',
        ingredients: 'Ingrediente',
        instructions: 'Instrucțiuni',
        askQuestion: 'Pune o întrebare',
        recipeLibrary: 'Biblioteca de rețete',
        loadMore: 'Încarcă mai multe',
        loadNewRandomRecipes: 'Încarcă mai multe rețete',
        loadingRecipes: 'Se încarcă {count} rețete...',
        viewRecipe: 'Vezi rețeta',
        noResultsFound: 'Nu s-au găsit rezultate',
        search: 'Încarcă imagine',
        decrease: 'Scade',
        increase: 'Crește',
        uploading: 'Se încarcă',
        elapsedTime: 'Timp scurs',
        seconds: 'secunde',
        cameraNotSupported: 'Camera nu este suportată pe acest dispozitiv',
        nutritions: 'Valori nutriționale',
        calories: 'Calorii',
        protein: 'Proteine',
        carbs: 'Carbohidrați',
        fat: 'Grăsimi',
        fiber: 'Fibre',
        sugar: 'Zahăr',
        sodium: 'Sodiu',
        vitamina: 'Vitamina A',
        vitaminc: 'Vitamina C',
        calcium: 'Calciu',
        iron: 'Fier',
        recipeDetails: 'Detalii rețetă',
        loadMore: 'Încarcă mai multe rețete',
        recipeAlreadySaved: 'Rețeta este deja salvată.',
        recipeSaved: 'Rețeta a fost salvată cu succes.',
        errorSavingRecipe: 'Eroare la salvarea rețetei. Încercați din nou.',
        recipeShared: 'Rețeta a fost distribuită pe {platform}!',
        defaultSaveMessage: 'Acțiunea a fost finalizată cu succes!',
        share: 'Distribuie',
        favorite: 'Favorite',
        close: 'Închide',
        whatsapp: 'WhatsApp',
        facebook: 'Facebook',
        twitter: 'Twitter',
        email: 'Email',
        loading: 'Se încarcă rețete noi...',
        tetrisTitle: 'Jucați Tetris în timp ce așteptați!',
        score: 'Scor',
        highScore: 'Scor maxim',
        gameOver: 'Joc terminat',
        playAgain: 'Joacă din nou',
        left: 'Stânga',
        right: 'Dreapta',
        down: 'Jos',
        rotate: 'Rotește',
        startTetris: 'Joacă Tetris',
        stopOrContinueTetris: 'Rețetele sunt încărcate. Doriți să opriți Tetris și să vedeți rețetele?',
        continueTetris: 'Continuă Tetris',
        playTetris: 'Joacă Tetris',
        viewRecipes: 'Vezi rețetele',
        recipesLoaded: 'SousChaif este gata cu rețetele tale!',
        capturePhoto: 'Fă o fotografie',
        closeCamera: 'Închide camera',
        pictureIngredients: 'Fotografiază ingredientele',
        previewImage: 'Aprobă imaginea',
        retake: 'Refă',
        approve: 'Trimite',
        waitingNotice: 'Jucați un joc în timp ce așteptați.',
        name: 'Nume',
        email: 'Email',
        newSearchQuestion: 'Căutați rețete noi?',
        newSearchPrompt: 'Doriți să căutați rețete noi sau să vedeți rezultatele anterioare?',
        searchNewRecipes: 'Caută rețete noi',
        seeOldRecipes: 'Vezi',
        chatBotIntro: 'Bine ați venit, sunt SousChaif. Cu ce vă pot ajuta astăzi?',
        chatWithSousChaif: 'Chat cu SousChaif',
        typeYourMessage: 'Scrieți mesajul...',
        recipeLoaded: 'Rețeta a fost încărcată',
        askAboutRecipe: 'Întreabă despre rețetă',
        errorFetchingData: 'A apărut o eroare la preluarea datelor.',
        whatQuestionWouldYouLikeToAsk: 'Ce întrebare doriți să puneți?',
        welcomeBack: 'Bine ați revenit',
        needHelpWithRecipe: 'Aveți nevoie de ajutor la gătit?',
        viewRecipesHome: 'Puneți o întrebare',
        popularIngredients: 'Ingrediente populare',
        popularCookbooks: 'Cărți de bucate populare',
        browseByLetter: 'Navighează după literă',
        videoRecipes: 'Rețete Video',
        recipesByLetter: 'Rețete după literă',
        noRecipesFound: 'Nu s-au găsit rețete',
        watchVideo: 'Urmărește video',
        loadMore: 'Încarcă Mai Mult',
        categories: 'Categorii',
        ingredients: 'Ingrediente',
        filterBy: 'Filtrează după',
        all: 'Toate',
        recipes: 'rețete',
        comments: 'Comentarii',
        addComment: 'Adăugați un comentariu',
        noComments: 'Încă nu există comentarii. Fiți primul!',
        submit: 'Trimite',
        commentSubmitted: 'Comentariul a fost publicat!',
        errorSubmittingComment: 'Eroare la publicarea comentariului.',
        backToWaiting: 'Înapoi',
        shoppingList: 'Listă de cumpărături',
        addItem: 'Adaugă articol',
        add: 'Adaugă',
        clearList: 'Șterge lista',
        addToShoppingList: 'Adaugă la lista de cumpărături',
        addedToShoppingList: 'Ingredientele au fost adăugate la lista de cumpărături!',
        quantity: 'Cantitate',
        diet: 'Dietă',
        selectDiet: 'Selectați dieta',
        keto: 'Keto',
        lowCarb: 'Carbohidrați reduși',
        vegetarian: 'Vegetarian',
        vegan: 'Vegan',
        paleo: 'Paleo',
        mediterraneanDiet: 'Mediteraneană',
        dairyFree: 'Fără lactate',
        glutenFree: 'Fără gluten',
        lowFat: 'Grăsimi reduse',
        highProtein: 'Proteine ridicate',
        selectIngredients: 'Selectați ingredientele',
        chicken: 'Pui',
        beef: 'Vită',
        pork: 'Porc',
        salmon: 'Somon',
        shrimp: 'Creveți',
        tofu: 'Tofu',
        tuna: 'Ton',
        potato: 'Cartof',
        rice: 'Orez',
        savedRecipes: "Rețete salvate",
        filters: "Filtre",
        resetFilters: "Resetează filtrele",
        tryAgain: "Încearcă din nou",
        searchRecipes: "Caută rețete...",
        ingredients: "Ingrediente",
        allergens: "Alergeni",
        cookingTime: "Timp de gătit",
        addIngredient: "Adaugă ingredient",
        upTo: "Până la",
        errorFetchingRecipes: "A apărut o eroare la preluarea rețetelor",
        budgetFriendlyCooking: "Gătit Economic",
        budgetFriendlyDescription: "Creați mese delicioase și economice cu 'sous-chaif' folosind rețete personalizate bazate pe ingredientele și preferințele dvs.",
        customRecipeSuggestions: "Sugestii de Rețete Personalizate",
        customRecipeDescription: "Împărtășiți ingredientele, preferințele și obiectivele dietetice, iar 'sous-chaif' vă va oferi rețete personalizate.",
        secureAndEasy: "Sigur și Ușor",
        secureAndEasyDescription: "Datele dvs. sunt în siguranță cu noi. Bucurați-vă de acces ușor la rețete personalizate și sfaturi de gătit.",
        featureWelcomeTitle: "Bun venit la Souschaif!",
        featureWelcomeSubtitle: "Încărcați o fotografie cu ingredientele sau frigiderul dvs. și primiți rețete instant. Puteți închide această fereastră oricând.",
        featureWelcomeGotIt: "Am înțeles",
        featureWelcomeMainBadge: "Cel mai important",
        featureWelcomePhotoTitle: "Încărcați o fotografie cu ingrediente sau frigiderul",
        featureWelcomePhotoDescription: "Faceți sau încărcați o fotografie și primiți rețete personalizate pe baza a ceea ce aveți acasă.",
        featureWelcomeChatDescription: "Puneți întrebări chef-ului nostru AI și primiți sfaturi personalizate instant.",
        featureWelcomeLibraryDescription: "Răsfoiți sute de rețete și filtrați după ingrediente, alergeni și timp de gătit.",
        featureWelcomeShoppingDescription: "Creați automat liste de cumpărături din rețetele dvs.",
        smartShoppingList: "Listă de cumpărături inteligentă",
        smartShoppingListDescription: "Generați liste de cumpărături pe baza rețetelor preferate.",
        usernameOrMobile: "Nume utilizator sau Număr mobil",
        rememberMe: "Ține-mă minte",
        logIn: "Conectare",
        noAccount: "Nu aveți cont?",
        signUp: "Înregistrare",
        next: "Următorul",
        skip: "Omite",
        notSubscribed: 'Nu sunteți abonat la acest serviciu',
        loginError: 'Nu se poate verifica abonamentul. Vă rugăm să încercați din nou mai târziu',
        signup: "Înregistrare",
        signupIntro: "Creează-ți cont pentru a începe",
        username: "Nume utilizator",
        password: "Parolă",
        confirmPassword: "Confirmă parola",
        email: "Adresă email",
        mobileNumber: "Număr mobil",
        signupButton: "Creează cont",
        signupError: "Eroare la înregistrare",
        alreadySubscribed: "Deja înregistrat?",
        clickHere: "Faceți clic aici",
        signupSuccess: "Cont creat cu succes",
        passwordRequirements: "Cerințe parolă",
        minLength: "Minim 8 caractere",
        requireUppercase: "Cel puțin o literă mare",
        requireLowercase: "Cel puțin o literă mică",
        requireNumber: "Cel puțin un număr",
        requireSpecial: "Cel puțin un caracter special",
        passwordsMatch: "Parolele corespund",
        passwordRequirementsNotMet: "Îndeplinește toate cerințele parolei",
        profile: "Profil",
        savedRecipes: "Rețete Salvate",
        userData: "Date Utilizator",
        basicInformation: "Informații de Bază",
        username: "Nume Utilizator",
        email: "Email",
        mobileNumber: "Număr Mobil",
        password: "Parolă",
        newPassword: "Parolă Nouă",
        leaveEmptyToKeep: "Lăsați gol pentru a păstra parola actuală",
        saveChanges: "Salvează Modificările",
        changesSaved: "Modificări salvate cu succes",
        subscriptionInformation: "Informații Abonament",
        sessionId: "ID Sesiune",
        createdAt: "Cont Creat",
        lastBillingDate: "Ultima Dată de Facturare",
        nextBillingDate: "Următoarea Dată de Facturare",
        errorFetchingUserData: "Eroare la obținerea datelor utilizatorului",
        errorUpdatingUser: "Eroare la actualizarea datelor utilizatorului",
        noSavedRecipes: "Încă nu există rețete salvate",
        minutes: "minute",
        servings: "porții",
        confirmUnsubscribe: "Confirmă dezabonarea",
        confirmUnsubscribeMessage: "Ești sigur că dorești să te dezabonezi?",
        confirmPasswordChange: "Confirmă schimbarea parolei",
        confirmPasswordChangeMessage: "Ești sigur că dorești să îți schimbi parola?",
        yes: "Da",
        cancel: "Anulează",
        // Database Recipes (Library 1) filters
        recipeLibraryTitle: "Bibliotecă de Rețete",
        recipesCount: "{count} rețete",
        searchPlaceholder: "Caută rețete...",
        filterByLetter: "Filtrează după Literă",
        allLetters: "Toate",
        maxCalories: "Calorii Maxime",
        caloriesUnit: "kcal",
        maxCookingTime: "Timp Maxim",
        minutesUnit: "min",
        minServings: "Porții Minime",
        maxServings: "Porții Maxime",
        selectAllergens: "Selectează Alergeni",
        typeToSearch: "Tastează pentru a căuta...",
        selectNutritions: "Selectează Nutrienți",
        selectIngredients: "Selectează Ingrediente",
        clearFilters: "Șterge Filtrele",
        noRecipesMatch: "Nicio rețetă nu corespunde filtrelor",
        dairy: "Produse lactate",
        showFilters: "Afișează Filtrele",
        hideFilters: "Ascunde Filtrele",
        viewAllRecipes: "Vezi Toate Rețetele",
        filters: "Filtre",
        resetFilters: "Resetează Filtrele",
        tryAgain: "Încearcă Din Nou",
        searchRecipes: "Caută rețete...",
        addIngredient: "Adaugă ingredient",
        upTo: "Până la",
        errorFetchingRecipes: "A apărut o eroare la preluarea rețetelor",
        continentEurope: 'Europa',
        continentMiddleEast: 'Orientul Mijlociu',
        continentAsia: 'Asia',
        continentAfrica: 'Africa',
        continentNorthAmerica: 'America de Nord',
        continentSouthAmerica: 'America de Sud',
        continentOceania: 'Oceania',
        backToContinents: 'Înapoi la Continente',
        downloadRecipe: 'Descarcă rețeta',
        pdfDownloaded: 'PDF descărcat cu succes!',
        errorDownloadingPdf: 'Eroare la descărcarea PDF-ului.',
        random: 'Aleatoriu',
        mostCommented: 'Cele Mai Comentate',
        mostLiked: 'Cele Mai Apreciate',
        newest: 'Cele Mai Noi',
        quickest: 'Cele Mai Rapide',
        lowestCalories: 'Cele Mai Puține Calorii',
        audioFetched: 'Audio-ul este gata de redare.',
        errorFetchingAudio: 'Eroare la obținerea audio-ului. Vă rugăm să încercați din nou.',
        loadingAudio: 'Se încarcă audio...',
        winePairings: 'Recomandări de Vinuri',
        errorWinePairing: 'Nu s-au putut obține recomandările de vinuri. Încercați din nou.',
        sharedOn: 'Rețetă partajată pe',
        copiedToClipboard: 'Rețetă copiată în clipboard!',
        shareError: 'Nu s-a putut partaja rețeta.',
        photoTip: 'Pentru cele mai bune rezultate, încărcați o fotografie clară a ingredientelor sau a unui preparat.',
        noFoodDetected: 'Nu au fost detectate alimente sau ingrediente în fotografia dvs. Încercați din nou cu o fotografie cu ingrediente sau un preparat.',
        errorCompressingImage: 'Eroare la comprimarea imaginii. Încercați o fotografie mai mică.',
        askingAboutCookbook: 'Întrebări despre cartea de rețete:',
        askingAboutRecipe: 'Întrebări despre rețetă:',
        submit: 'Trimite',
        noComments: 'Încă nu există comentarii. Fii primul care comentează!',
        comparePrices: 'Compară Prețurile Supermarketurilor',
        comparingPrices: 'Se compară prețurile...',
        pricesFor: 'Prețuri pentru',
        priceComparison: 'Comparație de Prețuri',
        estimate: 'estimare',
        potentialSavings: 'Economie potențială',
        cheapestAt: 'Cel mai ieftin la',
        cheapest: 'Cel mai ieftin',
        priceDisclaimer: 'Prețurile sunt estimări AI și pot diferi de prețurile reale din magazine.',
        budget: 'Economic',
        midRange: 'Gamă medie',
        premium: 'Premium',
        clearListConfirmTitle: 'Ștergeți lista de cumpărături?',
        clearListConfirmText: 'Aceasta va elimina toate articolele din listă. Această acțiune nu poate fi anulată.',
        allergyPreferences: 'Preferințe de alergie',
        allergyPreferencesDescription: 'Selectați alergenii mai jos. Rețetele care îi conțin vor fi ascunse din recomandări.',
        savePreferences: 'Salvează preferințele',
        saving: 'Se salvează...',
        preferencesSaved: 'Preferințe de alergie salvate!',
        errorSavingPreferences: 'Eroare la salvarea preferințelor',
    },
    "polish": {
        and: "i",
        validateWeight: "Waga musi być pomiędzy",
        validateHeight: "Wzrost musi być pomiędzy",
        nutritionGoals: "Cele żywieniowe",
        safetyAndDisclaimer: "Bezpieczeństwo & Zrzeczenie się odpowiedzialności",
        safetyAndDisclaimerText: "Cele są szacunkowe i nie zastępują profesjonalnej porady medycznej, żywieniowej ani dietetycznej. Jeśli masz problemy zdrowotne, skonsultuj się z pracownikiem służby zdrowia.",
        male: "Mężczyzna",
        female: "Kobieta",
        other: "Inne",
        allowed: "Dozwolone",
        pleaseEnterAWeight: "Proszę podać wagę",
        pleaseEnterAHeight: "Proszę podać wzrost",
        calories: "Kalorie",
        protein: "Białko",
        fat: "Tłuszcz",
        carbs: "Węglowodany",
        sex: "Płeć",
        age: "Wiek",
        weight: "Waga",
        height: "Wzrost",
        activity: "Aktywność",
        goal: "Cel",
        computeGoals: "Oblicz cele",
        light: "Lekki",
        moderate: "Umiarkowany",
        veryActive: "Bardzo aktywny",
        extraActive: "Ekstremalnie aktywny",
        lose: "Schudnąć",
        maintain: "Utrzymać",
        gain: "Przytyć",
        dailyTargets: "Codzienne cele",
        unableToFetchPrices: 'Nie można pobrać cen dla danej waluty',
        loadingPrices: 'Ładowanie cen',
        currency: 'Waluta',
        latestMarketPrices: 'Najnowsze ceny rynkowe',
        countryCurrency: 'PLN',
        startScan: 'Rozpocznij skanowanie',
        scanAnother: 'Skanuj inny',
        scanning: 'Łów',
        vitaminD: 'Witamina D',
        salt: 'Sól',
        protein: 'Białko',
        fiber: 'Błonnik',
        addedSugars: 'Dodane cukry',
        sugars: 'Cukry',
        saturatedFat: 'Tłuszcz nasycony',
        fat: 'Tłuszcz',
        energy: 'Energia',
        amount: 'Kwota',
        productNutrient: 'Odżywka',
        productNutritionalValuesPer100g: 'Wartość odżywcza (na 100 g)',
        productIngredients: 'Składniki',
        productNutriScore: 'Wynik odżywczy',
        productBrand: 'Marka',
        scanYourProductBarcode: 'Zeskanuj kod kreskowy swojego produktu!',
        productLookupFailed: 'Wyszukiwanie produktu nie powiodło się',
        productNotFoundError: 'Produkt nie został znaleziony',
        cameraFailedStartError: 'Aparat nie uruchomił się',
        profile: "Profil",
        basicInformation: "Podstawowe informacje",
        savedRecipes: "Zapisane przepisy",
        noSavedRecipes: "Nie masz jeszcze zapisanych żadnych przepisów.",
        userData: "Dane użytkownika",
        recipeRemoved: "Przepis {recipeName} został usunięty z Twoich ulubionych.",
        username: "Nazwa użytkownika",
        mobileNumber: "Numer telefonu komórkowego",
        password: "Hasło",
        saveChanges: "Zapisz zmiany",
        changesSaved: "Zmiany zapisano pomyślnie",
        subscriptionInformation: "Informacje o subskrypcji",
        lastBillingDate: "Data ostatniego rozliczenia",
        nextBillingDate: "Data następnego rozliczenia",
        unsubscribe: "Anuluj subskrypcję",
        unsubscribed: "Twoja subskrypcja została anulowana.",
        selectLanguage: "Wybierz swój język",
        whatToDo: "Co chcesz zrobić?",
        takePhoto: "Zrób zdjęcie",
        uploadPhoto: "Prześlij zdjęcie",
        uploading: "Tworzenie spersonalizowanych przepisów...",
        loadingTime: "Może to potrwać do 1 minuty...",
        analyzing: "AI analizuje Twoje zdjęcie...",
        aiAnalysisResult: "Wynik analizy AI:",
        uploadError: "Wystąpił błąd podczas przesyłania obrazu.",
        processingError: "Wystąpił błąd podczas przetwarzania obrazu.",
        numberOfPeople: "Liczba osób",
        timeOfDay: "Pora dnia",
        selectTimeOfDay: "Wybierz porę dnia",
        breakfast: "Śniadanie",
        morningSnack: "Drugie śniadanie",
        lunch: "Obiad",
        afternoonSnack: "Podwieczorek",
        dinner: "Kolacja",
        dessert: "Deser",
        lateNightSnack: "Późna przekąska",
        preferredCuisine: "Preferowana kuchnia",
        selectCuisine: "Wybierz kuchnię",
        italian: "Włoska",
        chinese: "Chińska",
        indian: "Indyjska",
        mexican: "Meksykańska",
        french: "Francuska",
        thai: "Tajska",
        japanese: "Japońska",
        mediterranean: "Śródziemnomorska",
        spanish: "Hiszpańska",
        greek: "Grecka",
        vietnamese: "Wietnamska",
        american: "Amerykańska",
        turkish: "Turecka",
        korean: "Koreańska",
        moroccan: "Marokańska",
        persian: "Perska",
        allergies: "Alergeny",
        selectAllergies: "Wybierz alergeny",
        gluten: "Gluten",
        nuts: "Orzechy",
        lactose: "Laktoza",
        soy: "Soja",
        shellfish: "Skorupiaki",
        fish: "Ryby",
        eggs: "Jajka",
        peanuts: "Orzeszki ziemne",
        sesame: "Sezam",
        sulphites: "Siarczyny",
        mustard: "Gorczyca",
        celery: "Seler",
        lupin: "Łubin",
        molluscs: "Mięczaki",
        cookingTime: "Czas gotowania",
        cookingTip: "Wskazówka kulinarna:",
        minutes: "minut",
        caloriesPerServing: "Kalorie na porcję",
        servings: "porcje",
        allergens: "Alergeny",
        ingredients: "Składniki",
        instructions: "Instrukcje",
        askQuestion: "Zadać pytanie",
        recipeLibrary: "Biblioteka przepisów",
        loadMore: "Załaduj więcej",
        loadNewRandomRecipes: "Załaduj więcej przepisów",
        loadingRecipes: "Ładowanie {count} przepisów...",
        viewRecipe: "Zobacz przepis",
        noResultsFound: "Nie znaleziono wyników",
        search: "Prześlij obraz",
        decrease: "Minus",
        increase: "Plus",
        elapsedTime: "Upłynął czas",
        seconds: "sekund",
        cameraNotSupported: "Aparat nie jest obsługiwany na tym urządzeniu",
        nutritions: "Wartości odżywcze",
        calories: "Kalorie",
        protein: "Białko",
        carbs: "Węglowodany",
        fat: "Tłuszcz",
        fiber: "Błonnik",
        sugar: "Cukier",
        sodium: "Sód",
        vitamina: "Witamina A",
        vitaminc: "Witamina C",
        calcium: "Wapń",
        iron: "Żelazo",
        recipeDetails: "Szczegóły przepisu",
        loadMore: "Załaduj więcej przepisów",
        recipeAlreadySaved: "Przepis jest już zapisany.",
        recipeSaved: "Przepis został pomyślnie zapisany.",
        errorSavingRecipe: "Błąd podczas zapisywania przepisu. Spróbuj ponownie.",
        recipeShared: "Przepis udostępniony przez {platform}!",
        defaultSaveMessage: "Akcja zakończona pomyślnie!",
        share: "Udostępnij",
        favorite: "Ulubione",
        close: "Zamknij",
        whatsapp: "WhatsApp",
        facebook: "Facebook",
        twitter: "Twitter",
        email: "Adres e-mail",
        loading: "Pobieranie nowych przepisów...",
        tetrisTitle: "Zagraj w Tetrisa, czekając!",
        score: "Wynik",
        highScore: "Najwyższy wynik",
        gameOver: "Koniec gry",
        playAgain: "Zagraj ponownie",
        left: "W lewo",
        right: "W prawo",
        down: "W dół",
        rotate: "Obróć",
        startTetris: "Zagraj w Tetrisa",
        stopOrContinueTetris: "Przepisy są gotowe. Czy chcesz zakończyć grę w Tetrisa i zobaczyć przepisy?",
        continueTetris: "Kontynuuj grę w Tetrisa",
        playTetris: "Graj w Tetrisa",
        viewRecipes: "Zobacz przepisy",
        recipesLoaded: "SousChaif ma już gotowe Twoje przepisy!",
        capturePhoto: "Zrób zdjęcie",
        closeCamera: "Zamknij aparat",
        pictureIngredients: "Sfotografuj składniki",
        previewImage: "Zatwierdź zdjęcie",
        retake: "Zrób ponownie",
        approve: "Wyślij",
        waitingNotice: "Zagraj w grę, czekając.",
        name: "Imię",
        newSearchQuestion: "Wyszukać nowe przepisy?",
        newSearchPrompt: "Czy chcesz wyszukać nowe przepisy, czy wyświetlić poprzednie wyniki?",
        searchNewRecipes: "Szukaj nowych przepisów",
        seeOldRecipes: "Zobacz",
        chatBotIntro: "Witaj, jestem SousChaif. W czym mogę dziś pomóc?",
        chatWithSousChaif: "Czatuj z SousChaif",
        typeYourMessage: "Wpisz swoją wiadomość...",
        recipeLoaded: "Przepis załadowany",
        askAboutRecipe: "Zapytaj o przepis",
        errorFetchingData: "Wystąpił błąd podczas pobierania danych.",
        whatQuestionWouldYouLikeToAsk: "Jakie pytanie chcesz zadać?",
        welcomeBack: "Witaj z powrotem",
        needHelpWithRecipe: "Potrzebujesz pomocy w gotowaniu?",
        viewRecipesHome: "Zadaj pytanie",
        popularIngredients: "Popularne składniki",
        popularCookbooks: "Popularne książki kucharskie",
        browseByLetter: "Przeglądaj według litery",
        videoRecipes: "Przepisy Wideo",
        recipesByLetter: "Przepisy według litery",
        noRecipesFound: "Nie znaleziono przepisów",
        watchVideo: "Obejrzyj film",
        loadMore: "Załaduj Więcej",
        categories: "Kategorie",
        ingredients: "Składniki",
        filterBy: "Filtruj według",
        all: "Wszystkie",
        recipes: "przepisy",
        Chicken: "Kurczak",
        Beef: "Wołowina",
        Pork: "Wieprzowina",
        Salmon: "Łosoś",
        Shrimp: "Krewetki",
        Tofu: "Tofu",
        Tuna: "Tuńczyk",
        Potato: "Ziemniak",
        Rice: "Ryż",
        comments: "Komentarze",
        addComment: "Zostaw komentarz",
        noComments: "Brak komentarzy. Bądź pierwszy!",
        submit: "Prześlij",
        commentSubmitted: "Komentarz opublikowany!",
        errorSubmittingComment: "Błąd podczas publikowania komentarza.",
        backToWaiting: "Wróć",
        shoppingList: "Lista zakupów",
        addItem: "Dodaj produkt",
        add: "Dodaj",
        clearList: "Wyczyść listę",
        addToShoppingList: "Dodaj do listy zakupów",
        addedToShoppingList: "Składniki dodane do listy zakupów!",
        quantity: "Ilość",
        diet: "Dieta",
        selectDiet: "Wybierz dietę",
        keto: "Keto",
        lowCarb: "Niskowęglowodanowa",
        vegetarian: "Wegetariańska",
        vegan: "Wegańska",
        paleo: "Paleo",
        mediterraneanDiet: "Śródziemnomorska",
        dairyFree: "Beznabiałowa",
        glutenFree: "Bezglutenowa",
        lowFat: "Niskotłuszczowa",
        highProtein: "Wysokobiałkowa",
        selectIngredients: "Wybierz składniki",
        chicken: "Kurczak",
        beef: "Wołowina",
        pork: "Wieprzowina",
        salmon: "Łosoś",
        shrimp: "Krewetki",
        tuna: "Tuńczyk",
        potato: "Ziemniak",
        rice: "Ryż",
        filters: "Filtry",
        resetFilters: "Resetuj filtry",
        tryAgain: "Spróbuj ponownie",
        searchRecipes: "Szukaj przepisów...",
        addIngredient: "Dodaj składnik",
        upTo: "Do",
        errorFetchingRecipes: "Wystąpił błąd podczas pobierania przepisów",
        budgetFriendlyCooking: "Gotowanie przyjazne dla budżetu",
        budgetFriendlyDescription: "Twórz pyszne i ekonomiczne posiłki z 'sous-chaif', korzystając ze spersonalizowanych przepisów na podstawie Twoich składników i preferencji.",
        customRecipeSuggestions: "Spersonalizowane propozycje przepisów",
        customRecipeDescription: "Podaj swoje składniki, preferencje i cele dietetyczne, a 'sous-chaif' przygotuje dla Ciebie spersonalizowane przepisy.",
        secureAndEasy: "Bezpiecznie i łatwo",
        secureAndEasyDescription: "Twoje dane są u nas bezpieczne. Ciesz się łatwym dostępem do spersonalizowanych przepisów i porad kulinarnych.",
        featureWelcomeTitle: "Witamy w Souschaif!",
        featureWelcomeSubtitle: "Prześlij zdjęcie składników lub lodówki i od razu otrzymaj przepisy. Możesz zamknąć to okno w dowolnym momencie.",
        featureWelcomeGotIt: "Rozumiem",
        featureWelcomeMainBadge: "Najważniejsze",
        featureWelcomePhotoTitle: "Prześlij zdjęcie składników lub lodówki",
        featureWelcomePhotoDescription: "Zrób lub prześlij zdjęcie i natychmiast otrzymaj przepisy na podstawie tego, co masz w domu.",
        featureWelcomeChatDescription: "Zadawaj pytania naszemu AI szefowi kuchni i otrzymuj natychmiast spersonalizowane porady.",
        featureWelcomeLibraryDescription: "Przeglądaj setki przepisów i filtruj według składników, alergenów i czasu gotowania.",
        featureWelcomeShoppingDescription: "Automatycznie twórz listy zakupów na podstawie przepisów.",
        smartShoppingList: "Inteligentna lista zakupów",
        smartShoppingListDescription: "Generuj listy zakupów na podstawie ulubionych przepisów.",
        usernameOrMobile: "Nazwa użytkownika lub numer telefonu",
        orClickHere: "Lub kliknij tutaj",
        rememberMe: "Zapamiętaj mnie",
        logIn: "Zaloguj się",
        signingIn: "Logowanie...",
        noAccount: "Nie masz konta?",
        signUp: "Zarejestruj się",
        next: "Dalej",
        skip: "Pomiń",
        defaultNotSubscribed: "Nie subskrybujesz tej usługi",
        defaultLoginError: "Nie można zweryfikować Twojej subskrypcji. Spróbuj ponownie później",
        signup: "Zarejestruj się",
        signupIntro: "Utwórz konto, aby zacząć",
        confirmPassword: "Potwierdź hasło",
        signupButton: "Utwórz konto",
        signupError: "Błąd podczas rejestracji",
        alreadySubscribed: "Już zarejestrowany?",
        clickHere: "Kliknij tutaj",
        signupSuccess: "Konto utworzono pomyślnie",
        passwordRequirements: "Wymagania dotyczące hasła",
        minLength: "Minimum 8 znaków",
        requireUppercase: "Co najmniej jedna wielka litera",
        requireLowercase: "Co najmniej jedna mała litera",
        requireNumber: "Co najmniej jedna cyfra",
        requireSpecial: "Co najmniej jeden znak specjalny",
        passwordsMatch: "Hasła są zgodne",
        passwordRequirementsNotMet: "Proszę spełnić wszystkie wymagania dotyczące hasła",
        newPassword: "Nowe hasło",
        leaveEmptyToKeep: "Pozostaw puste, aby zachować obecne hasło",
        sessionId: "ID sesji",
        createdAt: "Konto utworzono",
        errorFetchingUserData: "Błąd podczas pobierania danych użytkownika",
        errorUpdatingUser: "Błąd podczas aktualizacji danych użytkownika",
        confirmUnsubscribe: "Potwierdź rezygnację z subskrypcji",
        confirmUnsubscribeMessage: "Czy na pewno chcesz zrezygnować z subskrypcji?",
        confirmPasswordChange: "Potwierdź zmianę hasła",
        confirmPasswordChangeMessage: "Czy na pewno chcesz zmienić swoje hasło?",
        yes: "Tak",
        cancel: "Anuluj",
        continentEurope: 'Europa',
        continentMiddleEast: 'Bliski Wschód',
        continentAsia: 'Azja',
        continentAfrica: 'Afryka',
        continentNorthAmerica: 'Ameryka Północna',
        continentSouthAmerica: 'Ameryka Południowa',
        continentOceania: 'Oceania',
        backToContinents: 'Powrót do Kontynentów',
        downloadRecipe: 'Pobierz przepis',
        pdfDownloaded: 'PDF pobrany pomyślnie!',
        errorDownloadingPdf: 'Błąd podczas pobierania PDF.',
        random: 'Losowe',
        mostCommented: 'Najczęściej Komentowane',
        mostLiked: 'Najczęściej Lubiane',
        newest: 'Najnowsze',
        quickest: 'Najszybsze',
        lowestCalories: 'Najmniej Kalorii',
        audioFetched: 'Dźwięk jest gotowy do odtworzenia.',
        errorFetchingAudio: 'Błąd podczas pobierania dźwięku. Spróbuj ponownie.',
        loadingAudio: 'Ładowanie dźwięku...',
        winePairings: 'Rekomendacje Win',
        errorWinePairing: 'Nie udało się uzyskać rekomendacji win. Spróbuj ponownie.',
        sharedOn: 'Przepis udostępniony na',
        copiedToClipboard: 'Przepis skopiowany do schowka!',
        shareError: 'Nie udało się udostępnić przepisu.',
        photoTip: 'Aby uzyskać najlepsze wyniki, prześlij wyraźne zdjęcie składników lub potrawy.',
        noFoodDetected: 'Nie wykryto żywności ani składników na Twoim zdjęciu. Spróbuj ponownie ze zdjęciem składników lub potrawy.',
        errorCompressingImage: 'Błąd podczas kompresji obrazu. Spróbuj mniejszego zdjęcia.',
        askingAboutCookbook: 'Pytania o książkę kucharską:',
        askingAboutRecipe: 'Pytania o przepis:',
        submit: 'Wyślij',
        noComments: 'Brak komentarzy. Bądź pierwszym, który skomentuje!',
        comparePrices: 'Porównaj Ceny w Supermarketach',
        comparingPrices: 'Porównywanie cen...',
        pricesFor: 'Ceny dla',
        priceComparison: 'Porównanie Cen',
        estimate: 'szacunek',
        potentialSavings: 'Potencjalne oszczędności',
        cheapestAt: 'Najtaniej w',
        cheapest: 'Najtańszy',
        priceDisclaimer: 'Ceny są szacunkami AI i mogą różnić się od rzeczywistych cen w sklepach.',
        budget: 'Ekonomiczny',
        midRange: 'Średnia półka',
        premium: 'Premium',
        clearListConfirmTitle: 'Wyczyścić listę zakupów?',
        clearListConfirmText: 'Spowoduje to usunięcie wszystkich pozycji z listy. Nie można tego cofnąć.',
        allergyPreferences: 'Ustawienia alergii',
        allergyPreferencesDescription: 'Wybierz alergeny poniżej. Przepisy zawierające te składniki zostaną ukryte z rekomendacji.',
        savePreferences: 'Zapisz ustawienia',
        saving: 'Zapisywanie...',
        preferencesSaved: 'Ustawienia alergii zapisane!',
        errorSavingPreferences: 'Błąd przy zapisywaniu ustawień',
    },
    arabic: {
        and: "و",
        validateWeight: "يجب أن يكون الوزن بين",
        validateHeight: "يجب أن يكون الطول بين",
        nutritionGoals: "الأهداف الغذائية",
        safetyAndDisclaimer: "السلامة & إخلاء المسؤولية",
        safetyAndDisclaimerText: "الأهداف تقديرات ولا تحل محل النصائح الطبية أو الغذائية أو الحمية المهنية. إذا كانت لديك مخاوف صحية، فاستشر أخصائي رعاية صحية.",
        male: "ذكر",
        female: "أنثى",
        other: "آخر",
        allowed: "مسموح",
        pleaseEnterAWeight: "الرجاء إدخال الوزن",
        pleaseEnterAHeight: "الرجاء إدخال الطول",
        calories: "سعرات حرارية",
        protein: "بروتين",
        fat: "دهون",
        carbs: "كربوهيدرات",
        sex: "الجنس",
        age: "العمر",
        weight: "الوزن",
        height: "الطول",
        activity: "النشاط",
        goal: "الهدف",
        computeGoals: "احسب الأهداف",
        light: "خفيف",
        moderate: "متوسط",
        veryActive: "نشط جدًا",
        extraActive: "نشط للغاية",
        lose: "فقدان",
        maintain: "الحفاظ",
        gain: "زيادة",
        dailyTargets: "الأهداف اليومية",
        unableToFetchPrices: 'غير قادر على جلب أسعار العملة',
        loadingPrices: 'تحميل الأسعار',
        currency: 'العملة',
        latestMarketPrices: 'أحدث أسعار السوق',
        startScan: 'ابدأ المسح',
        scanAnother: 'مسح آخر',
        scanning: 'جاري المسح',
        vitaminD: 'فيتامين د',
        salt: 'ملح',
        protein: 'بروتين',
        fiber: 'ألياف',
        addedSugars: 'سكريات مضافة',
        sugars: 'سكريات',
        saturatedFat: 'دهون مشبعة',
        fat: 'دهون',
        energy: 'طاقة',
        amount: 'الكمية',
        productNutrient: 'العنصر الغذائي',
        productNutritionalValuesPer100g: 'القيم الغذائية (لكل 100 جرام)',
        productIngredients: 'المكونات',
        productNutriScore: 'نتي-سكور',
        productBrand: 'العلامة التجارية',
        scanYourProductBarcode: 'امسح رمز المنتج الشريطي!',
        productLookupFailed: 'فشل البحث عن المنتج',
        productNotFoundError: 'المنتج غير موجود',
        cameraFailedStartError: 'فشل تشغيل الكاميرا',
        profile: 'الملف الشخصي',
        basicInformation: 'المعلومات الأساسية',
        savedRecipes: 'الوصفات المحفوظة',
        noSavedRecipes: 'ليس لديك وصفات محفوظة.',
        welcomeBack: 'مرحباً بعودتك',
        needHelpWithRecipe: 'هل تحتاج مساعدة في الطبخ؟',
        viewRecipesHome: 'اطرح سؤالك',
        userData: 'بيانات المستخدم',
        recipeRemoved: 'تم إزالة الوصفة {recipeName} من مفضلتك.',
        username: 'اسم المستخدم',
        mobileNumber: 'رقم الهاتف المحمول',
        password: 'كلمة المرور',
        saveChanges: 'حفظ التغييرات',
        changesSaved: 'تم حفظ تغييراتك.',
        subscriptionInformation: 'معلومات الاشتراك',
        lastBillingDate: 'تاريخ الفوترة الأخير',
        nextBillingDate: 'تاريخ الفوترة التالي',
        unsubscribe: 'إلغاء الاشتراك',
        unsubscribed: 'تم إلغاء اشتراكك.',
        selectLanguage: 'اختر لغتك',
        whatToDo: 'ماذا تريد أن تفعل؟',
        takePhoto: 'التقط صورة',
        uploadPhoto: 'رفع صورة',
        pleaseAddPhotoFirst: 'يرجى إضافة صورة أولاً أو التقاط صورة',
        uploading: 'إنشاء وصفاتك الشخصية...',
        loadingTime: 'قد يستغرق هذا ما يصل إلى دقيقة واحدة...',
        analyzing: 'الذكاء الاصطناعي يحلل صورتك...',
        aiAnalysisResult: 'نتيجة تحليل الذكاء الاصطناعي:',
        uploadError: 'حدث خطأ أثناء رفع الصورة.',
        processingError: 'حدث خطأ أثناء معالجة الصورة.',
        numberOfPeople: 'عدد الأشخاص',
        timeOfDay: 'وقت اليوم',
        selectTimeOfDay: 'اختر وقت اليوم',
        breakfast: 'الفطور',
        morningSnack: 'وجبة خفيفة صباحية',
        lunch: 'الغداء',
        afternoonSnack: 'وجبة خفيفة بعد الظهر',
        dinner: 'العشاء',
        dessert: 'الحلوى',
        lateNightSnack: 'وجبة خفيفة متأخرة',
        preferredCuisine: 'المطبخ المفضل',
        selectCuisine: 'اختر المطبخ',
        italian: 'إيطالي',
        chinese: 'صيني',
        indian: 'هندي',
        mexican: 'مكسيكي',
        french: 'فرنسي',
        thai: 'تايلاندي',
        japanese: 'ياباني',
        mediterranean: 'متوسطي',
        spanish: 'إسباني',
        greek: 'يوناني',
        vietnamese: 'فيتنامي',
        american: 'أمريكي',
        turkish: 'تركي',
        korean: 'كوري',
        moroccan: 'مغربي',
        persian: 'فارسي',
        allergies: 'الحساسية',
        selectAllergies: 'اختر الحساسية',
        gluten: 'غلوتين',
        nuts: 'مكسرات',
        lactose: 'لاكتوز',
        soy: 'صويا',
        shellfish: 'محار',
        fish: 'سمك',
        eggs: 'بيض',
        peanuts: 'فول سوداني',
        sesame: 'سمسم',
        sulphites: 'سلفيت',
        mustard: 'خردل',
        celery: 'كرفس',
        lupin: 'لوبين',
        molluscs: 'رخويات',
        diet: 'النظام الغذائي',
        selectDiet: 'اختر نظام غذائي',
        keto: 'كيتو',
        lowCarb: 'منخفض الكربوهيدرات',
        vegetarian: 'نباتي',
        vegan: 'نباتي صرف',
        paleo: 'باليو',
        mediterraneanDiet: 'البحر الأبيض المتوسط',
        dairyFree: 'خالٍ من منتجات الألبان',
        glutenFree: 'خالٍ من الغلوتين',
        lowFat: 'قليل الدهون',
        highProtein: 'عالي البروتين',
        selectIngredients: 'اختر المكونات',
        getRecipeIdeas: 'احصل على أفكار الوصفات',
        generateRecipes: 'إنشاء وصفات',
        recipeIdeasTitle: 'أفكار الوصفات',
        noRecipeIdeas: 'لا توجد أفكار وصفات متاحة.',
        errorGeneratingRecipes: 'خطأ في إنشاء الوصفات. يرجى المحاولة مرة أخرى.',
        errorFetchingRecipes: 'خطأ في استرجاع الوصفات.',
        viewRecipe: 'عرض الوصفة',
        saveRecipe: 'حفظ الوصفة',
        savedRecipe: 'تم حفظ الوصفة!',
        recipeAlreadySaved: 'الوصفة محفوظة بالفعل!',
        home: 'الرئيسية',
        recipes: 'الوصفات',
        popularCookbooks: 'كتب طبخ شهيرة',
        browseByLetter: 'تصفح حسب الحرف',
        videoRecipes: 'وصفات الفيديو',
        recipesByLetter: 'وصفات حسب الحرف',
        noRecipesFound: 'لم يتم العثور على وصفات',
        watchVideo: 'شاهد الفيديو',
        loadMore: 'تحميل المزيد',
        categories: 'الفئات',
        ingredients: 'المكونات',
        filterBy: 'تصفية حسب',
        all: 'الكل',
        search: 'البحث',
        login: 'تسجيل الدخول',
        logout: 'تسجيل الخروج',
        cancelSubscription: 'إلغاء الاشتراك',
        deleteAccount: 'حذف الحساب',
        deleteAccountConfirm: 'هل أنت متأكد من أنك تريد حذف حسابك؟ هذا الإجراء لا رجعة فيه.',
        accountDeleted: 'تم حذف حسابك.',
        errorDeletingAccount: 'خطأ في حذف الحساب.',
        ingredients: 'المكونات',
        instructions: 'التعليمات',
        askQuestion: 'طرح سؤال',
        recipeLibrary: 'مكتبة الوصفات',
        loadMore: 'تحميل المزيد',
        loadNewRandomRecipes: 'تحميل المزيد من الوصفات',
        loadingRecipes: 'جاري تحميل {count} وصفة...',
        viewRecipe: 'عرض الوصفة',
        nutritionalInfo: 'المعلومات الغذائية',
        preparationTime: 'وقت التحضير',
        cookingTime: 'وقت الطبخ',
        servings: 'الحصص',
        minutes: 'دقيقة',
        likes: 'إعجابات',
        viewAll: 'عرض الكل',
        difficulty: 'الصعوبة',
        easy: 'سهل',
        medium: 'متوسط',
        hard: 'صعب',
        cookingTips: 'نصائح الطبخ',
        noCookingTip: 'لا توجد نصيحة طبخ متاحة.',
        foodWasteAndFacts: 'هدر الطعام والحقائق',
        noFoodWasteSaving: 'لا توجد معلومات توفير متاحة.',
        noFoodFact: 'لا توجد حقيقة غذائية متاحة.',
        searchRecipes: 'البحث عن الوصفات',
        searchPlaceholder: 'ابحث عن وصفات...',
        noResults: 'لا توجد نتائج.',
        shoppingList: 'قائمة التسوق',
        addItem: 'إضافة عنصر',
        add: 'إضافة',
        addIngredient: 'إضافة مكون',
        removeIngredient: 'إزالة المكون',
        clearList: 'مسح القائمة',
        addToShoppingList: 'أضف إلى قائمة التسوق',
        addedToShoppingList: 'تمت إضافة المكونات إلى قائمة التسوق!',
        quantity: 'كمية',
        shoppingListEmpty: 'قائمة التسوق فارغة.',
        tetris: 'تتريس',
        playTetris: 'العب تتريس',
        barcodeScan: 'مسح الرمز الشريطي',
        scanBarcode: 'امسح الرمز الشريطي',
        noCameraAccess: 'لا يمكن الوصول إلى الكاميرا.',
        invalidBarcode: 'رمز شريطي غير صالح.',
        productAdded: 'تم إضافة المنتج إلى قائمة التسوق.',
        productAlreadyInList: 'المنتج موجود بالفعل في القائمة.',
        productNotAdded: 'لم يتم إضافة المنتج.',
        // Ingredients (lowercase)
        chicken: 'دجاج',
        beef: 'لحم بقري',
        pork: 'لحم خنزير',
        salmon: 'سلمون',
        shrimp: 'روبيان',
        eggs: 'بيض',
        tofu: 'توفو',
        tuna: 'تونة',
        potato: 'بطاطس',
        rice: 'أرز',
        // Ingredients (capitalized)
        Chicken: 'دجاج',
        Beef: 'لحم بقري',
        Pork: 'لحم خنزير',
        Salmon: 'سلمون',
        Shrimp: 'روبيان',
        comments: 'التعليقات',
        addComment: 'ترك تعليق',
        noComments: 'لا توجد تعليقات بعد. كن الأول!',
        submit: 'إرسال',
        commentSubmitted: 'تم إرسال التعليق!',
        errorSubmittingComment: 'خطأ في إرسال التعليق.',
        backToWaiting: 'رجوع',
        welcome: 'مرحباً',
        welcomeMessage: 'مرحباً بك في sous-chaif! نحن نقدم وصفات شخصية بناءً على صور المكونات الخاصة بك.',
        getStarted: 'ابدأ',
        personalizedRecipes: 'وصفات شخصية',
        personalizedRecipesDescription: 'احصل على وصفات مخصصة بناءً على صور المكونات الخاصة بك.',
        smartShoppingList: 'قائمة تسوق ذكية',
        smartShoppingListDescription: 'أنشئ قوائم تسوق بناءً على وصفاتك.',
        reduceFoodWaste: 'تقليل هدر الطعام',
        reduceFoodWasteDescription: 'تعلم كيفية تقليل هدر الطعام مع نصائحنا الذكية.',
        customRecipeSuggestions: 'اقتراحات وصفات مخصصة',
        customRecipeDescription: 'أدخل مكوناتك وتفضيلاتك وأهدافك الغذائية، وسيقوم sous-chaif بإعداد وصفات مخصصة لك.',
        secureAndEasy: 'آمن وسهل',
        secureAndEasyDescription: 'بياناتك آمنة معنا. استمتع بالوصول السهل إلى الوصفات الشخصية ونصائح الطبخ.',
        featureWelcomeTitle: 'مرحباً بك في Souschaif!',
        featureWelcomeSubtitle: 'ارفع صورة لمكوناتك أو ثلاجتك واحصل على وصفات فوراً. يمكنك إغلاق هذه النافذة في أي وقت.',
        featureWelcomeGotIt: 'فهمت',
        featureWelcomeMainBadge: 'الأهم',
        featureWelcomePhotoTitle: 'رفع صورة للمكونات أو الثلاجة',
        featureWelcomePhotoDescription: 'التقط أو ارفع صورة واحصل على وصفات مخصصة بناءً على ما لديك في المنزل.',
        featureWelcomeChatDescription: 'اطرح أسئلتك على طاهينا الذكي واحصل على نصائح شخصية فوراً.',
        featureWelcomeLibraryDescription: 'تصفح مئات الوصفات وصفِّ حسب المكونات والحساسية ووقت الطهي.',
        featureWelcomeShoppingDescription: 'أنشئ قوائم تسوق تلقائياً من وصفاتك.',
        usernameOrMobile: 'اسم المستخدم أو رقم الهاتف',
        rememberMe: 'تذكرني',
        logIn: 'تسجيل الدخول',
        signingIn: 'جاري تسجيل الدخول...',
        noAccount: 'ليس لديك حساب؟',
        signUp: 'إنشاء حساب',
        next: 'التالي',
        skip: 'تخطي',
        defaultNotSubscribed: 'أنت غير مشترك في هذه الخدمة',
        defaultLoginError: 'لا يمكن التحقق من اشتراكك. يرجى المحاولة مرة أخرى لاحقاً',
        signup: 'إنشاء حساب',
        signupIntro: 'أنشئ حساباً للبدء',
        confirmPassword: 'تأكيد كلمة المرور',
        signupButton: 'إنشاء حساب',
        signupError: 'خطأ في التسجيل',
        alreadySubscribed: 'مسجل بالفعل؟',
        clickHere: 'انقر هنا',
        signupSuccess: 'تم إنشاء الحساب بنجاح',
        passwordRequirements: 'متطلبات كلمة المرور',
        minLength: '8 أحرف كحد أدنى',
        requireUppercase: 'حرف كبير واحد على الأقل',
        requireLowercase: 'حرف صغير واحد على الأقل',
        requireNumber: 'رقم واحد على الأقل',
        requireSpecial: 'رمز خاص واحد على الأقل',
        passwordsMatch: 'كلمات المرور متطابقة',
        passwordRequirementsNotMet: 'يرجى تلبية جميع متطلبات كلمة المرور',
        newPassword: 'كلمة مرور جديدة',
        leaveEmptyToKeep: 'اتركها فارغة للاحتفاظ بكلمة المرور الحالية',
        sessionId: 'معرف الجلسة',
        createdAt: 'تم إنشاء الحساب',
        errorFetchingUserData: 'خطأ في استرجاع بيانات المستخدم',
        errorUpdatingUser: 'خطأ في تحديث بيانات المستخدم',
        confirmUnsubscribe: 'تأكيد إلغاء الاشتراك',
        confirmUnsubscribeMessage: 'هل أنت متأكد من أنك تريد إلغاء اشتراكك؟',
        confirmPasswordChange: 'تأكيد تغيير كلمة المرور',
        confirmPasswordChangeMessage: 'هل أنت متأكد من أنك تريد تغيير كلمة المرور الخاصة بك؟',
        yes: 'نعم',
        cancel: 'إلغاء',
        popularCookbooks: 'كتب طبخ شهيرة',
        browseByLetter: 'تصفح حسب الحرف',
        videoRecipes: 'وصفات الفيديو',
        recipesByLetter: 'وصفات حسب الحرف',
        noRecipesFound: 'لم يتم العثور على وصفات',
        watchVideo: 'شاهد الفيديو',
        loadMore: 'تحميل المزيد',
        categories: 'الفئات',
        ingredients: 'المكونات',
        filterBy: 'تصفية حسب',
        all: 'الكل',
        // Database Recipes (Library 1) filters
        recipeLibraryTitle: "مكتبة الوصفات",
        recipesCount: "{count} وصفات",
        searchPlaceholder: "ابحث عن وصفات...",
        filterByLetter: "تصفية حسب الحرف",
        allLetters: "الكل",
        maxCalories: "الحد الأقصى للسعرات",
        caloriesUnit: "kcal",
        maxCookingTime: "الوقت الأقصى",
        minutesUnit: "د",
        servings: "الحصص",
        minServings: "الحد الأدنى للحصص",
        maxServings: "الحد الأقصى للحصص",
        selectAllergens: "اختر المحسسات",
        typeToSearch: "اكتب للبحث...",
        selectNutritions: "اختر العناصر الغذائية",
        selectIngredients: "اختر المكونات",
        clearFilters: "مسح المرشحات",
        noRecipesMatch: "لا توجد وصفات تطابق المرشحات",
        dairy: "منتجات الألبان",
        soy: "فول الصويا",
        shellfish: "المحار",
        fish: "سمك",
        showFilters: "إظهار المرشحات",
        hideFilters: "إخفاء المرشحات",
        viewAllRecipes: "عرض جميع الوصفات",
        continentEurope: 'أوروبا',
        continentMiddleEast: 'الشرق الأوسط',
        continentAsia: 'آسيا',
        continentAfrica: 'أفريقيا',
        continentNorthAmerica: 'أمريكا الشمالية',
        continentSouthAmerica: 'أمريكا الجنوبية',
        continentOceania: 'أوقيانوسيا',
        backToContinents: 'العودة إلى القارات',
        downloadRecipe: 'تحميل الوصفة',
        pdfDownloaded: 'تم تحميل PDF بنجاح!',
        errorDownloadingPdf: 'خطأ في تحميل PDF.',
        random: 'عشوائي',
        mostCommented: 'الأكثر تعليقاً',
        mostLiked: 'الأكثر إعجاباً',
        newest: 'الأحدث',
        quickest: 'الأسرع',
        lowestCalories: 'أقل سعرات حرارية',
        audioFetched: 'الصوت جاهز للتشغيل.',
        errorFetchingAudio: 'خطأ في جلب الصوت. يرجى المحاولة مرة أخرى.',
        loadingAudio: 'جاري تحميل الصوت...',
        winePairings: 'اقتراحات النبيذ',
        errorWinePairing: 'تعذر الحصول على اقتراحات النبيذ. يرجى المحاولة مرة أخرى.',
        sharedOn: 'تمت مشاركة الوصفة على',
        copiedToClipboard: 'تم نسخ الوصفة إلى الحافظة!',
        shareError: 'تعذر مشاركة الوصفة.',
        photoTip: 'للحصول على أفضل النتائج، قم بتحميل صورة واضحة لمكوناتك أو طبقك.',
        noFoodDetected: 'لم يتم اكتشاف أي طعام أو مكونات في صورتك. يرجى المحاولة مرة أخرى بصورة مكونات أو طبق.',
        errorCompressingImage: 'خطأ في ضغط الصورة. جرب صورة أصغر.',
        askingAboutCookbook: 'أسئلة حول كتاب الطبخ:',
        askingAboutRecipe: 'أسئلة حول الوصفة:',
        submit: 'إرسال',
        noComments: 'لا توجد تعليقات بعد. كن أول من يعلق!',
        comparePrices: 'قارن أسعار السوبرماركت',
        comparingPrices: 'جاري مقارنة الأسعار...',
        pricesFor: 'الأسعار لـ',
        priceComparison: 'مقارنة الأسعار',
        estimate: 'تقدير',
        potentialSavings: 'التوفير المحتمل',
        cheapestAt: 'الأرخص في',
        cheapest: 'الأرخص',
        priceDisclaimer: 'الأسعار تقديرات ذكاء اصطناعي وقد تختلف عن الأسعار الفعلية في المتاجر.',
        budget: 'اقتصادي',
        midRange: 'متوسط',
        premium: 'فاخر',
        clearListConfirmTitle: 'مسح قائمة التسوق؟',
        clearListConfirmText: 'سيؤدي هذا إلى إزالة جميع العناصر من قائمتك. لا يمكن التراجع عن هذا الإجراء.',
        allergyPreferences: 'تفضيلات الحساسية',
        allergyPreferencesDescription: 'حدد مسببات الحساسية أدناه. سيتم إخفاء الوصفات التي تحتوي عليها من التوصيات.',
        savePreferences: 'حفظ التفضيلات',
        saving: 'جارٍ الحفظ...',
        preferencesSaved: 'تم حفظ تفضيلات الحساسية!',
        errorSavingPreferences: 'خطأ في حفظ التفضيلات',
    },
    norwegian: {
        and: "og",
        validateWeight: "Vekten må være mellom",
        validateHeight: "Høyden må være mellom",
        nutritionGoals: "Ernæringsmål",
        safetyAndDisclaimer: "Sikkerhet & Ansvarsfraskrivelse",
        safetyAndDisclaimerText: "Målene er estimater og erstatter ikke profesjonell medisinsk, ernæringsmessig eller dietetisk rådgivning. Hvis du har helseproblemer, kontakt en helsepersonell.",
        male: "Mann",
        female: "Kvinne",
        other: "Annet",
        allowed: "Tillatt",
        pleaseEnterAWeight: "Vennligst oppgi en vekt",
        pleaseEnterAHeight: "Vennligst oppgi en høyde",
        calories: "Kalorier",
        protein: "Protein",
        fat: "Fett",
        carbs: "Karbohydrater",
        sex: "Kjønn",
        age: "Alder",
        weight: "Vekt",
        height: "Høyde",
        activity: "Aktivitet",
        goal: "Mål",
        computeGoals: "Beregn mål",
        light: "Lett",
        moderate: "Moderat",
        veryActive: "Veldig aktiv",
        extraActive: "Ekstra aktiv",
        lose: "Miste",
        maintain: "Opprettholde",
        gain: "Øke",
        dailyTargets: "Daglige mål",
        unableToFetchPrices: 'Kan ikke hente priser for valuta',
        loadingPrices: 'Laster inn priser',
        currency: 'Valuta',
        latestMarketPrices: 'Siste markedspriser',
        countryCurrency: 'NOK',
        startScan: 'Start skanning',
        scanAnother: 'Skann en annen',
        scanning: 'Skanner',
        vitaminD: 'Vitamin D',
        salt: 'Salt',
        protein: 'Protein',
        fiber: 'Fiber',
        addedSugars: 'Tilsatt sukker',
        sugars: 'Sukker',
        saturatedFat: 'Mettet fett',
        fat: 'Fett',
        energy: 'Energi',
        amount: 'Mengde',
        productNutrient: 'Næringsstoff',
        productNutritionalValuesPer100g: 'Næringsverdi (per 100g)',
        productIngredients: 'Ingredienser',
        productNutriScore: 'Nutri-Score',
        productBrand: 'Merke',
        scanYourProductBarcode: 'Skann strekkoden på produktet ditt!',
        productLookupFailed: 'Produktsøk feilet',
        productNotFoundError: 'Produkt ikke funnet',
        cameraFailedStartError: 'Kamera kunne ikke starte',
        profile: 'Profil',
        basicInformation: 'Grunnleggende informasjon',
        savedRecipes: 'Lagrede oppskrifter',
        noSavedRecipes: 'Du har ingen lagrede oppskrifter ennå.',
        userData: 'Brukerdata',
        recipeRemoved: 'Oppskriften {recipeName} ble fjernet fra favorittene dine.',
        username: 'Brukernavn',
        mobileNumber: 'Mobilnummer',
        password: 'Passord',
        saveChanges: 'Lagre endringer',
        changesSaved: 'Dine endringer ble lagret.',
        subscriptionInformation: 'Abonnementsinformasjon',
        lastBillingDate: 'Siste faktureringsdato',
        nextBillingDate: 'Neste faktureringsdato',
        unsubscribe: 'Avslutt abonnement',
        unsubscribed: 'Ditt abonnement ble avsluttet.',
        selectLanguage: "Velg ditt språk",
        whatToDo: "Hva vil du gjøre?",
        takePhoto: "Ta bilde",
        uploadPhoto: "Last opp bilde",
        pleaseAddPhotoFirst: "Vennligst legg til et bilde først eller ta et bilde",
        uploading: "Lager dine tilpassede oppskrifter...",
        loadingTime: "Dette kan ta opptil 1 minutt...",
        analyzing: "AI analyserer bildet ditt...",
        aiAnalysisResult: "AI-analyse resultat:",
        uploadError: "Det oppstod en feil ved opplasting av bildet.",
        processingError: "Det oppstod en feil ved behandling av bildet.",
        numberOfPeople: 'Antall personer',
        timeOfDay: 'Tid på dagen',
        selectTimeOfDay: 'Velg tid på dagen',
        breakfast: 'Frokost',
        morningSnack: 'Formiddagsmat',
        lunch: 'Lunsj',
        afternoonSnack: 'Ettermiddagsmat',
        dinner: 'Middag',
        dessert: 'Dessert',
        lateNightSnack: 'Senkveldsmat',
        preferredCuisine: 'Foretrukket kjøkken',
        selectCuisine: 'Velg kjøkken',
        italian: 'Italiensk',
        chinese: 'Kinesisk',
        indian: 'Indisk',
        mexican: 'Meksikansk',
        french: 'Fransk',
        thai: 'Thai',
        japanese: 'Japansk',
        mediterranean: 'Middelhavs',
        spanish: 'Spansk',
        greek: 'Gresk',
        vietnamese: 'Vietnamesisk',
        american: 'Amerikansk',
        turkish: 'Tyrkisk',
        korean: 'Koreansk',
        moroccan: 'Marokkansk',
        persian: 'Persisk',
        allergies: 'Allergier',
        selectAllergies: 'Velg allergier',
        gluten: 'Gluten',
        nuts: 'Nøtter',
        lactose: 'Laktose',
        soy: 'Soya',
        shellfish: 'Skalldyr',
        fish: 'Fisk',
        eggs: 'Egg',
        peanuts: 'Peanøtter',
        sesame: 'Sesamfrø',
        sulphites: 'Sulfitter',
        mustard: 'Sennep',
        celery: 'Selleri',
        lupin: 'Lupin',
        molluscs: 'Bløtdyr',
        diet: 'Diett',
        selectDiet: 'Velg diett',
        keto: 'Keto',
        lowCarb: 'Lavkarbo',
        vegetarian: 'Vegetar',
        vegan: 'Vegansk',
        paleo: 'Paleo',
        mediterraneanDiet: 'Middelhavs',
        dairyFree: 'Melkefri',
        glutenFree: 'Glutenfri',
        lowFat: 'Lavfett',
        highProtein: 'Høyt protein',
        selectIngredients: 'Velg ingredienser',
        cookingTime: 'Tilberedningstid',
        cookingTip: "Koketips:",
        minutes: 'minutter',
        caloriesPerServing: 'Kalorier per porsjon',
        servings: 'porsjoner',
        allergens: 'Allergener',
        ingredients: 'Ingredienser',
        instructions: 'Instruksjoner',
        askQuestion: 'Stille et spørsmål',
        recipeLibrary: 'Oppskriftsbibliotek',
        loadMore: 'Last inn mer',
        loadNewRandomRecipes: 'Last inn flere oppskrifter',
        loadingRecipes: 'Laster {count} oppskrifter...',
        viewRecipe: 'Se oppskrift',
        noResultsFound: 'Ingen resultater funnet',
        search: 'Last opp bilde',
        decrease: 'Mindre',
        increase: 'Mer',
        uploading: "Laster opp",
        elapsedTime: "Tid brukt",
        seconds: "sekunder",
        cameraNotSupported: 'Kamera ikke støttet på denne enheten',
        nutritions: "Næringsverdier",
        calories: "Kalorier",
        protein: "Protein",
        carbs: "Karbohydrater",
        fat: "Fett",
        fiber: "Fiber",
        sugar: "Sukker",
        sodium: "Natrium",
        vitamina: "Vitamin A",
        vitaminc: "Vitamin C",
        calcium: "Kalsium",
        iron: "Jern",
        recipeDetails: "Oppskriftsdetaljer",
        loadMore: "Last inn flere oppskrifter",
        recipeAlreadySaved: 'Oppskriften er allerede lagret.',
        recipeSaved: 'Oppskriften ble lagret.',
        errorSavingRecipe: 'Feil ved lagring av oppskrift. Prøv igjen.',
        recipeShared: "Oppskrift delt via {platform}!",
        defaultSaveMessage: "Handling fullført!",
        share: "Del",
        favorite: "Favoritt",
        close: "Lukk",
        whatsapp: "WhatsApp",
        facebook: "Facebook",
        twitter: "Twitter",
        email: "E-post",
        loading: 'Søker etter nye oppskrifter...',
        tetrisTitle: "Spill Tetris mens du venter!",
        score: "Poengsum",
        highScore: "Høyeste poengsum",
        gameOver: "Spill slutt",
        playAgain: "Spill igjen",
        left: "Venstre",
        right: "Høyre",
        down: "Ned",
        rotate: "Roter",
        startTetris: "Spill Tetris",
        stopOrContinueTetris: "Oppskriftene er lastet inn. Vil du stoppe Tetris og se oppskriftene?",
        continueTetris: "Fortsett Tetris",
        playTetris: "Spill Tetris",
        viewRecipes: "Se oppskrifter",
        recipesLoaded: "SousChaif er klar med oppskriftene dine!",
        capturePhoto: "Ta bilde",
        closeCamera: "Lukk kamera",
        pictureIngredients: "Fotografer ingredienser",
        previewImage: "Godkjenn bilde",
        retake: "Ta på nytt",
        approve: "Send",
        waitingNotice: "Spill et spill mens du venter.",
        profile: "Profil",
        basicInformation: "Grunnleggende informasjon",
        name: "Navn",
        email: "E-post",
        savedRecipes: "Lagrede oppskrifter",
        noSavedRecipes: "Du har ingen lagrede oppskrifter ennå.",
        recipeRemoved: "Oppskriften {recipeName} ble fjernet fra favorittene dine.",
        newSearchQuestion: "Søke etter nye oppskrifter?",
        newSearchPrompt: "Vil du søke etter nye oppskrifter eller se dine tidligere resultater?",
        searchNewRecipes: "Søk etter nye oppskrifter",
        seeOldRecipes: "Se",
        chatBotIntro: "Selvfølgelig! Jeg er her for å hjelpe. Hvordan kan jeg hjelpe deg med ditt kulinariske eventyr på norsk?",
        chatWithSousChaif: "Chat med SousChaif",
        typeYourMessage: "Skriv din melding...",
        recipeLoaded: "Oppskrift lastet inn",
        askAboutRecipe: "Spør om oppskriften",
        errorFetchingData: "Det oppstod en feil ved henting av data.",
        whatQuestionWouldYouLikeToAsk: "Hvilket spørsmål vil du stille?",
        welcomeBack: "Velkommen tilbake",
        needHelpWithRecipe: "Trenger du hjelp med matlaging?",
        viewRecipesHome: "Still ditt spørsmål",
        popularIngredients: "Populære ingredienser",
        popularCookbooks: "Populære kokebøker",
        browseByLetter: "Bla gjennom etter bokstav",
        videoRecipes: "Video Oppskrifter",
        recipesByLetter: "Oppskrifter etter bokstav",
        noRecipesFound: "Ingen oppskrifter funnet",
        watchVideo: "Se video",
        loadMore: "Last Inn Mer",
        categories: "Kategorier",
        ingredients: "Ingredienser",
        filterBy: "Filtrer etter",
        all: "Alle",
        recipes: "oppskrifter",
        Chicken: "Kylling",
        Beef: "Storfekjøtt",
        Pork: "Svinekjøtt",
        Salmon: "Laks",
        Shrimp: "Reker",
        Eggs: "Egg",
        Tofu: "Tofu",
        Tuna: "Tunfisk",
        Potato: "Potet",
        Rice: "Ris",
        comments: "Kommentarer",
        addComment: "Legg til en kommentar",
        noComments: "Ingen kommentarer ennå. Vær den første!",
        submit: "Send inn",
        commentSubmitted: "Kommentar publisert!",
        errorSubmittingComment: "Feil ved publisering av kommentar.",
        backToWaiting: 'Tilbake',
        login: 'Logg inn',
        logout: 'Logg ut',
        cancelSubscription: 'Avslutt abonnement',
        deleteAccount: 'Slett konto',
        deleteAccountConfirm: 'Er du sikker på at du vil slette kontoen din? Denne handlingen kan ikke angres.',
        accountDeleted: 'Kontoen din ble slettet.',
        errorDeletingAccount: 'Feil ved sletting av konto.',
        ingredients: 'Ingredienser',
        instructions: 'Instruksjoner',
        askQuestion: 'Stille et spørsmål',
        recipeLibrary: 'Opskriftsbibliotek',
        loadMore: 'Indlæs mere',
        loadNewRandomRecipes: 'Indlæs flere opskrifter',
        loadingRecipes: 'Indlæser {count} opskrifter...',
        viewRecipe: 'Se opskrift',
        nutritionalInfo: 'Næringsinformasjon',
        preparationTime: 'Forberedelsestid',
        cookingTime: 'Tilberedningstid',
        servings: 'Porsjoner',
        minutes: 'minutter',
        likes: 'Likes',
        viewAll: 'Se alle',
        difficulty: 'Vanskelighetsgrad',
        easy: 'Lett',
        medium: 'Middels',
        hard: 'Vanskelig',
        cookingTips: 'Koketips',
        noCookingTip: 'Ingen koketips tilgjengelig.',
        foodWasteAndFacts: 'Matsvinn og fakta',
        noFoodWasteSaving: 'Ingen spareinformasjon tilgjengelig.',
        noFoodFact: 'Ingen matfakta tilgjengelig.',
        searchRecipes: 'Søk oppskrifter',
        searchPlaceholder: 'Søk etter oppskrifter...',
        noResults: 'Ingen resultater.',
        shoppingList: 'Handleliste',
        addItem: 'Legg til vare',
        add: 'Legg til',
        addIngredient: 'Legg til ingrediens',
        removeIngredient: 'Fjern ingrediens',
        clearList: 'Tøm liste',
        addToShoppingList: 'Legg til i handleliste',
        addedToShoppingList: 'Ingredienser lagt til handleliste!',
        quantity: 'Mengde',
        shoppingListEmpty: 'Handlelisten er tom.',
        tetris: 'Tetris',
        playTetris: 'Spill Tetris',
        barcodeScan: 'Strekkode skanning',
        scanBarcode: 'Skann strekkode',
        noCameraAccess: 'Kan ikke få tilgang til kamera.',
        invalidBarcode: 'Ugyldig strekkode.',
        productAdded: 'Produkt lagt til handlelisten.',
        productAlreadyInList: 'Produktet er allerede i listen.',
        productNotAdded: 'Produktet ble ikke lagt til.',
        // Ingredients (lowercase)
        chicken: 'kylling',
        beef: 'storfekjøtt',
        pork: 'svinekjøtt',
        salmon: 'laks',
        shrimp: 'reker',
        eggs: 'egg',
        tofu: 'tofu',
        tuna: 'tunfisk',
        potato: 'potet',
        rice: 'ris',
        // Ingredients (capitalized)
        Chicken: 'Kylling',
        Beef: 'Storfekjøtt',
        Pork: 'Svinekjøtt',
        Salmon: 'Laks',
        Shrimp: 'Reker',
        comments: 'Kommentarer',
        addComment: 'Legg igjen en kommentar',
        noComments: 'Ingen kommentarer ennå. Bli den første!',
        submit: 'Send inn',
        commentSubmitted: 'Kommentar sendt!',
        errorSubmittingComment: 'Feil ved innsending av kommentar.',
        backToWaiting: 'tilbake',
        welcome: 'Velkommen',
        welcomeMessage: 'Velkommen til sous-chaif! Vi gir deg personlige oppskrifter basert på bilder av ingrediensene dine.',
        getStarted: 'Kom i gang',
        personalizedRecipes: 'Personlige oppskrifter',
        personalizedRecipesDescription: 'Få tilpassede oppskrifter basert på bilder av ingrediensene dine.',
        smartShoppingList: 'Smart handleliste',
        smartShoppingListDescription: 'Lag handlelister basert på dine oppskrifter.',
        reduceFoodWaste: 'Reduser matsvinn',
        reduceFoodWasteDescription: 'Lær hvordan du reduserer matsvinn med våre smarte tips.',
        customRecipeSuggestions: 'Tilpassede oppskriftsforslag',
        customRecipeDescription: 'Skriv inn ingrediensene dine, preferanser og ernæringsmål, og sous-chaif lager tilpassede oppskrifter for deg.',
        secureAndEasy: 'Sikker og enkel',
        secureAndEasyDescription: 'Dine data er trygge hos oss. Nyt enkel tilgang til personlige oppskrifter og koketips.',
        featureWelcomeTitle: 'Velkommen til Souschaif!',
        featureWelcomeSubtitle: 'Last opp et bilde av ingrediensene eller kjøleskapet ditt og få oppskrifter med en gang. Du kan lukke dette vinduet når som helst.',
        featureWelcomeGotIt: 'Skjønner',
        featureWelcomeMainBadge: 'Viktigst',
        featureWelcomePhotoTitle: 'Last opp bilde av ingredienser eller kjøleskap',
        featureWelcomePhotoDescription: 'Ta eller last opp et bilde og få oppskrifter med en gang basert på det du har hjemme.',
        featureWelcomeChatDescription: 'Still spørsmål til vår AI-kokk og få personlige råd med en gang.',
        featureWelcomeLibraryDescription: 'Bla gjennom hundrevis av oppskrifter og filtrer etter ingredienser, allergener og tilberedningstid.',
        featureWelcomeShoppingDescription: 'Lag handlelister automatisk basert på oppskriftene dine.',
        usernameOrMobile: 'Brukernavn eller telefonnummer',
        rememberMe: 'Husk meg',
        logIn: 'Logg inn',
        noAccount: 'Har du ikke en konto?',
        signUp: 'Opprett konto',
        next: 'Neste',
        skip: 'Hopp over',
        defaultNotSubscribed: 'Du er ikke abonnent på denne tjenesten',
        defaultLoginError: 'Kan ikke bekrefte abonnementet ditt. Prøv igjen senere',
        signup: 'Opprett konto',
        signupIntro: 'Opprett en konto for å komme i gang',
        confirmPassword: 'Bekreft passord',
        signupButton: 'Opprett konto',
        signupError: 'Feil ved registrering',
        alreadySubscribed: 'Allerede registrert?',
        clickHere: 'Klikk her',
        signupSuccess: 'Konto opprettet',
        passwordRequirements: 'Passordkrav',
        minLength: 'Minst 8 tegn',
        requireUppercase: 'Minst én stor bokstav',
        requireLowercase: 'Minst én liten bokstav',
        requireNumber: 'Minst ett tall',
        requireSpecial: 'Minst ett spesialtegn',
        passwordsMatch: 'Passordene stemmer overens',
        passwordRequirementsNotMet: 'Vennligst oppfyll alle passordkrav',
        newPassword: 'Nytt passord',
        leaveEmptyToKeep: 'La stå tomt for å beholde nåværende passord',
        sessionId: 'Sesjons-ID',
        createdAt: 'Konto opprettet',
        errorFetchingUserData: 'Feil ved henting av brukerdata',
        errorUpdatingUser: 'Feil ved oppdatering av brukerdata',
        confirmUnsubscribe: 'Bekreft avslutning av abonnement',
        confirmUnsubscribeMessage: 'Er du sikker på at du vil avslutte abonnementet ditt?',
        confirmPasswordChange: 'Bekreft passordendring',
        confirmPasswordChangeMessage: 'Er du sikker på at du vil endre passordet ditt?',
        yes: 'Ja',
        cancel: 'Avbryt',
        // Database Recipes (Library 1) filters
        recipeLibraryTitle: "Oppskriftsbibliotek",
        recipesCount: "{count} oppskrifter",
        searchPlaceholder: "Søk etter oppskrifter...",
        filterByLetter: "Filtrer etter Bokstav",
        allLetters: "Alle",
        maxCalories: "Maks Kalorier",
        caloriesUnit: "kcal",
        maxCookingTime: "Maks Tid",
        minutesUnit: "min",
        minServings: "Min Porsjoner",
        maxServings: "Maks Porsjoner",
        selectAllergens: "Velg Allergener",
        typeToSearch: "Skriv for å søke...",
        selectNutritions: "Velg Næringsstoffer",
        selectIngredients: "Velg Ingredienser",
        clearFilters: "Fjern Filtre",
        noRecipesMatch: "Ingen oppskrifter matcher filtrene",
        dairy: "Melkeprodukter",
        soy: "Soya",
        shellfish: "Skalldyr",
        fish: "Fisk",
        showFilters: "Vis Filtre",
        hideFilters: "Skjul Filtre",
        viewAllRecipes: "Vis Alle Oppskrifter",
        filters: "Filtre",
        resetFilters: "Tilbakestill Filtre",
        tryAgain: "Prøv Igjen",
        addIngredient: "Legg til ingrediens",
        upTo: "Opp til",
        errorFetchingRecipes: "En feil oppstod under henting av oppskrifter",
        continentEurope: 'Europa',
        continentMiddleEast: 'Midtøsten',
        continentAsia: 'Asia',
        continentAfrica: 'Afrika',
        continentNorthAmerica: 'Nord-Amerika',
        continentSouthAmerica: 'Sør-Amerika',
        continentOceania: 'Oseania',
        backToContinents: 'Tilbake til Kontinenter',
        downloadRecipe: 'Last ned oppskrift',
        pdfDownloaded: 'PDF lastet ned!',
        errorDownloadingPdf: 'Feil ved nedlasting av PDF.',
        random: 'Tilfeldig',
        mostCommented: 'Mest Kommentert',
        mostLiked: 'Mest Likt',
        newest: 'Nyeste',
        quickest: 'Raskeste',
        lowestCalories: 'Færrest Kalorier',
        audioFetched: 'Lyden er klar til avspilling.',
        errorFetchingAudio: 'Feil ved henting av lyd. Vennligst prøv igjen.',
        loadingAudio: 'Laster lyd...',
        winePairings: 'Vinanbefalinger',
        errorWinePairing: 'Kunne ikke hente vinanbefalinger. Vennligst prøv igjen.',
        sharedOn: 'Oppskrift delt på',
        copiedToClipboard: 'Oppskrift kopiert til utklippstavlen!',
        shareError: 'Kunne ikke dele oppskriften.',
        photoTip: 'For best resultat, last opp et tydelig bilde av ingrediensene dine eller en rett.',
        noFoodDetected: 'Ingen mat eller ingredienser ble funnet på bildet ditt. Prøv igjen med et bilde av ingredienser eller en rett.',
        errorCompressingImage: 'Feil ved komprimering av bildet. Prøv et mindre bilde.',
        askingAboutCookbook: 'Spørsmål om kokebok:',
        askingAboutRecipe: 'Spørsmål om oppskrift:',
        submit: 'Send',
        noComments: 'Ingen kommentarer ennå. Bli den første til å kommentere!',
        comparePrices: 'Sammenlign Supermarkedspriser',
        comparingPrices: 'Sammenligner priser...',
        pricesFor: 'Priser for',
        priceComparison: 'Prissammenligning',
        estimate: 'estimat',
        potentialSavings: 'Mulig besparelse',
        cheapestAt: 'Billigst hos',
        cheapest: 'Billigst',
        priceDisclaimer: 'Prisene er AI-estimater og kan avvike fra faktiske butikkpriser.',
        budget: 'Billig',
        midRange: 'Mellomsegment',
        premium: 'Premium',
        clearListConfirmTitle: 'Tømme handlelisten?',
        clearListConfirmText: 'Dette vil fjerne alle varene fra listen din. Dette kan ikke angres.',
        allergyPreferences: 'Allergiinnstillinger',
        allergyPreferencesDescription: 'Velg allergenene dine nedenfor. Oppskrifter som inneholder disse vil bli skjult fra anbefalingene.',
        savePreferences: 'Lagre innstillinger',
        saving: 'Lagrer...',
        preferencesSaved: 'Allergiinnstillinger lagret!',
        errorSavingPreferences: 'Feil ved lagring av innstillinger',
    },
    'bahrain-arabic': {
        and: "و",
        validateWeight: "يجب أن يكون الوزن بين",
        validateHeight: "يجب أن يكون الطول بين",
        nutritionGoals: "الأهداف الغذائية",
        safetyAndDisclaimer: "الأمان والتنبيه القانوني",
        safetyAndDisclaimerText: "الأهداف هي تقديرات ولا تحل محل المشورة الطبية أو الغذائية أو الغذائية المهنية. إذا كنت تعاني من مشاكل صحية، استشر أخصائي رعاية صحية.",
        male: "ذكر",
        female: "أنثى",
        other: "آخر",
        allowed: "مسموح",
        pleaseEnterAWeight: "يرجى إدخال وزن",
        pleaseEnterAHeight: "يرجى إدخال طول",
        calories: "السعرات الحرارية",
        protein: "البروتين",
        fat: "الدهون",
        carbs: "الكربوهيدرات",
        sex: "الجنس",
        age: "العمر",
        weight: "الوزن",
        height: "الطول",
        activity: "النشاط",
        goal: "الهدف",
        computeGoals: "حساب الأهداف",
        light: "خفيف",
        moderate: "معتدل",
        veryActive: "نشط جداً",
        extraActive: "نشط للغاية",
        lose: "فقدان",
        maintain: "الحفاظ",
        gain: "زيادة",
        dailyTargets: "الأهداف اليومية",
        unableToFetchPrices: 'لا يمكن الحصول على الأسعار للعملة',
        loadingPrices: 'جاري تحميل الأسعار',
        currency: 'العملة',
        latestMarketPrices: 'أحدث أسعار السوق',
        countryCurrency: 'BHD',
        startScan: 'بدء المسح',
        scanAnother: 'مسح آخر',
        scanning: 'جاري المسح',
        vitaminD: 'فيتامين د',
        salt: 'الملح',
        protein: 'البروتين',
        fiber: 'الألياف',
        addedSugars: 'السكريات المضافة',
        sugars: 'السكريات',
        saturatedFat: 'الدهون المشبعة',
        fat: 'الدهون',
        energy: 'الطاقة',
        amount: 'الكمية',
        productNutrient: 'المغذيات',
        productNutritionalValuesPer100g: 'القيم الغذائية (لكل 100غ)',
        productIngredients: 'المكونات',
        productNutriScore: 'نوتري سكور',
        productBrand: 'العلامة التجارية',
        scanYourProductBarcode: 'امسح رمز الباركود لمنتجك!',
        productLookupFailed: 'فشل في البحث عن المنتج',
        productNotFoundError: 'المنتج غير موجود',
        cameraFailedStartError: 'لا يمكن تشغيل الكاميرا',
        profile: 'الملف الشخصي',
        basicInformation: 'المعلومات الأساسية',
        savedRecipes: 'الوصفات المحفوظة',
        noSavedRecipes: 'لا توجد وصفات محفوظة بعد.',
        userData: 'بيانات المستخدم',
        recipeRemoved: 'تم إزالة الوصفة {recipeName} من المفضلة.',
        username: 'اسم المستخدم',
        email: 'البريد الإلكتروني',
        mobileNumber: 'رقم الجوال',
        password: 'كلمة المرور',
        saveChanges: 'حفظ التغييرات',
        changesSaved: 'تم حفظ تغييراتك.',
        subscriptionInformation: 'معلومات الاشتراك',
        lastBillingDate: 'تاريخ آخر فوترة',
        nextBillingDate: 'تاريخ الفوترة التالية',
        subscriptionStarted: 'بدء الاشتراك',
        timesBilled: 'مرات الفوترة',
        serviceName: 'اسم الخدمة',
        termsAndConditions: 'الشروط والأحكام',
        viewTermsAndConditions: 'عرض الشروط والأحكام',
        pricingInformation: 'معلومات التسعير',
        unsubscribe: 'إلغاء الاشتراك',
        unsubscribed: 'تم إلغاء اشتراكك.',
        selectLanguage: "اختر لغتك",
        whatToDo: "ماذا تريد أن تفعل؟",
        takePhoto: "التقاط صورة",
        uploadPhoto: "رفع صورة",
        uploading: "جاري إنشاء وصفاتك المخصصة...",
        loadingTime: "قد يستغرق هذا حتى دقيقة واحدة...",
        analyzing: "الذكاء الاصطناعي يحلل صورتك...",
        aiAnalysisResult: "نتيجة تحليل الذكاء الاصطناعي:",
        uploadError: "حدث خطأ أثناء رفع الصورة.",
        processingError: "حدث خطأ أثناء معالجة الصورة.",
        numberOfPeople: 'عدد الأشخاص',
        timeOfDay: 'وقت اليوم',
        selectTimeOfDay: 'اختر وقت اليوم',
        breakfast: 'الإفطار',
        morningSnack: 'وجبة خفيفة صباحية',
        lunch: 'الغداء',
        afternoonSnack: 'وجبة خفيفة بعد الظهر',
        dinner: 'العشاء',
        eveningSnack: 'وجبة خفيفة مسائية',
        budgetFriendlyCooking: 'الطبخ الاقتصادي',
        budgetFriendlyDescription: 'احصل على وصفات مخصصة بناءً على المكونات المتوفرة لديك.',
        customRecipeSuggestions: 'اقتراحات وصفات مخصصة',
        customRecipeDescription: 'اكتب مكوناتك، تفضيلاتك وأهدافك الغذائية، وسيقوم sous-chaif بإنشاء وصفات مخصصة لك.',
        secureAndEasy: 'آمن وسهل',
        secureAndEasyDescription: 'بياناتك آمنة معنا. استمتع بالوصول السهل إلى الوصفات الشخصية ونصائح الطبخ.',
        alreadySubscribed: 'مسجل بالفعل؟',
        clickHere: 'انقر هنا',
        logIn: 'تسجيل الدخول',
        signingIn: 'جاري تسجيل الدخول...',
        noAccount: 'ليس لديك حساب؟',
        signUp: 'إنشاء حساب',
        next: 'التالي',
        skip: 'تخطي',
        defaultNotSubscribed: 'لست مشتركاً في هذه الخدمة',
        defaultLoginError: 'لا يمكن تأكيد اشتراكك. حاول مرة أخرى لاحقاً',
        signup: 'إنشاء حساب',
        signupIntro: 'أنشئ حساباً للبدء',
        email: 'البريد الإلكتروني',
        confirmPassword: 'تأكيد كلمة المرور',
        signupButton: 'إنشاء حساب',
        signupError: 'خطأ في التسجيل',
        alreadySubscribed: 'مسجل بالفعل؟',
        clickHere: 'انقر هنا',
        signupSuccess: 'تم إنشاء الحساب',
        passwordRequirements: 'متطلبات كلمة المرور',
        minLength: '8 أحرف على الأقل',
        requireUppercase: 'حرف كبير واحد على الأقل',
        requireLowercase: 'حرف صغير واحد على الأقل',
        requireNumber: 'رقم واحد على الأقل',
        requireSpecial: 'رمز خاص واحد على الأقل',
        passwordsMatch: 'كلمات المرور متطابقة',
        passwordRequirementsNotMet: 'يرجى تلبية جميع متطلبات كلمة المرور',
        newPassword: 'كلمة مرور جديدة',
        leaveEmptyToKeep: 'اتركها فارغة للاحتفاظ بكلمة المرور الحالية',
        sessionId: 'معرف الجلسة',
        createdAt: 'تم إنشاء الحساب',
        errorFetchingUserData: 'خطأ في جلب بيانات المستخدم',
        errorUpdatingUser: 'خطأ في تحديث بيانات المستخدم',
        confirmUnsubscribe: 'تأكيد إلغاء الاشتراك',
        confirmUnsubscribeMessage: 'هل أنت متأكد من أنك تريد إلغاء اشتراكك؟',
        confirmPasswordChange: 'تأكيد تغيير كلمة المرور',
        confirmPasswordChangeMessage: 'هل أنت متأكد من أنك تريد تغيير كلمة المرور؟',
        yes: 'نعم',
        cancel: 'إلغاء',
        downloadRecipe: 'تحميل الوصفة',
        pdfDownloaded: 'تم تحميل PDF بنجاح!',
        errorDownloadingPdf: 'خطأ في تحميل PDF.',
        random: 'عشوائي',
        mostCommented: 'الأكثر تعليقاً',
        mostLiked: 'الأكثر إعجاباً',
        newest: 'الأحدث',
        quickest: 'الأسرع',
        lowestCalories: 'أقل سعرات حرارية',
        audioFetched: 'الصوت جاهز للتشغيل.',
        errorFetchingAudio: 'خطأ في جلب الصوت. يرجى المحاولة مرة أخرى.',
        loadingAudio: 'جاري تحميل الصوت...',
        winePairings: 'اقتراحات النبيذ',
        errorWinePairing: 'تعذر الحصول على اقتراحات النبيذ. يرجى المحاولة مرة أخرى.',
        sharedOn: 'تمت مشاركة الوصفة على',
        copiedToClipboard: 'تم نسخ الوصفة إلى الحافظة!',
        shareError: 'تعذر مشاركة الوصفة.',
        photoTip: 'للحصول على أفضل النتائج، قم بتحميل صورة واضحة لمكوناتك أو طبقك.',
        noFoodDetected: 'لم يتم اكتشاف أي طعام أو مكونات في صورتك. يرجى المحاولة مرة أخرى بصورة مكونات أو طبق.',
        errorCompressingImage: 'خطأ في ضغط الصورة. جرب صورة أصغر.',
        askingAboutCookbook: 'أسئلة حول كتاب الطبخ:',
        askingAboutRecipe: 'أسئلة حول الوصفة:',
        submit: 'إرسال',
        noComments: 'لا توجد تعليقات بعد. كن أول من يعلق!',
        comparePrices: 'قارن أسعار السوبرماركت',
        comparingPrices: 'جاري مقارنة الأسعار...',
        pricesFor: 'الأسعار لـ',
        priceComparison: 'مقارنة الأسعار',
        estimate: 'تقدير',
        potentialSavings: 'التوفير المحتمل',
        cheapestAt: 'الأرخص في',
        cheapest: 'الأرخص',
        priceDisclaimer: 'الأسعار تقديرات ذكاء اصطناعي وقد تختلف عن الأسعار الفعلية في المتاجر.',
        budget: 'اقتصادي',
        midRange: 'متوسط',
        premium: 'فاخر',
        clearListConfirmTitle: 'مسح قائمة التسوق؟',
        clearListConfirmText: 'سيؤدي هذا إلى إزالة جميع العناصر من قائمتك. لا يمكن التراجع عن هذا الإجراء.',
        allergyPreferences: 'تفضيلات الحساسية',
        allergyPreferencesDescription: 'حدد مسببات الحساسية أدناه. سيتم إخفاء الوصفات التي تحتوي عليها من التوصيات.',
        savePreferences: 'حفظ التفضيلات',
        saving: 'جارٍ الحفظ...',
        preferencesSaved: 'تم حفظ تفضيلات الحساسية!',
        errorSavingPreferences: 'خطأ في حفظ التفضيلات',
    },
    'bahrain-english': {
        and: "and",
        validateWeight: "Weight must be between",
        validateHeight: "Height must be between",
        nutritionGoals: "Nutrition Goals",
        safetyAndDisclaimer: "Safety & Legal Disclaimer",
        safetyAndDisclaimerText: "Goals are estimates and do not replace professional medical, nutritional or dietary advice. If you have health problems, consult a healthcare professional.",
        male: "Male",
        female: "Female",
        other: "Other",
        allowed: "Allowed",
        pleaseEnterAWeight: "Please enter a weight",
        pleaseEnterAHeight: "Please enter a height",
        calories: "Calories",
        protein: "Protein",
        fat: "Fat",
        carbs: "Carbs",
        sex: "Sex",
        age: "Age",
        weight: "Weight",
        height: "Height",
        activity: "Activity",
        goal: "Goal",
        computeGoals: "Compute Goals",
        light: "Light",
        moderate: "Moderate",
        veryActive: "Very Active",
        extraActive: "Extra Active",
        lose: "Lose",
        maintain: "Maintain",
        gain: "Gain",
        dailyTargets: "Daily Targets",
        unableToFetchPrices: 'Unable to fetch prices for currency',
        loadingPrices: 'Loading prices',
        currency: 'Currency',
        latestMarketPrices: 'Latest Market Prices',
        countryCurrency: 'BHD',
        startScan: 'Start Scan',
        scanAnother: 'Scan Another',
        scanning: 'Scanning',
        vitaminD: 'Vitamin D',
        salt: 'Salt',
        protein: 'Protein',
        fiber: 'Fiber',
        addedSugars: 'Added Sugars',
        sugars: 'Sugars',
        saturatedFat: 'Saturated Fat',
        fat: 'Fat',
        energy: 'Energy',
        amount: 'Amount',
        productNutrient: 'Nutrient',
        productNutritionalValuesPer100g: 'Nutritional Values (per 100g)',
        productIngredients: 'Ingredients',
        productNutriScore: 'Nutri-Score',
        productBrand: 'Brand',
        scanYourProductBarcode: 'Scan your product barcode!',
        productLookupFailed: 'Product lookup failed',
        productNotFoundError: 'Product not found',
        cameraFailedStartError: 'Camera could not start',
        profile: 'Profile',
        basicInformation: 'Basic Information',
        savedRecipes: 'Saved Recipes',
        noSavedRecipes: 'No saved recipes yet.',
        userData: 'User Data',
        recipeRemoved: 'Recipe {recipeName} has been removed from your favorites.',
        username: 'Username',
        email: 'Email',
        mobileNumber: 'Mobile Number',
        password: 'Password',
        saveChanges: 'Save Changes',
        changesSaved: 'Your changes have been saved.',
        subscriptionInformation: 'Subscription Information',
        lastBillingDate: 'Last Billing Date',
        nextBillingDate: 'Next Billing Date',
        subscriptionStarted: 'Subscription Started',
        timesBilled: 'Times Billed',
        serviceName: 'Service Name',
        termsAndConditions: 'Terms and Conditions',
        viewTermsAndConditions: 'View Terms and Conditions',
        pricingInformation: 'Pricing Information',
        unsubscribe: 'Unsubscribe',
        unsubscribed: 'Your subscription has been cancelled.',
        selectLanguage: "Select your language",
        whatToDo: "What would you like to do?",
        takePhoto: "Take photo",
        uploadPhoto: "Upload photo",
        uploading: "Creating your personalized recipes...",
        loadingTime: "This may take up to 1 minute...",
        analyzing: "AI is analyzing your photo...",
        aiAnalysisResult: "AI Analysis Result:",
        uploadError: "An error occurred while uploading the image.",
        processingError: "An error occurred while processing the image.",
        numberOfPeople: 'Number of people',
        timeOfDay: 'Time of day',
        selectTimeOfDay: 'Select time of day',
        breakfast: 'Breakfast',
        morningSnack: 'Morning snack',
        lunch: 'Lunch',
        afternoonSnack: 'Afternoon snack',
        dinner: 'Dinner',
        eveningSnack: 'Evening snack',
        budgetFriendlyCooking: 'Budget-Friendly Cooking',
        budgetFriendlyDescription: 'Get personalized recipes based on the ingredients you have available.',
        customRecipeSuggestions: 'Custom Recipe Suggestions',
        customRecipeDescription: 'Enter your ingredients, preferences and nutritional goals, and sous-chaif will create personalized recipes for you.',
        secureAndEasy: 'Secure and Easy',
        secureAndEasyDescription: 'Your data is safe with us. Enjoy easy access to personalized recipes and cooking tips.',
        alreadySubscribed: 'Already subscribed?',
        clickHere: 'Click here',
        logIn: 'Log In',
        noAccount: 'Don\'t have an account?',
        signUp: 'Sign Up',
        next: 'Next',
        skip: 'Skip',
        defaultNotSubscribed: 'You are not subscribed to this service',
        defaultLoginError: 'Cannot confirm your subscription. Please try again later',
        signup: 'Sign Up',
        signupIntro: 'Create an account to get started',
        email: 'Email',
        confirmPassword: 'Confirm Password',
        signupButton: 'Sign Up',
        signupError: 'Signup Error',
        alreadySubscribed: 'Already subscribed?',
        signupSuccess: 'Account Created',
        passwordRequirements: 'Password Requirements',
        minLength: 'At least 8 characters',
        requireUppercase: 'At least one uppercase letter',
        requireLowercase: 'At least one lowercase letter',
        requireNumber: 'At least one number',
        requireSpecial: 'At least one special character',
        passwordsMatch: 'Passwords match',
        passwordRequirementsNotMet: 'Please meet all password requirements',
        newPassword: 'New Password',
        leaveEmptyToKeep: 'Leave empty to keep current password',
        sessionId: 'Session ID',
        createdAt: 'Account Created',
        errorFetchingUserData: 'Error fetching user data',
        errorUpdatingUser: 'Error updating user data',
        confirmUnsubscribe: 'Confirm Unsubscribe',
        confirmUnsubscribeMessage: 'Are you sure you want to unsubscribe?',
        confirmPasswordChange: 'Confirm Password Change',
        confirmPasswordChangeMessage: 'Are you sure you want to change your password?',
        yes: 'Yes',
        cancel: 'Cancel',
        popularCookbooks: 'Popular Cookbooks',
        browseByLetter: 'Browse by Letter',
        videoRecipes: 'Video Recipes',
        randomRecipes: 'Random Recipes',
        recipesByLetter: 'Recipes by Letter',
        noRecipesFound: 'No recipes found',
        watchVideo: 'Watch Video',
        loadMore: 'Load More',
        categories: 'Categories',
        ingredients: 'Ingredients',
        areas: 'Areas',
        filterBy: 'Filter by',
        all: 'All',
        continentEurope: 'Europe',
        continentMiddleEast: 'Middle East',
        continentAsia: 'Asia',
        continentAfrica: 'Africa',
        continentNorthAmerica: 'North America',
        continentSouthAmerica: 'South America',
        continentOceania: 'Oceania',
        backToContinents: 'Back to Continents',
        downloadRecipe: 'Download recipe',
        pdfDownloaded: 'PDF downloaded successfully!',
        errorDownloadingPdf: 'Error downloading PDF.',
        random: 'Random',
        mostCommented: 'Most Commented',
        mostLiked: 'Most Liked',
        newest: 'Newest',
        quickest: 'Quickest',
        lowestCalories: 'Lowest Calories',
        audioFetched: 'Audio is ready to play.',
        errorFetchingAudio: 'Error fetching audio. Please try again.',
        loadingAudio: 'Loading audio...',
        winePairings: 'Wine Pairings',
        errorWinePairing: 'Could not get wine pairings. Please try again.',
        sharedOn: 'Recipe shared on',
        copiedToClipboard: 'Recipe copied to clipboard!',
        shareError: 'Could not share recipe.',
        photoTip: 'For best results, upload a clear photo of your ingredients or a dish.',
        noFoodDetected: 'No food or ingredients were detected in your photo. Please try again with a photo of ingredients or a dish.',
        errorCompressingImage: 'Error compressing image. Please try a smaller photo.',
        askingAboutCookbook: 'Questions about cookbook:',
        askingAboutRecipe: 'Asking about recipe:',
        submit: 'Submit',
        noComments: 'No comments yet. Be the first to comment!',
        comparePrices: 'Compare Supermarket Prices',
        comparingPrices: 'Comparing prices...',
        pricesFor: 'Prices for',
        priceComparison: 'Price Comparison',
        estimate: 'estimate',
        potentialSavings: 'Potential savings',
        cheapestAt: 'Cheapest at',
        cheapest: 'Cheapest',
        priceDisclaimer: 'Prices are AI estimates and may differ from actual store prices.',
        budget: 'Budget',
        midRange: 'Mid-range',
        premium: 'Premium',
        clearListConfirmTitle: 'Clear shopping list?',
        clearListConfirmText: 'This will remove all items from your list. This cannot be undone.',
        allergyPreferences: 'Allergy Preferences',
        allergyPreferencesDescription: 'Select your allergens below. Recipes containing these will be hidden from recommendations.',
        savePreferences: 'Save Preferences',
        saving: 'Saving...',
        preferencesSaved: 'Allergy preferences saved!',
        errorSavingPreferences: 'Error saving preferences',
    },
    'uae-arabic': {
        and: "و",
        validateWeight: "يجب أن يكون الوزن بين",
        validateHeight: "يجب أن يكون الطول بين",
        nutritionGoals: "الأهداف الغذائية",
        safetyAndDisclaimer: "الأمان والتنبيه القانوني",
        safetyAndDisclaimerText: "الأهداف هي تقديرات ولا تحل محل المشورة الطبية أو الغذائية أو الغذائية المهنية. إذا كنت تعاني من مشاكل صحية، استشر أخصائي رعاية صحية.",
        male: "ذكر",
        female: "أنثى",
        other: "آخر",
        allowed: "مسموح",
        pleaseEnterAWeight: "يرجى إدخال وزن",
        pleaseEnterAHeight: "يرجى إدخال طول",
        calories: "السعرات الحرارية",
        protein: "البروتين",
        fat: "الدهون",
        carbs: "الكربوهيدرات",
        sex: "الجنس",
        age: "العمر",
        weight: "الوزن",
        height: "الطول",
        activity: "النشاط",
        goal: "الهدف",
        computeGoals: "حساب الأهداف",
        light: "خفيف",
        moderate: "معتدل",
        veryActive: "نشط جداً",
        extraActive: "نشط للغاية",
        lose: "فقدان",
        maintain: "الحفاظ",
        gain: "زيادة",
        dailyTargets: "الأهداف اليومية",
        unableToFetchPrices: 'لا يمكن الحصول على الأسعار للعملة',
        loadingPrices: 'جاري تحميل الأسعار',
        currency: 'العملة',
        latestMarketPrices: 'أحدث أسعار السوق',
        countryCurrency: 'AED',
        startScan: 'بدء المسح',
        scanAnother: 'مسح آخر',
        scanning: 'جاري المسح',
        vitaminD: 'فيتامين د',
        salt: 'الملح',
        protein: 'البروتين',
        fiber: 'الألياف',
        addedSugars: 'السكريات المضافة',
        sugars: 'السكريات',
        saturatedFat: 'الدهون المشبعة',
        fat: 'الدهون',
        energy: 'الطاقة',
        amount: 'الكمية',
        productNutrient: 'المغذيات',
        productNutritionalValuesPer100g: 'القيم الغذائية (لكل 100غ)',
        productIngredients: 'المكونات',
        productNutriScore: 'نوتري سكور',
        productBrand: 'العلامة التجارية',
        scanYourProductBarcode: 'امسح رمز الباركود لمنتجك!',
        productLookupFailed: 'فشل في البحث عن المنتج',
        productNotFoundError: 'المنتج غير موجود',
        cameraFailedStartError: 'لا يمكن تشغيل الكاميرا',
        profile: 'الملف الشخصي',
        basicInformation: 'المعلومات الأساسية',
        savedRecipes: 'الوصفات المحفوظة',
        noSavedRecipes: 'لا توجد وصفات محفوظة بعد.',
        userData: 'بيانات المستخدم',
        recipeRemoved: 'تم إزالة الوصفة {recipeName} من المفضلة.',
        username: 'اسم المستخدم',
        email: 'البريد الإلكتروني',
        mobileNumber: 'رقم الجوال',
        password: 'كلمة المرور',
        saveChanges: 'حفظ التغييرات',
        changesSaved: 'تم حفظ تغييراتك.',
        subscriptionInformation: 'معلومات الاشتراك',
        lastBillingDate: 'تاريخ آخر فوترة',
        nextBillingDate: 'تاريخ الفوترة التالية',
        subscriptionStarted: 'بدء الاشتراك',
        timesBilled: 'مرات الفوترة',
        serviceName: 'اسم الخدمة',
        termsAndConditions: 'الشروط والأحكام',
        viewTermsAndConditions: 'عرض الشروط والأحكام',
        pricingInformation: 'معلومات التسعير',
        unsubscribe: 'إلغاء الاشتراك',
        unsubscribed: 'تم إلغاء اشتراكك.',
        selectLanguage: "اختر لغتك",
        whatToDo: "ماذا تريد أن تفعل؟",
        takePhoto: "التقاط صورة",
        uploadPhoto: "رفع صورة",
        uploading: "جاري إنشاء وصفاتك المخصصة...",
        loadingTime: "قد يستغرق هذا حتى دقيقة واحدة...",
        analyzing: "الذكاء الاصطناعي يحلل صورتك...",
        aiAnalysisResult: "نتيجة تحليل الذكاء الاصطناعي:",
        uploadError: "حدث خطأ أثناء رفع الصورة.",
        processingError: "حدث خطأ أثناء معالجة الصورة.",
        numberOfPeople: 'عدد الأشخاص',
        timeOfDay: 'وقت اليوم',
        selectTimeOfDay: 'اختر وقت اليوم',
        breakfast: 'الإفطار',
        morningSnack: 'وجبة خفيفة صباحية',
        lunch: 'الغداء',
        afternoonSnack: 'وجبة خفيفة بعد الظهر',
        dinner: 'العشاء',
        eveningSnack: 'وجبة خفيفة مسائية',
        budgetFriendlyCooking: 'الطبخ الاقتصادي',
        budgetFriendlyDescription: 'احصل على وصفات مخصصة بناءً على المكونات المتوفرة لديك.',
        customRecipeSuggestions: 'اقتراحات وصفات مخصصة',
        customRecipeDescription: 'اكتب مكوناتك، تفضيلاتك وأهدافك الغذائية، وسيقوم sous-chaif بإنشاء وصفات مخصصة لك.',
        secureAndEasy: 'آمن وسهل',
        secureAndEasyDescription: 'بياناتك آمنة معنا. استمتع بالوصول السهل إلى الوصفات الشخصية ونصائح الطبخ.',
        alreadySubscribed: 'مسجل بالفعل؟',
        clickHere: 'انقر هنا',
        logIn: 'تسجيل الدخول',
        signingIn: 'جاري تسجيل الدخول...',
        noAccount: 'ليس لديك حساب؟',
        signUp: 'إنشاء حساب',
        next: 'التالي',
        skip: 'تخطي',
        defaultNotSubscribed: 'لست مشتركاً في هذه الخدمة',
        defaultLoginError: 'لا يمكن تأكيد اشتراكك. حاول مرة أخرى لاحقاً',
        signup: 'إنشاء حساب',
        signupIntro: 'أنشئ حساباً للبدء',
        email: 'البريد الإلكتروني',
        confirmPassword: 'تأكيد كلمة المرور',
        signupButton: 'إنشاء حساب',
        signupError: 'خطأ في التسجيل',
        alreadySubscribed: 'مسجل بالفعل؟',
        clickHere: 'انقر هنا',
        signupSuccess: 'تم إنشاء الحساب',
        passwordRequirements: 'متطلبات كلمة المرور',
        minLength: '8 أحرف على الأقل',
        requireUppercase: 'حرف كبير واحد على الأقل',
        requireLowercase: 'حرف صغير واحد على الأقل',
        requireNumber: 'رقم واحد على الأقل',
        requireSpecial: 'رمز خاص واحد على الأقل',
        passwordsMatch: 'كلمات المرور متطابقة',
        passwordRequirementsNotMet: 'يرجى تلبية جميع متطلبات كلمة المرور',
        newPassword: 'كلمة مرور جديدة',
        leaveEmptyToKeep: 'اتركها فارغة للاحتفاظ بكلمة المرور الحالية',
        sessionId: 'معرف الجلسة',
        createdAt: 'تم إنشاء الحساب',
        errorFetchingUserData: 'خطأ في جلب بيانات المستخدم',
        errorUpdatingUser: 'خطأ في تحديث بيانات المستخدم',
        confirmUnsubscribe: 'تأكيد إلغاء الاشتراك',
        confirmUnsubscribeMessage: 'هل أنت متأكد من أنك تريد إلغاء اشتراكك؟',
        confirmPasswordChange: 'تأكيد تغيير كلمة المرور',
        confirmPasswordChangeMessage: 'هل أنت متأكد من أنك تريد تغيير كلمة المرور؟',
        yes: 'نعم',
        cancel: 'إلغاء',
        popularCookbooks: 'كتب الطبخ الشائعة',
        browseByLetter: 'تصفح حسب الحرف',
        videoRecipes: 'وصفات الفيديو',
        randomRecipes: 'وصفات عشوائية',
        recipesByLetter: 'وصفات حسب الحرف',
        noRecipesFound: 'لا توجد وصفات',
        watchVideo: 'شاهد الفيديو',
        loadMore: 'تحميل المزيد',
        categories: 'الفئات',
        ingredients: 'المكونات',
        areas: 'المناطق',
        filterBy: 'تصفية حسب',
        all: 'الكل',
        pleaseAddPhotoFirst: "يرجى إضافة صورة أولاً أو التقاط صورة",
        continentEurope: 'أوروبا',
        continentMiddleEast: 'الشرق الأوسط',
        continentAsia: 'آسيا',
        continentAfrica: 'أفريقيا',
        continentNorthAmerica: 'أمريكا الشمالية',
        continentSouthAmerica: 'أمريكا الجنوبية',
        continentOceania: 'أوقيانوسيا',
        backToContinents: 'العودة إلى القارات',
        downloadRecipe: 'تحميل الوصفة',
        pdfDownloaded: 'تم تحميل PDF بنجاح!',
        errorDownloadingPdf: 'خطأ في تحميل PDF.',
        random: 'عشوائي',
        mostCommented: 'الأكثر تعليقاً',
        mostLiked: 'الأكثر إعجاباً',
        newest: 'الأحدث',
        quickest: 'الأسرع',
        lowestCalories: 'أقل سعرات حرارية',
        audioFetched: 'الصوت جاهز للتشغيل.',
        errorFetchingAudio: 'خطأ في جلب الصوت. يرجى المحاولة مرة أخرى.',
        loadingAudio: 'جاري تحميل الصوت...',
        winePairings: 'اقتراحات النبيذ',
        errorWinePairing: 'تعذر الحصول على اقتراحات النبيذ. يرجى المحاولة مرة أخرى.',
        sharedOn: 'تمت مشاركة الوصفة على',
        copiedToClipboard: 'تم نسخ الوصفة إلى الحافظة!',
        shareError: 'تعذر مشاركة الوصفة.',
        photoTip: 'للحصول على أفضل النتائج، قم بتحميل صورة واضحة لمكوناتك أو طبقك.',
        noFoodDetected: 'لم يتم اكتشاف أي طعام أو مكونات في صورتك. يرجى المحاولة مرة أخرى بصورة مكونات أو طبق.',
        errorCompressingImage: 'خطأ في ضغط الصورة. جرب صورة أصغر.',
        askingAboutCookbook: 'أسئلة حول كتاب الطبخ:',
        askingAboutRecipe: 'أسئلة حول الوصفة:',
        submit: 'إرسال',
        noComments: 'لا توجد تعليقات بعد. كن أول من يعلق!',
        comparePrices: 'قارن أسعار السوبرماركت',
        comparingPrices: 'جاري مقارنة الأسعار...',
        pricesFor: 'الأسعار لـ',
        priceComparison: 'مقارنة الأسعار',
        estimate: 'تقدير',
        potentialSavings: 'التوفير المحتمل',
        cheapestAt: 'الأرخص في',
        cheapest: 'الأرخص',
        priceDisclaimer: 'الأسعار تقديرات ذكاء اصطناعي وقد تختلف عن الأسعار الفعلية في المتاجر.',
        budget: 'اقتصادي',
        midRange: 'متوسط',
        premium: 'فاخر',
        clearListConfirmTitle: 'مسح قائمة التسوق؟',
        clearListConfirmText: 'سيؤدي هذا إلى إزالة جميع العناصر من قائمتك. لا يمكن التراجع عن هذا الإجراء.',
        allergyPreferences: 'تفضيلات الحساسية',
        allergyPreferencesDescription: 'حدد مسببات الحساسية أدناه. سيتم إخفاء الوصفات التي تحتوي عليها من التوصيات.',
        savePreferences: 'حفظ التفضيلات',
        saving: 'جارٍ الحفظ...',
        preferencesSaved: 'تم حفظ تفضيلات الحساسية!',
        errorSavingPreferences: 'خطأ في حفظ التفضيلات',
    },
    'uae-english': {
        and: "and",
        validateWeight: "Weight must be between",
        validateHeight: "Height must be between",
        nutritionGoals: "Nutrition Goals",
        safetyAndDisclaimer: "Safety & Legal Disclaimer",
        safetyAndDisclaimerText: "Goals are estimates and do not replace professional medical, nutritional or dietary advice. If you have health problems, consult a healthcare professional.",
        male: "Male",
        female: "Female",
        other: "Other",
        allowed: "Allowed",
        pleaseEnterAWeight: "Please enter a weight",
        pleaseEnterAHeight: "Please enter a height",
        calories: "Calories",
        protein: "Protein",
        fat: "Fat",
        carbs: "Carbs",
        sex: "Sex",
        age: "Age",
        weight: "Weight",
        height: "Height",
        activity: "Activity",
        goal: "Goal",
        computeGoals: "Compute Goals",
        light: "Light",
        moderate: "Moderate",
        veryActive: "Very Active",
        extraActive: "Extra Active",
        lose: "Lose",
        maintain: "Maintain",
        gain: "Gain",
        dailyTargets: "Daily Targets",
        unableToFetchPrices: 'Unable to fetch prices for currency',
        loadingPrices: 'Loading prices',
        currency: 'Currency',
        latestMarketPrices: 'Latest Market Prices',
        countryCurrency: 'AED',
        startScan: 'Start Scan',
        scanAnother: 'Scan Another',
        scanning: 'Scanning',
        vitaminD: 'Vitamin D',
        salt: 'Salt',
        protein: 'Protein',
        fiber: 'Fiber',
        addedSugars: 'Added Sugars',
        sugars: 'Sugars',
        saturatedFat: 'Saturated Fat',
        fat: 'Fat',
        energy: 'Energy',
        amount: 'Amount',
        productNutrient: 'Nutrient',
        productNutritionalValuesPer100g: 'Nutritional Values (per 100g)',
        productIngredients: 'Ingredients',
        productNutriScore: 'Nutri-Score',
        productBrand: 'Brand',
        scanYourProductBarcode: 'Scan your product barcode!',
        productLookupFailed: 'Product lookup failed',
        productNotFoundError: 'Product not found',
        cameraFailedStartError: 'Camera could not start',
        profile: 'Profile',
        basicInformation: 'Basic Information',
        savedRecipes: 'Saved Recipes',
        noSavedRecipes: 'No saved recipes yet.',
        userData: 'User Data',
        recipeRemoved: 'Recipe {recipeName} has been removed from your favorites.',
        username: 'Username',
        email: 'Email',
        mobileNumber: 'Mobile Number',
        password: 'Password',
        saveChanges: 'Save Changes',
        changesSaved: 'Your changes have been saved.',
        subscriptionInformation: 'Subscription Information',
        lastBillingDate: 'Last Billing Date',
        nextBillingDate: 'Next Billing Date',
        subscriptionStarted: 'Subscription Started',
        timesBilled: 'Times Billed',
        serviceName: 'Service Name',
        termsAndConditions: 'Terms and Conditions',
        viewTermsAndConditions: 'View Terms and Conditions',
        pricingInformation: 'Pricing Information',
        unsubscribe: 'Unsubscribe',
        unsubscribed: 'Your subscription has been cancelled.',
        selectLanguage: "Select your language",
        whatToDo: "What would you like to do?",
        takePhoto: "Take photo",
        uploadPhoto: "Upload photo",
        uploading: "Creating your personalized recipes...",
        loadingTime: "This may take up to 1 minute...",
        analyzing: "AI is analyzing your photo...",
        aiAnalysisResult: "AI Analysis Result:",
        uploadError: "An error occurred while uploading the image.",
        processingError: "An error occurred while processing the image.",
        numberOfPeople: 'Number of people',
        timeOfDay: 'Time of day',
        selectTimeOfDay: 'Select time of day',
        breakfast: 'Breakfast',
        morningSnack: 'Morning snack',
        lunch: 'Lunch',
        afternoonSnack: 'Afternoon snack',
        dinner: 'Dinner',
        eveningSnack: 'Evening snack',
        budgetFriendlyCooking: 'Budget-Friendly Cooking',
        budgetFriendlyDescription: 'Get personalized recipes based on the ingredients you have available.',
        customRecipeSuggestions: 'Custom Recipe Suggestions',
        customRecipeDescription: 'Enter your ingredients, preferences and nutritional goals, and sous-chaif will create personalized recipes for you.',
        secureAndEasy: 'Secure and Easy',
        secureAndEasyDescription: 'Your data is safe with us. Enjoy easy access to personalized recipes and cooking tips.',
        alreadySubscribed: 'Already subscribed?',
        clickHere: 'Click here',
        logIn: 'Log In',
        noAccount: 'Don\'t have an account?',
        signUp: 'Sign Up',
        next: 'Next',
        skip: 'Skip',
        defaultNotSubscribed: 'You are not subscribed to this service',
        defaultLoginError: 'Cannot confirm your subscription. Please try again later',
        signup: 'Sign Up',
        signupIntro: 'Create an account to get started',
        email: 'Email',
        confirmPassword: 'Confirm Password',
        signupButton: 'Sign Up',
        signupError: 'Signup Error',
        alreadySubscribed: 'Already subscribed?',
        signupSuccess: 'Account Created',
        passwordRequirements: 'Password Requirements',
        minLength: 'At least 8 characters',
        requireUppercase: 'At least one uppercase letter',
        requireLowercase: 'At least one lowercase letter',
        requireNumber: 'At least one number',
        requireSpecial: 'At least one special character',
        passwordsMatch: 'Passwords match',
        passwordRequirementsNotMet: 'Please meet all password requirements',
        newPassword: 'New Password',
        leaveEmptyToKeep: 'Leave empty to keep current password',
        sessionId: 'Session ID',
        createdAt: 'Account Created',
        errorFetchingUserData: 'Error fetching user data',
        errorUpdatingUser: 'Error updating user data',
        confirmUnsubscribe: 'Confirm Unsubscribe',
        confirmUnsubscribeMessage: 'Are you sure you want to unsubscribe?',
        confirmPasswordChange: 'Confirm Password Change',
        confirmPasswordChangeMessage: 'Are you sure you want to change your password?',
        yes: 'Yes',
        cancel: 'Cancel',
        popularCookbooks: 'Popular Cookbooks',
        browseByLetter: 'Browse by Letter',
        videoRecipes: 'Video Recipes',
        randomRecipes: 'Random Recipes',
        recipesByLetter: 'Recipes by Letter',
        noRecipesFound: 'No recipes found',
        watchVideo: 'Watch Video',
        loadMore: 'Load More',
        categories: 'Categories',
        ingredients: 'Ingredients',
        areas: 'Areas',
        filterBy: 'Filter by',
        all: 'All',
        pleaseAddPhotoFirst: "Please add a photo first or take a photo",
        continentEurope: 'Europe',
        continentMiddleEast: 'Middle East',
        continentAsia: 'Asia',
        continentAfrica: 'Africa',
        continentNorthAmerica: 'North America',
        continentSouthAmerica: 'South America',
        continentOceania: 'Oceania',
        backToContinents: 'Back to Continents',
        downloadRecipe: 'Download recipe',
        pdfDownloaded: 'PDF downloaded successfully!',
        errorDownloadingPdf: 'Error downloading PDF.',
        random: 'Random',
        mostCommented: 'Most Commented',
        mostLiked: 'Most Liked',
        newest: 'Newest',
        quickest: 'Quickest',
        lowestCalories: 'Lowest Calories',
        audioFetched: 'Audio is ready to play.',
        errorFetchingAudio: 'Error fetching audio. Please try again.',
        loadingAudio: 'Loading audio...',
        winePairings: 'Wine Pairings',
        errorWinePairing: 'Could not get wine pairings. Please try again.',
        sharedOn: 'Recipe shared on',
        copiedToClipboard: 'Recipe copied to clipboard!',
        shareError: 'Could not share recipe.',
        photoTip: 'For best results, upload a clear photo of your ingredients or a dish.',
        noFoodDetected: 'No food or ingredients were detected in your photo. Please try again with a photo of ingredients or a dish.',
        errorCompressingImage: 'Error compressing image. Please try a smaller photo.',
        askingAboutCookbook: 'Questions about cookbook:',
        askingAboutRecipe: 'Asking about recipe:',
        submit: 'Submit',
        noComments: 'No comments yet. Be the first to comment!',
        comparePrices: 'Compare Supermarket Prices',
        comparingPrices: 'Comparing prices...',
        pricesFor: 'Prices for',
        priceComparison: 'Price Comparison',
        estimate: 'estimate',
        potentialSavings: 'Potential savings',
        cheapestAt: 'Cheapest at',
        cheapest: 'Cheapest',
        priceDisclaimer: 'Prices are AI estimates and may differ from actual store prices.',
        budget: 'Budget',
        midRange: 'Mid-range',
        premium: 'Premium',
        clearListConfirmTitle: 'Clear shopping list?',
        clearListConfirmText: 'This will remove all items from your list. This cannot be undone.',
        allergyPreferences: 'Allergy Preferences',
        allergyPreferencesDescription: 'Select your allergens below. Recipes containing these will be hidden from recommendations.',
        savePreferences: 'Save Preferences',
        saving: 'Saving...',
        preferencesSaved: 'Allergy preferences saved!',
        errorSavingPreferences: 'Error saving preferences',
    },
    danish: {
        and: "og",
        validateWeight: "Vægt skal være mellem",
        validateHeight: "Højde skal være mellem",
        nutritionGoals: "Ernæringsmål",
        safetyAndDisclaimer: "Sikkerhed & Ansvarsfraskrivelse",
        safetyAndDisclaimerText: "Målene er estimater og erstatter ikke professionel medicinsk, ernæringsmæssig eller diætmæssig rådgivning. Hvis du har helbredsproblemer, skal du konsultere en sundhedsprofessionel.",
        male: "Mand",
        female: "Kvinde",
        other: "Andet",
        allowed: "Tilladt",
        pleaseEnterAWeight: "Indtast venligst en vægt",
        pleaseEnterAHeight: "Indtast venligst en højde",
        calories: "Kalorier",
        protein: "Protein",
        fat: "Fedt",
        carbs: "Kulhydrater",
        sex: "Køn",
        age: "Alder",
        weight: "Vægt",
        height: "Højde",
        activity: "Aktivitet",
        goal: "Mål",
        computeGoals: "Beregn mål",
        light: "Let",
        moderate: "Moderat",
        veryActive: "Meget aktiv",
        extraActive: "Ekstra aktiv",
        lose: "Tab",
        maintain: "Vedligehold",
        gain: "Øg",
        dailyTargets: "Daglige mål",
        unableToFetchPrices: 'Kan ikke hente priser for valuta',
        loadingPrices: 'Indlæser priser',
        currency: 'Valuta',
        latestMarketPrices: 'Seneste markedspriser',
        countryCurrency: 'DKK',
        startScan: 'Start scanning',
        scanAnother: 'Scan en anden',
        scanning: 'Scanner',
        vitaminD: 'D-vitamin',
        salt: 'Salt',
        fiber: 'Fiber',
        addedSugars: 'Tilsat sukker',
        sugars: 'Sukkerarter',
        saturatedFat: 'Mættet fedt',
        energy: 'Energi',
        amount: 'Mængde',
        productNutrient: 'Næringsstof',
        productNutritionalValuesPer100g: 'Næringsværdi (per 100g)',
        productIngredients: 'Ingredienser',
        productNutriScore: 'Nutri-Score',
        productBrand: 'Mærke',
        scanYourProductBarcode: 'Scan din produktstregkode!',
        productLookupFailed: 'Produktopslag mislykkedes',
        productNotFoundError: 'Produkt ikke fundet',
        cameraFailedStartError: 'Kamera kunne ikke startes',
        profile: 'Profil',
        basicInformation: 'Grundlæggende oplysninger',
        savedRecipes: 'Gemte opskrifter',
        noSavedRecipes: 'Du har ingen gemte opskrifter.',
        userData: 'Brugerdata',
        recipeRemoved: 'Opskriften {recipeName} er blevet fjernet fra dine favoritter.',
        username: 'Brugernavn',
        mobileNumber: 'Mobilnummer',
        password: 'Adgangskode',
        saveChanges: 'Gem ændringer',
        changesSaved: 'Dine ændringer er blevet gemt.',
        subscriptionInformation: 'Abonnementsoplysninger',
        lastBillingDate: 'Sidste faktureringsdato',
        nextBillingDate: 'Næste faktureringsdato',
        subscriptionStarted: 'Abonnement startet',
        timesBilled: 'Gange faktureret',
        serviceName: 'Tjenestenavn',
        termsAndConditions: 'Vilkår og betingelser',
        viewTermsAndConditions: 'Se vilkår og betingelser',
        pricingInformation: 'Prisoplysninger',
        unsubscribe: 'Afmeld',
        unsubscribed: 'Du er blevet afmeldt.',
        selectLanguage: 'Vælg dit sprog',
        whatToDo: 'Hvad vil du gøre?',
        takePhoto: 'Tag foto',
        uploadPhoto: 'Upload foto',
        pleaseAddPhotoFirst: 'Tilføj venligst et foto først eller tag et foto',
        uploading: 'Opretter dine personlige opskrifter...',
        loadingTime: 'Dette kan tage op til 1 minut...',
        analyzing: 'AI analyserer dit foto...',
        aiAnalysisResult: 'AI-analyseresultat:',
        uploadError: 'Der opstod en fejl ved upload af billedet.',
        processingError: 'Der opstod en fejl ved behandling af billedet.',
        numberOfPeople: 'Antal personer',
        timeOfDay: 'Tidspunkt på dagen',
        selectTimeOfDay: 'Vælg tidspunkt på dagen',
        breakfast: 'Morgenmad',
        morningSnack: 'Formiddagssnack',
        lunch: 'Frokost',
        afternoonSnack: 'Eftermiddagssnack',
        dinner: 'Aftensmad',
        dessert: 'Dessert',
        lateNightSnack: 'Sen aften snack',
        preferredCuisine: 'Foretrukket køkken',
        selectCuisine: 'Vælg køkken',
        italian: 'Italiensk',
        chinese: 'Kinesisk',
        indian: 'Indisk',
        mexican: 'Mexicansk',
        french: 'Fransk',
        thai: 'Thailandsk',
        japanese: 'Japansk',
        mediterranean: 'Middelhavs',
        spanish: 'Spansk',
        greek: 'Græsk',
        vietnamese: 'Vietnamesisk',
        american: 'Amerikansk',
        turkish: 'Tyrkisk',
        korean: 'Koreansk',
        moroccan: 'Marokkansk',
        persian: 'Persisk',
        allergies: 'Allergier',
        selectAllergies: 'Vælg allergier',
        gluten: 'Gluten',
        nuts: 'Nødder',
        lactose: 'Laktose',
        soy: 'Soja',
        shellfish: 'Skaldyr',
        fish: 'Fisk',
        eggs: 'Æg',
        peanuts: 'Jordnødder',
        sesame: 'Sesam',
        sulphites: 'Sulfitter',
        mustard: 'Sennep',
        celery: 'Selleri',
        lupin: 'Lupin',
        molluscs: 'Bløddyr',
        cookingTime: 'Tilberedningstid',
        cookingTip: 'Madlavningstip:',
        minutes: 'minutter',
        caloriesPerServing: 'Kalorier per portion',
        servings: 'portioner',
        allergens: 'Allergener',
        ingredients: 'Ingredienser',
        instructions: 'Instruktioner',
        noResultsFound: 'Ingen resultater fundet',
        search: 'Upload billede',
        decrease: 'Minus',
        increase: 'Plus',
        elapsedTime: 'Forløbet tid',
        seconds: 'sekunder',
        cameraNotSupported: 'Kamera understøttes ikke på denne enhed',
        nutritions: 'Næringsværdier',
        sugar: 'Sukker',
        sodium: 'Natrium',
        vitamina: 'A-vitamin',
        vitaminc: 'C-vitamin',
        calcium: 'Calcium',
        iron: 'Jern',
        recipeDetails: 'Opskriftsdetaljer',
        loadMore: 'Indlæs flere opskrifter',
        recipeAlreadySaved: 'Opskriften er allerede gemt.',
        recipeSaved: 'Opskriften er blevet gemt.',
        errorSavingRecipe: 'Fejl ved lagring af opskriften. Prøv venligst igen.',
        recipeShared: 'Opskrift delt via {platform}!',
        defaultSaveMessage: 'Handling gennemført!',
        pleaseLogin: 'Log venligst ind for at fortsætte',
        noIngredientsFound: 'Ingen ingredienser fundet til indkøbslisten',
        noValidIngredients: 'Ingen gyldige ingredienser fundet',
        addedToShoppingList: 'Tilføjet',
        toShoppingList: 'til indkøbslisten',
        errorAddingToShoppingList: 'Fejl ved tilføjelse til indkøbslisten',
        noImageAvailable: 'Intet billede tilgængeligt',
        askQuestion: 'Stil et spørgsmål',
        recipeLibrary: 'Opskriftsbibliotek',
        loadNewRandomRecipes: 'Indlæs flere opskrifter',
        loadingRecipes: 'Indlæser {count} opskrifter...',
        viewRecipe: 'Se opskrift',
        share: 'Del',
        favorite: 'Favorit',
        close: 'Luk',
        whatsapp: 'WhatsApp',
        facebook: 'Facebook',
        twitter: 'Twitter',
        email: 'E-mail',
        loading: 'Henter nye opskrifter...',
        tetrisTitle: 'Spil Tetris mens du venter!',
        score: 'Score',
        highScore: 'Højeste score',
        gameOver: 'Spil slut',
        playAgain: 'Spil igen',
        left: 'Venstre',
        right: 'Højre',
        down: 'Ned',
        rotate: 'Roter',
        startTetris: 'Spil Tetris',
        stopOrContinueTetris: 'Opskrifter er indlæst. Vil du stoppe Tetris og se opskrifterne?',
        continueTetris: 'Fortsæt Tetris',
        playTetris: 'Spil Tetris',
        viewRecipes: 'Se opskrifter',
        recipesLoaded: 'SousChaif er klar med dine opskrifter!',
        capturePhoto: 'Tag foto',
        closeCamera: 'Luk kamera',
        pictureIngredients: 'Fotografer ingredienser',
        previewImage: 'Godkend billede',
        retake: 'Tag igen',
        approve: 'Send',
        waitingNotice: 'Spil et spil mens du venter.',
        name: 'Navn',
        newSearchQuestion: 'Søg efter nye opskrifter?',
        newSearchPrompt: 'Vil du søge efter nye opskrifter eller se dine tidligere resultater?',
        searchNewRecipes: 'Søg nye opskrifter',
        seeOldRecipes: 'Se',
        chatBotIntro: 'Velkommen, jeg er SousChaif. Hvordan kan jeg hjælpe dig i dag?',
        chatWithSousChaif: 'Chat med SousChaif',
        typeYourMessage: 'Skriv din besked...',
        recipeLoaded: 'Opskrift indlæst',
        askAboutRecipe: 'Spørg om opskrift',
        errorFetchingData: 'Der opstod en fejl ved hentning af data.',
        whatQuestionWouldYouLikeToAsk: 'Hvilket spørgsmål vil du stille?',
        welcomeBack: 'Velkommen tilbage',
        needHelpWithRecipe: 'Har du brug for hjælp til madlavning?',
        viewRecipesHome: 'Stil dit spørgsmål',
        popularIngredients: 'Populære ingredienser',
        popularCookbooks: 'Populære kogebøger',
        browseByLetter: 'Gennemse efter bogstav',
        videoRecipes: 'Videoopskrifter',
        randomRecipes: 'Tilfældige opskrifter',
        recipesByLetter: 'Opskrifter efter bogstav',
        noRecipesFound: 'Ingen opskrifter fundet',
        watchVideo: 'Se video',
        categories: 'Kategorier',
        areas: 'Områder',
        filterBy: 'Filtrer efter',
        all: 'Alle',
        beef: 'Oksekød',
        chicken: 'Kylling',
        goat: 'Ged',
        lamb: 'Lam',
        miscellaneous: 'Diverse',
        pasta: 'Pasta',
        pork: 'Svinekød',
        seafood: 'Skaldyr',
        side: 'Tilbehør',
        starter: 'Forret',
        vegan: 'Vegansk',
        vegetarian: 'Vegetarisk',
        avocado: 'Avocado',
        bacon: 'Bacon',
        bakingPowder: 'Bagepulver',
        balsamicVinegar: 'Balsamicoeddike',
        basil: 'Basilikum',
        basilLeaves: 'Basilikumblade',
        basmatiRice: 'Basmatiris',
        bayLeaf: 'Laurbærblad',
        bayLeaves: 'Laurbærblade',
        beefBrisket: 'Oksebrisket',
        beefFillet: 'Oksemørbrad',
        beefGravy: 'Oksesovs',
        beefStock: 'Oksefond',
        bicarbonateOfSoda: 'Natron',
        biryaniMasala: 'Biryani Masala',
        blackPepper: 'Sort peber',
        blackTreacle: 'Mørk sirup',
        appleCiderVinegar: 'Æblecidereddike',
        asparagus: 'Asparges',
        aubergine: 'Aubergine',
        babyPlumTomatoes: 'Baby blommetomater',
        british: 'Britisk',
        canadian: 'Canadisk',
        croatian: 'Kroatisk',
        dutch: 'Hollandsk',
        egyptian: 'Egyptisk',
        filipino: 'Filippinsk',
        irish: 'Irsk',
        jamaican: 'Jamaicansk',
        kenyan: 'Kenyansk',
        malaysian: 'Malaysisk',
        polish: 'Polsk',
        portuguese: 'Portugisisk',
        russian: 'Russisk',
        syrian: 'Syrisk',
        tunisian: 'Tunesisk',
        ukrainian: 'Ukrainsk',
        uruguayan: 'Uruguayansk',
        recipes: 'opskrifter',
        Chicken: 'Kylling',
        Beef: 'Oksekød',
        Pork: 'Svinekød',
        Salmon: 'Laks',
        Shrimp: 'Rejer',
        Eggs: 'Æg',
        Tofu: 'Tofu',
        Tuna: 'Tun',
        Potato: 'Kartoffel',
        Rice: 'Ris',
        comments: 'Kommentarer',
        addComment: 'Skriv en kommentar',
        noComments: 'Ingen kommentarer endnu. Vær den første!',
        submit: 'Indsend',
        commentSubmitted: 'Kommentar sendt!',
        errorSubmittingComment: 'Fejl ved indsendelse af kommentar.',
        backToWaiting: 'Tilbage',
        shoppingList: 'Indkøbsliste',
        addItem: 'Tilføj vare',
        add: 'Tilføj',
        clearList: 'Ryd liste',
        addToShoppingList: 'Tilføj til indkøbsliste',
        quantity: 'Mængde',
        diet: 'Diæt',
        selectDiet: 'Vælg en diæt',
        keto: 'Keto',
        lowCarb: 'Lavt kulhydratindhold',
        paleo: 'Paleo',
        mediterraneanDiet: 'Middelhavsdiæt',
        dairyFree: 'Mælkefri',
        glutenFree: 'Glutenfri',
        lowFat: 'Lavt fedtindhold',
        highProtein: 'Højt proteinindhold',
        selectIngredients: 'Vælg ingredienser',
        salmon: 'Laks',
        shrimp: 'Rejer',
        tofu: 'Tofu',
        tuna: 'Tun',
        potato: 'Kartoffel',
        rice: 'Ris',
        filters: 'Filtre',
        resetFilters: 'Nulstil filtre',
        tryAgain: 'Prøv igen',
        searchRecipes: 'Søg opskrifter...',
        addIngredient: 'Tilføj ingrediens',
        upTo: 'Op til',
        errorFetchingRecipes: 'Der opstod en fejl ved hentning af opskrifter',
        recipeLibraryTitle: 'Opskriftsbibliotek',
        recipesCount: '{count} opskrifter',
        searchPlaceholder: 'Søg opskrifter...',
        filterByLetter: 'Filtrer efter bogstav',
        allLetters: 'Alle',
        maxCalories: 'Maks kalorier',
        caloriesUnit: 'kcal',
        maxCookingTime: 'Maks tid',
        minutesUnit: 'min',
        minServings: 'Min portioner',
        maxServings: 'Maks portioner',
        selectAllergens: 'Vælg allergener',
        typeToSearch: 'Skriv for at søge...',
        selectNutritions: 'Vælg næringsstoffer',
        clearFilters: 'Ryd filtre',
        noRecipesMatch: 'Ingen opskrifter matcher filtrene',
        dairy: 'Mælkeprodukter',
        showFilters: 'Vis filtre',
        hideFilters: 'Skjul filtre',
        viewAllRecipes: 'Se alle opskrifter',
        budgetFriendlyCooking: 'Budgetvenlig madlavning',
        budgetFriendlyDescription: 'Opret lækre, budgetvenlige måltider med SousChaif ved hjælp af personlige opskrifter baseret på dine ingredienser og præferencer.',
        customRecipeSuggestions: 'Tilpassede opskriftsforslag',
        customRecipeDescription: 'Del dine ingredienser, præferencer og kostmål, og SousChaif vil give dig personlige opskrifter.',
        secureAndEasy: 'Sikkert og nemt',
        secureAndEasyDescription: 'Dine data er sikre hos os. Nyd nem adgang til personlige opskrifter og madlavningstips.',
        featureWelcomeTitle: "Velkommen til Souschaif!",
        featureWelcomeSubtitle: 'Upload et billede af dine ingredienser eller køleskab og få opskrifter med det samme. Du kan lukke dette vindue når som helst.',
        featureWelcomeGotIt: "Forstået",
        featureWelcomeMainBadge: 'Vigtigst',
        featureWelcomePhotoTitle: 'Upload billede af ingredienser eller køleskab',
        featureWelcomePhotoDescription: 'Tag eller upload et billede og få opskrifter med det samme baseret på det, du har hjemme.',
        featureWelcomeChatDescription: 'Stil spørgsmål til vores AI-kok og få personlig rådgivning med det samme.',
        featureWelcomeLibraryDescription: 'Gennemse hundredvis af opskrifter og filtrer efter ingredienser, allergener og tilberedningstid.',
        featureWelcomeShoppingDescription: 'Opret indkøbslister automatisk ud fra dine opskrifter.',
        smartShoppingList: "Smart indkøbsliste",
        smartShoppingListDescription: "Generer indkøbslister baseret på dine yndlingsopskrifter.",
        usernameOrMobile: 'Brugernavn eller mobilnummer',
        rememberMe: 'Husk mig',
        logIn: 'Log ind',
        signingIn: 'Logger ind...',
        noAccount: 'Har du ikke en konto?',
        signUp: 'Opret konto',
        next: 'Næste',
        skip: 'Spring over',
        defaultNotSubscribed: 'Du er ikke abonnent på denne tjeneste',
        defaultLoginError: 'Kan ikke bekræfte dit abonnement. Prøv venligst igen senere',
        signup: 'Opret konto',
        signupIntro: 'Opret din konto for at komme i gang',
        confirmPassword: 'Bekræft adgangskode',
        signupButton: 'Opret konto',
        signupError: 'Fejl under oprettelse',
        alreadySubscribed: 'Allerede abonnent?',
        clickHere: 'Klik her',
        signupSuccess: 'Konto oprettet',
        passwordRequirements: 'Adgangskodekrav',
        minLength: 'Minimum 8 tegn',
        requireUppercase: 'Mindst ét stort bogstav',
        requireLowercase: 'Mindst ét lille bogstav',
        requireNumber: 'Mindst ét tal',
        requireSpecial: 'Mindst ét specialtegn',
        passwordsMatch: 'Adgangskoder matcher',
        passwordRequirementsNotMet: 'Opfyld venligst alle adgangskodekrav',
        newPassword: 'Ny adgangskode',
        leaveEmptyToKeep: 'Lad være tom for at beholde nuværende adgangskode',
        sessionId: 'Sessions-ID',
        createdAt: 'Konto oprettet',
        errorFetchingUserData: 'Fejl ved hentning af brugerdata',
        errorUpdatingUser: 'Fejl ved opdatering af brugerdata',
        confirmUnsubscribe: 'Bekræft afmelding',
        confirmUnsubscribeMessage: 'Er du sikker på, at du vil afmelde?',
        confirmPasswordChange: 'Bekræft adgangskodeændring',
        confirmPasswordChangeMessage: 'Er du sikker på, at du vil ændre din adgangskode?',
        yes: 'Ja',
        cancel: 'Annuller',
        continentEurope: 'Europa',
        continentMiddleEast: 'Mellemøsten',
        continentAsia: 'Asien',
        continentAfrica: 'Afrika',
        continentNorthAmerica: 'Nordamerika',
        continentSouthAmerica: 'Sydamerika',
        continentOceania: 'Oceanien',
        backToContinents: 'Tilbage til kontinenter',
        downloadRecipe: 'Download opskrift',
        pdfDownloaded: 'PDF downloadet!',
        errorDownloadingPdf: 'Fejl ved download af PDF.',
        random: 'Tilfældig',
        mostCommented: 'Mest Kommenteret',
        mostLiked: 'Mest Populære',
        newest: 'Nyeste',
        quickest: 'Hurtigste',
        lowestCalories: 'Færrest Kalorier',
        audioFetched: 'Lyden er klar til afspilning.',
        errorFetchingAudio: 'Fejl ved hentning af lyd. Prøv venligst igen.',
        loadingAudio: 'Indlæser lyd...',
        winePairings: 'Vinanbefalinger',
        errorWinePairing: 'Kunne ikke hente vinanbefalinger. Prøv venligst igen.',
        sharedOn: 'Opskrift delt på',
        copiedToClipboard: 'Opskrift kopieret til udklipsholder!',
        shareError: 'Kunne ikke dele opskriften.',
        photoTip: 'For bedste resultater, upload et tydeligt billede af dine ingredienser eller en ret.',
        noFoodDetected: 'Ingen mad eller ingredienser blev fundet på dit billede. Prøv igen med et billede af ingredienser eller en ret.',
        errorCompressingImage: 'Fejl ved komprimering af billede. Prøv et mindre billede.',
        askingAboutCookbook: 'Spørgsmål om kogebog:',
        askingAboutRecipe: 'Spørgsmål om opskrift:',
        submit: 'Send',
        noComments: 'Ingen kommentarer endnu. Vær den første til at kommentere!',
        comparePrices: 'Sammenlign Supermarkedspriser',
        comparingPrices: 'Sammenligner priser...',
        pricesFor: 'Priser for',
        priceComparison: 'Prissammenligning',
        estimate: 'estimat',
        potentialSavings: 'Mulig besparelse',
        cheapestAt: 'Billigst hos',
        cheapest: 'Billigst',
        priceDisclaimer: 'Priserne er AI-estimater og kan afvige fra faktiske butikspriser.',
        budget: 'Billig',
        midRange: 'Mellemklasse',
        premium: 'Premium',
        clearListConfirmTitle: 'Ryd indkøbslisten?',
        clearListConfirmText: 'Dette fjerner alle varer fra din liste. Handlingen kan ikke fortrydes.',
        allergyPreferences: 'Allergiindstillinger',
        allergyPreferencesDescription: 'Vælg dine allergener nedenfor. Opskrifter der indeholder disse vil blive skjult fra anbefalingerne.',
        savePreferences: 'Gem indstillinger',
        saving: 'Gemmer...',
        preferencesSaved: 'Allergiindstillinger gemt!',
        errorSavingPreferences: 'Fejl ved lagring af indstillinger',
    },
    swedish: {
        and: "och",
        validateWeight: "Vikten måste vara mellan",
        validateHeight: "Höjden måste vara mellan",
        nutritionGoals: "Näringsgsmål",
        safetyAndDisclaimer: "Säkerhet & Ansvarsfriskrivning",
        safetyAndDisclaimerText: "Målen är uppskattningar och ersätter inte professionell medicinsk, närings- eller kostrådgivning. Om du har hälsoproblem, konsultera en vårdpersonal.",
        male: "Man",
        female: "Kvinna",
        other: "Annat",
        allowed: "Tillåten",
        pleaseEnterAWeight: "Vänligen ange en vikt",
        pleaseEnterAHeight: "Vänligen ange en höjd",
        calories: "Kalorier",
        protein: "Protein",
        fat: "Fett",
        carbs: "Kolhydrater",
        sex: "Kön",
        age: "Ålder",
        weight: "Vikt",
        height: "Höjd",
        activity: "Aktivitet",
        goal: "Mål",
        computeGoals: "Beräkna mål",
        light: "Lätt",
        moderate: "Måttlig",
        veryActive: "Mycket aktiv",
        extraActive: "Extra aktiv",
        lose: "Gå ner",
        maintain: "Behåll",
        gain: "Gå upp",
        dailyTargets: "Dagliga mål",
        unableToFetchPrices: 'Kan inte hämta priser för valuta',
        loadingPrices: 'Laddar priser',
        currency: 'Valuta',
        latestMarketPrices: 'Senaste marknadspriser',
        countryCurrency: 'SEK',
        startScan: 'Starta skanning',
        scanAnother: 'Skanna en annan',
        scanning: 'Skannar',
        vitaminD: 'D-vitamin',
        salt: 'Salt',
        fiber: 'Fiber',
        addedSugars: 'Tillsatt socker',
        sugars: 'Sockerarter',
        saturatedFat: 'Mättat fett',
        energy: 'Energi',
        amount: 'Mängd',
        productNutrient: 'Näringsämne',
        productNutritionalValuesPer100g: 'Näringsvärde (per 100g)',
        productIngredients: 'Ingredienser',
        productNutriScore: 'Nutri-Score',
        productBrand: 'Varumärke',
        scanYourProductBarcode: 'Skanna din produktstreckkod!',
        productLookupFailed: 'Produktsökning misslyckades',
        productNotFoundError: 'Produkt hittades inte',
        cameraFailedStartError: 'Kameran kunde inte startas',
        profile: 'Profil',
        basicInformation: 'Grundläggande information',
        savedRecipes: 'Sparade recept',
        noSavedRecipes: 'Du har inga sparade recept.',
        userData: 'Användardata',
        recipeRemoved: 'Receptet {recipeName} har tagits bort från dina favoriter.',
        username: 'Användarnamn',
        mobileNumber: 'Mobilnummer',
        password: 'Lösenord',
        saveChanges: 'Spara ändringar',
        changesSaved: 'Dina ändringar har sparats.',
        subscriptionInformation: 'Prenumerationsinformation',
        lastBillingDate: 'Senaste faktureringsdatum',
        nextBillingDate: 'Nästa faktureringsdatum',
        subscriptionStarted: 'Prenumeration startad',
        timesBilled: 'Gånger fakturerad',
        serviceName: 'Tjänstnamn',
        termsAndConditions: 'Villkor',
        viewTermsAndConditions: 'Visa villkor',
        pricingInformation: 'Prisinformation',
        unsubscribe: 'Avsluta prenumeration',
        unsubscribed: 'Du har avprenumererat.',
        selectLanguage: 'Välj ditt språk',
        whatToDo: 'Vad vill du göra?',
        takePhoto: 'Ta foto',
        uploadPhoto: 'Ladda upp foto',
        pleaseAddPhotoFirst: 'Vänligen lägg till ett foto först eller ta ett foto',
        uploading: 'Skapar dina personliga recept...',
        loadingTime: 'Detta kan ta upp till 1 minut...',
        analyzing: 'AI analyserar ditt foto...',
        aiAnalysisResult: 'AI-analysresultat:',
        uploadError: 'Ett fel uppstod vid uppladdning av bilden.',
        processingError: 'Ett fel uppstod vid bearbetning av bilden.',
        numberOfPeople: 'Antal personer',
        timeOfDay: 'Tid på dagen',
        selectTimeOfDay: 'Välj tid på dagen',
        breakfast: 'Frukost',
        morningSnack: 'Förmiddagssnacks',
        lunch: 'Lunch',
        afternoonSnack: 'Eftermiddagssnacks',
        dinner: 'Middag',
        dessert: 'Dessert',
        lateNightSnack: 'Sen kvällssnacks',
        preferredCuisine: 'Föredraget kök',
        selectCuisine: 'Välj kök',
        italian: 'Italienskt',
        chinese: 'Kinesiskt',
        indian: 'Indiskt',
        mexican: 'Mexikanskt',
        french: 'Franskt',
        thai: 'Thailändskt',
        japanese: 'Japanskt',
        mediterranean: 'Medelhavs',
        spanish: 'Spanskt',
        greek: 'Grekiskt',
        vietnamese: 'Vietnamesiskt',
        american: 'Amerikanskt',
        turkish: 'Turkiskt',
        korean: 'Koreanskt',
        moroccan: 'Marockanskt',
        persian: 'Persiskt',
        allergies: 'Allergier',
        selectAllergies: 'Välj allergier',
        gluten: 'Gluten',
        nuts: 'Nötter',
        lactose: 'Laktos',
        soy: 'Soja',
        shellfish: 'Skaldjur',
        fish: 'Fisk',
        eggs: 'Ägg',
        peanuts: 'Jordnötter',
        sesame: 'Sesam',
        sulphites: 'Sulfiter',
        mustard: 'Senap',
        celery: 'Selleri',
        lupin: 'Lupin',
        molluscs: 'Blötdjur',
        cookingTime: 'Tillagningstid',
        cookingTip: 'Mattips:',
        minutes: 'minuter',
        caloriesPerServing: 'Kalorier per portion',
        servings: 'portioner',
        allergens: 'Allergener',
        ingredients: 'Ingredienser',
        instructions: 'Instruktioner',
        noResultsFound: 'Inga resultat hittades',
        search: 'Ladda upp bild',
        decrease: 'Minus',
        increase: 'Plus',
        elapsedTime: 'Förfluten tid',
        seconds: 'sekunder',
        cameraNotSupported: 'Kamera stöds inte på denna enhet',
        nutritions: 'Näringsvärden',
        sugar: 'Socker',
        sodium: 'Natrium',
        vitamina: 'A-vitamin',
        vitaminc: 'C-vitamin',
        calcium: 'Kalcium',
        iron: 'Järn',
        recipeDetails: 'Receptdetaljer',
        loadMore: 'Ladda fler recept',
        recipeAlreadySaved: 'Receptet är redan sparat.',
        recipeSaved: 'Receptet har sparats.',
        errorSavingRecipe: 'Fel vid sparande av recept. Försök igen.',
        recipeShared: 'Recept delat via {platform}!',
        defaultSaveMessage: 'Åtgärd slutförd!',
        pleaseLogin: 'Vänligen logga in för att fortsätta',
        noIngredientsFound: 'Inga ingredienser hittades för inköpslistan',
        noValidIngredients: 'Inga giltiga ingredienser hittades',
        addedToShoppingList: 'Tillagd',
        toShoppingList: 'till inköpslistan',
        errorAddingToShoppingList: 'Fel vid tillägg till inköpslistan',
        noImageAvailable: 'Ingen bild tillgänglig',
        askQuestion: 'Ställ en fråga',
        recipeLibrary: 'Receptbibliotek',
        loadNewRandomRecipes: 'Ladda fler recept',
        loadingRecipes: 'Laddar {count} recept...',
        viewRecipe: 'Visa recept',
        share: 'Dela',
        favorite: 'Favorit',
        close: 'Stäng',
        whatsapp: 'WhatsApp',
        facebook: 'Facebook',
        twitter: 'Twitter',
        email: 'E-post',
        loading: 'Hämtar nya recept...',
        tetrisTitle: 'Spela Tetris medan du väntar!',
        score: 'Poäng',
        highScore: 'Högsta poäng',
        gameOver: 'Spelet slut',
        playAgain: 'Spela igen',
        left: 'Vänster',
        right: 'Höger',
        down: 'Ner',
        rotate: 'Rotera',
        startTetris: 'Spela Tetris',
        stopOrContinueTetris: 'Recept är laddade. Vill du stoppa Tetris och se recepten?',
        continueTetris: 'Fortsätt Tetris',
        playTetris: 'Spela Tetris',
        viewRecipes: 'Visa recept',
        recipesLoaded: 'SousChaif är redo med dina recept!',
        capturePhoto: 'Ta foto',
        closeCamera: 'Stäng kamera',
        pictureIngredients: 'Fotografera ingredienser',
        previewImage: 'Godkänn bild',
        retake: 'Ta om',
        approve: 'Skicka',
        waitingNotice: 'Spela ett spel medan du väntar.',
        name: 'Namn',
        newSearchQuestion: 'Sök efter nya recept?',
        newSearchPrompt: 'Vill du söka efter nya recept eller se dina tidigare resultat?',
        searchNewRecipes: 'Sök nya recept',
        seeOldRecipes: 'Visa',
        chatBotIntro: 'Välkommen, jag är SousChaif. Hur kan jag hjälpa dig idag?',
        chatWithSousChaif: 'Chatta med SousChaif',
        typeYourMessage: 'Skriv ditt meddelande...',
        recipeLoaded: 'Recept laddat',
        askAboutRecipe: 'Fråga om recept',
        errorFetchingData: 'Ett fel uppstod vid hämtning av data.',
        whatQuestionWouldYouLikeToAsk: 'Vilken fråga vill du ställa?',
        welcomeBack: 'Välkommen tillbaka',
        needHelpWithRecipe: 'Behöver du hjälp med matlagning?',
        viewRecipesHome: 'Ställ din fråga',
        popularIngredients: 'Populära ingredienser',
        popularCookbooks: 'Populära kokböcker',
        browseByLetter: 'Bläddra efter bokstav',
        videoRecipes: 'Videorecept',
        randomRecipes: 'Slumpmässiga recept',
        recipesByLetter: 'Recept efter bokstav',
        noRecipesFound: 'Inga recept hittades',
        watchVideo: 'Se video',
        categories: 'Kategorier',
        areas: 'Områden',
        filterBy: 'Filtrera efter',
        all: 'Alla',
        beef: 'Nötkött',
        chicken: 'Kyckling',
        goat: 'Get',
        lamb: 'Lamm',
        miscellaneous: 'Diverse',
        pasta: 'Pasta',
        pork: 'Fläsk',
        seafood: 'Skaldjur',
        side: 'Tillbehör',
        starter: 'Förrätt',
        vegan: 'Vegansk',
        vegetarian: 'Vegetarisk',
        avocado: 'Avokado',
        bacon: 'Bacon',
        bakingPowder: 'Bakpulver',
        balsamicVinegar: 'Balsamvinäger',
        basil: 'Basilika',
        basilLeaves: 'Basilikablad',
        basmatiRice: 'Basmatiris',
        bayLeaf: 'Lagerblad',
        bayLeaves: 'Lagerblad',
        beefBrisket: 'Oxbringa',
        beefFillet: 'Oxfilé',
        beefGravy: 'Oxsås',
        beefStock: 'Oxbuljong',
        bicarbonateOfSoda: 'Bikarbonat',
        biryaniMasala: 'Biryani Masala',
        blackPepper: 'Svartpeppar',
        blackTreacle: 'Mörk sirap',
        appleCiderVinegar: 'Äppelcidervinäger',
        asparagus: 'Sparris',
        aubergine: 'Aubergine',
        babyPlumTomatoes: 'Små plommontomater',
        british: 'Brittiskt',
        canadian: 'Kanadensiskt',
        croatian: 'Kroatiskt',
        dutch: 'Holländskt',
        egyptian: 'Egyptiskt',
        filipino: 'Filippinskt',
        irish: 'Irländskt',
        jamaican: 'Jamaicanskt',
        kenyan: 'Kenyanskt',
        malaysian: 'Malaysiskt',
        polish: 'Polskt',
        portuguese: 'Portugisiskt',
        russian: 'Ryskt',
        syrian: 'Syriskt',
        tunisian: 'Tunisiskt',
        ukrainian: 'Ukrainskt',
        uruguayan: 'Uruguayanskt',
        recipes: 'recept',
        Chicken: 'Kyckling',
        Beef: 'Nötkött',
        Pork: 'Fläsk',
        Salmon: 'Lax',
        Shrimp: 'Räkor',
        Eggs: 'Ägg',
        Tofu: 'Tofu',
        Tuna: 'Tonfisk',
        Potato: 'Potatis',
        Rice: 'Ris',
        comments: 'Kommentarer',
        addComment: 'Lämna en kommentar',
        noComments: 'Inga kommentarer än. Bli den första!',
        submit: 'Skicka',
        commentSubmitted: 'Kommentar skickad!',
        errorSubmittingComment: 'Fel vid skickande av kommentar.',
        backToWaiting: 'Tillbaka',
        shoppingList: 'Inköpslista',
        addItem: 'Lägg till vara',
        add: 'Lägg till',
        clearList: 'Rensa lista',
        addToShoppingList: 'Lägg till i inköpslistan',
        quantity: 'Kvantitet',
        diet: 'Diet',
        selectDiet: 'Välj en diet',
        keto: 'Keto',
        lowCarb: 'Låg kolhydrat',
        paleo: 'Paleo',
        mediterraneanDiet: 'Medelhavsdiet',
        dairyFree: 'Mjölkfri',
        glutenFree: 'Glutenfri',
        lowFat: 'Låg fetthalt',
        highProtein: 'Hög proteinhalt',
        selectIngredients: 'Välj ingredienser',
        salmon: 'Lax',
        shrimp: 'Räkor',
        tofu: 'Tofu',
        tuna: 'Tonfisk',
        potato: 'Potatis',
        rice: 'Ris',
        filters: 'Filter',
        resetFilters: 'Återställ filter',
        tryAgain: 'Försök igen',
        searchRecipes: 'Sök recept...',
        addIngredient: 'Lägg till ingrediens',
        upTo: 'Upp till',
        errorFetchingRecipes: 'Ett fel uppstod vid hämtning av recept',
        recipeLibraryTitle: 'Receptbibliotek',
        recipesCount: '{count} recept',
        searchPlaceholder: 'Sök recept...',
        filterByLetter: 'Filtrera efter bokstav',
        allLetters: 'Alla',
        maxCalories: 'Max kalorier',
        caloriesUnit: 'kcal',
        maxCookingTime: 'Max tid',
        minutesUnit: 'min',
        minServings: 'Min portioner',
        maxServings: 'Max portioner',
        selectAllergens: 'Välj allergener',
        typeToSearch: 'Skriv för att söka...',
        selectNutritions: 'Välj näringsvärden',
        clearFilters: 'Rensa filter',
        noRecipesMatch: 'Inga recept matchar filtren',
        dairy: 'Mejeri',
        showFilters: 'Visa filter',
        hideFilters: 'Dölj filter',
        viewAllRecipes: 'Visa alla recept',
        budgetFriendlyCooking: 'Budgetvänlig matlagning',
        budgetFriendlyDescription: 'Skapa läckra, budgetvänliga måltider med SousChaif med personliga recept baserade på dina ingredienser och preferenser.',
        customRecipeSuggestions: 'Anpassade receptförslag',
        customRecipeDescription: 'Dela dina ingredienser, preferenser och kostmål, och SousChaif kommer att ge dig personliga recept.',
        secureAndEasy: 'Säkert och enkelt',
        secureAndEasyDescription: 'Din data är säker hos oss. Njut av enkel åtkomst till personliga recept och matlagningstips.',
        featureWelcomeTitle: "Välkommen till Souschaif!",
        featureWelcomeSubtitle: 'Ladda upp ett foto av dina ingredienser eller kylskåp och få recept direkt. Du kan stänga detta fönster när som helst.',
        featureWelcomeGotIt: "Jag förstår",
        featureWelcomeMainBadge: 'Viktigast',
        featureWelcomePhotoTitle: 'Ladda upp foto av ingredienser eller kylskåp',
        featureWelcomePhotoDescription: 'Ta eller ladda upp ett foto och få recept direkt baserat på det du har hemma.',
        featureWelcomeChatDescription: 'Ställ frågor till vår AI-kock och få personliga råd direkt.',
        featureWelcomeLibraryDescription: 'Bläddra bland hundratals recept och filtrera efter ingredienser, allergener och tillagningstid.',
        featureWelcomeShoppingDescription: 'Skapa inköpslistor automatiskt från dina recept.',
        smartShoppingList: "Smart inköpslista",
        smartShoppingListDescription: "Generera inköpslistor baserat på dina favoritrecept.",
        usernameOrMobile: 'Användarnamn eller mobilnummer',
        rememberMe: 'Kom ihåg mig',
        logIn: 'Logga in',
        signingIn: 'Loggar in...',
        noAccount: 'Har du inget konto?',
        signUp: 'Skapa konto',
        next: 'Nästa',
        skip: 'Hoppa över',
        defaultNotSubscribed: 'Du prenumererar inte på denna tjänst',
        defaultLoginError: 'Kan inte bekräfta din prenumeration. Försök igen senare',
        signup: 'Skapa konto',
        signupIntro: 'Skapa ditt konto för att komma igång',
        confirmPassword: 'Bekräfta lösenord',
        signupButton: 'Skapa konto',
        signupError: 'Fel vid registrering',
        alreadySubscribed: 'Redan prenumerant?',
        clickHere: 'Klicka här',
        signupSuccess: 'Konto skapat',
        passwordRequirements: 'Lösenordskrav',
        minLength: 'Minst 8 tecken',
        requireUppercase: 'Minst en stor bokstav',
        requireLowercase: 'Minst en liten bokstav',
        requireNumber: 'Minst en siffra',
        requireSpecial: 'Minst ett specialtecken',
        passwordsMatch: 'Lösenorden matchar',
        passwordRequirementsNotMet: 'Vänligen uppfyll alla lösenordskrav',
        newPassword: 'Nytt lösenord',
        leaveEmptyToKeep: 'Lämna tomt för att behålla nuvarande lösenord',
        sessionId: 'Sessions-ID',
        createdAt: 'Konto skapat',
        errorFetchingUserData: 'Fel vid hämtning av användardata',
        errorUpdatingUser: 'Fel vid uppdatering av användardata',
        confirmUnsubscribe: 'Bekräfta avprenumeration',
        confirmUnsubscribeMessage: 'Är du säker på att du vill avprenumerera?',
        confirmPasswordChange: 'Bekräfta lösenordsändring',
        confirmPasswordChangeMessage: 'Är du säker på att du vill ändra ditt lösenord?',
        yes: 'Ja',
        cancel: 'Avbryt',
        continentEurope: 'Europa',
        continentMiddleEast: 'Mellanöstern',
        continentAsia: 'Asien',
        continentAfrica: 'Afrika',
        continentNorthAmerica: 'Nordamerika',
        continentSouthAmerica: 'Sydamerika',
        continentOceania: 'Oceanien',
        backToContinents: 'Tillbaka till kontinenter',
        downloadRecipe: 'Ladda ner recept',
        pdfDownloaded: 'PDF nedladdad!',
        errorDownloadingPdf: 'Fel vid nedladdning av PDF.',
        random: 'Slumpmässig',
        mostCommented: 'Mest Kommenterade',
        mostLiked: 'Mest Gillade',
        newest: 'Senaste',
        quickest: 'Snabbaste',
        lowestCalories: 'Lägst Kalorier',
        audioFetched: 'Ljudet är redo att spelas upp.',
        errorFetchingAudio: 'Fel vid hämtning av ljud. Försök igen.',
        loadingAudio: 'Laddar ljud...',
        winePairings: 'Vinrekommendationer',
        errorWinePairing: 'Kunde inte hämta vinrekommendationer. Försök igen.',
        sharedOn: 'Recept delat på',
        copiedToClipboard: 'Recept kopierat till urklipp!',
        shareError: 'Kunde inte dela receptet.',
        photoTip: 'För bästa resultat, ladda upp en tydlig bild av dina ingredienser eller en rätt.',
        noFoodDetected: 'Ingen mat eller ingredienser hittades på din bild. Försök igen med en bild av ingredienser eller en rätt.',
        errorCompressingImage: 'Fel vid komprimering av bilden. Försök med en mindre bild.',
        askingAboutCookbook: 'Frågor om kokbok:',
        askingAboutRecipe: 'Frågor om recept:',
        submit: 'Skicka',
        noComments: 'Inga kommentarer ännu. Bli den första att kommentera!',
        comparePrices: 'Jämför Snabbköpspriser',
        comparingPrices: 'Jämför priser...',
        pricesFor: 'Priser för',
        priceComparison: 'Prisjämförelse',
        estimate: 'uppskattning',
        potentialSavings: 'Möjlig besparing',
        cheapestAt: 'Billigast hos',
        cheapest: 'Billigast',
        priceDisclaimer: 'Priserna är AI-uppskattningar och kan avvika från faktiska butikspriser.',
        budget: 'Budget',
        midRange: 'Mellanklass',
        premium: 'Premium',
        clearListConfirmTitle: 'Rensa inköpslistan?',
        clearListConfirmText: 'Detta tar bort alla varor från din lista. Åtgärden kan inte ångras.',
        allergyPreferences: 'Allergiinställningar',
        allergyPreferencesDescription: 'Välj dina allergener nedan. Recept som innehåller dessa döljs från rekommendationerna.',
        savePreferences: 'Spara inställningar',
        saving: 'Sparar...',
        preferencesSaved: 'Allergiinställningar sparade!',
        errorSavingPreferences: 'Fel vid sparande av inställningar',
    },
    slovenian: {
        and: "in",
        validateWeight: "Teža mora biti med",
        validateHeight: "Višina mora biti med",
        nutritionGoals: "Prehranski cilji",
        safetyAndDisclaimer: "Varnost in izjava o omejitvi odgovornosti",
        safetyAndDisclaimerText: "Cilji so ocene in ne nadomeščajo strokovnega medicinskega, prehranskega ali dietnega svetovanja. Če imate zdravstvene težave, se posvetujte z zdravstvenim strokovnjakom.",
        male: "Moški",
        female: "Ženska",
        age: "Starost",
        weight: "Teža",
        height: "Višina",
        activityLevel: "Stopnja aktivnosti",
        sedentary: "Sedeč",
        lightlyActive: "Rahlo aktiven",
        moderatelyActive: "Zmerno aktiven",
        veryActive: "Zelo aktiven",
        extraActive: "Izjemno aktiven",
        goal: "Cilj",
        loseWeight: "Hujšanje",
        maintainWeight: "Ohranjanje teže",
        gainWeight: "Pridobivanje teže",
        calculate: "Izračunaj",
        dailyCalories: "Dnevne kalorije",
        protein: "Beljakovine",
        carbs: "Ogljikovi hidrati",
        fat: "Maščobe",
        saveGoals: "Shrani cilje",
        goalsSaved: "Cilji shranjeni!",
        caloriesBurned: "Porabljene kalorije",
        resultDisclaimer: "Ti rezultati so ocene, ki temeljijo na splošnih formulah. Dejanske potrebe se lahko razlikujejo.",
        pleaseEnterAWeight: "Prosimo, vnesite težo",
        pleaseEnterAHeight: "Prosimo, vnesite višino",
        loadMore: 'Naloži več',
        loadNewRandomRecipes: 'Naloži več receptov',
        loadingRecipes: 'Nalaganje {count} receptov...',
        viewRecipe: 'Oglej si recept',
        share: 'Deli',
        favorite: 'Priljubljeno',
        close: 'Zapri',
        whatsapp: 'WhatsApp',
        facebook: 'Facebook',
        twitter: 'Twitter',
        email: 'E-pošta',
        loading: 'Pridobivanje novih receptov...',
        tetrisTitle: 'Igrajte Tetris, medtem ko čakate!',
        score: 'Rezultat',
        highScore: 'Najboljši rezultat',
        gameOver: 'Konec igre',
        playAgain: 'Igraj znova',
        left: 'Levo',
        right: 'Desno',
        down: 'Dol',
        rotate: 'Zasukaj',
        startTetris: 'Igraj Tetris',
        stopOrContinueTetris: 'Recepti so naloženi. Ali želite ustaviti Tetris in si ogledati recepte?',
        continueTetris: 'Nadaljuj Tetris',
        playTetris: 'Igraj Tetris',
        viewRecipes: 'Oglej si recepte',
        recipesLoaded: 'SousChaif ima pripravljene vaše recepte!',
        capturePhoto: 'Fotografiraj',
        closeCamera: 'Zapri kamero',
        pictureIngredients: 'Fotografiraj sestavine',
        previewImage: 'Potrdi sliko',
        retake: 'Ponovno posnemi',
        approve: 'Pošlji',
        waitingNotice: 'Igrajte igro, medtem ko čakate.',
        profile: 'Profil',
        basicInformation: 'Osnovne informacije',
        name: 'Ime',
        savedRecipes: 'Shranjeni recepti',
        noSavedRecipes: 'Nimate še shranjenih receptov.',
        recipeRemoved: 'Recept {recipeName} je bil odstranjen iz priljubljenih.',
        newSearchQuestion: 'Iščete nove recepte?',
        newSearchPrompt: 'Ali želite poiskati nove recepte ali si ogledati prejšnje rezultate?',
        searchNewRecipes: 'Išči nove recepte',
        seeOldRecipes: 'Oglej si',
        chatBotIntro: 'Dobrodošli, jaz sem SousChaif. Kako vam lahko pomagam danes?',
        chatWithSousChaif: 'Klepet s SousChaif',
        typeYourMessage: 'Vpišite svoje sporočilo...',
        recipeLoaded: 'Recept naložen',
        askAboutRecipe: 'Vprašaj o receptu',
        errorFetchingData: 'Prišlo je do napake pri pridobivanju podatkov.',
        whatQuestionWouldYouLikeToAsk: 'Katero vprašanje bi radi zastavili?',
        welcomeBack: 'Dobrodošli nazaj',
        needHelpWithRecipe: 'Potrebujete pomoč pri kuhanju?',
        viewRecipesHome: 'Zastavite svoje vprašanje',
        popularIngredients: 'Priljubljene sestavine',
        popularCookbooks: 'Priljubljene kuharske knjige',
        browseByLetter: 'Brskaj po črki',
        videoRecipes: 'Video recepti',
        randomRecipes: 'Naključni recepti',
        recipesByLetter: 'Recepti po črki',
        noRecipesFound: 'Ni najdenih receptov',
        watchVideo: 'Oglej si video',
        categories: 'Kategorije',
        ingredients: 'Sestavine',
        areas: 'Območja',
        filterBy: 'Filtriraj po',
        all: 'Vse',
        beef: 'Govedina',
        breakfast: 'Zajtrk',
        chicken: 'Piščanec',
        dessert: 'Sladica',
        goat: 'Koza',
        lamb: 'Jagnjetina',
        miscellaneous: 'Razno',
        pasta: 'Testenine',
        pork: 'Svinjina',
        seafood: 'Morski sadeži',
        side: 'Priloga',
        starter: 'Predjed',
        vegan: 'Vegansko',
        vegetarian: 'Vegetarijansko',
        avocado: 'Avokado',
        bacon: 'Slanina',
        bakingPowder: 'Pecilni prašek',
        balsamicVinegar: 'Balzamični kis',
        basil: 'Bazilika',
        basilLeaves: 'Listi bazilike',
        basmatiRice: 'Basmati riž',
        bayLeaf: 'Lovorjev list',
        bayLeaves: 'Lovorjevi listi',
        beefBrisket: 'Goveja prsa',
        beefFillet: 'Goveji file',
        beefGravy: 'Goveja omaka',
        beefStock: 'Goveja juha',
        bicarbonateOfSoda: 'Soda bikarbona',
        biryaniMasala: 'Biryani Masala',
        blackPepper: 'Črni poper',
        blackTreacle: 'Črna melasa',
        appleCiderVinegar: 'Jabolčni kis',
        asparagus: 'Šparglji',
        aubergine: 'Jajčevec',
        babyPlumTomatoes: 'Mali paradižniki',
        american: 'Ameriška',
        british: 'Britanska',
        canadian: 'Kanadska',
        chinese: 'Kitajska',
        croatian: 'Hrvaška',
        dutch: 'Nizozemska',
        egyptian: 'Egipčanska',
        filipino: 'Filipinska',
        french: 'Francoska',
        greek: 'Grška',
        indian: 'Indijska',
        irish: 'Irska',
        italian: 'Italijanska',
        jamaican: 'Jamajška',
        japanese: 'Japonska',
        kenyan: 'Kenijska',
        malaysian: 'Malezijska',
        mexican: 'Mehiška',
        moroccan: 'Maroška',
        polish: 'Poljska',
        portuguese: 'Portugalska',
        russian: 'Ruska',
        spanish: 'Španska',
        syrian: 'Sirska',
        thai: 'Tajska',
        tunisian: 'Tunizijska',
        turkish: 'Turška',
        ukrainian: 'Ukrajinska',
        uruguayan: 'Urugvajska',
        vietnamese: 'Vietnamska',
        recipes: 'recepti',
        Chicken: 'Piščanec',
        Beef: 'Govedina',
        Pork: 'Svinjina',
        Salmon: 'Losos',
        Shrimp: 'Kozice',
        Eggs: 'Jajca',
        Tofu: 'Tofu',
        Tuna: 'Tuna',
        Potato: 'Krompir',
        Rice: 'Riž',
        comments: 'Komentarji',
        addComment: 'Pustite komentar',
        noComments: 'Še ni komentarjev. Bodite prvi!',
        submit: 'Oddaj',
        commentSubmitted: 'Komentar objavljen!',
        errorSubmittingComment: 'Napaka pri objavljanju komentarja.',
        backToWaiting: 'Nazaj',
        shoppingList: 'Nakupovalni seznam',
        addItem: 'Dodaj artikel',
        add: 'Dodaj',
        clearList: 'Počisti seznam',
        addToShoppingList: 'Dodaj na nakupovalni seznam',
        addedToShoppingList: 'Sestavine dodane na nakupovalni seznam!',
        quantity: 'Količina',
        diet: 'Dieta',
        selectDiet: 'Izberite dieto',
        keto: 'Keto',
        lowCarb: 'Nizko ogljikohidratna',
        paleo: 'Paleo',
        mediterraneanDiet: 'Sredozemska',
        dairyFree: 'Brez mlečnih izdelkov',
        glutenFree: 'Brez glutena',
        lowFat: 'Nizko maščobna',
        highProtein: 'Visoko beljakovinska',
        selectIngredients: 'Izberite sestavine',
        salmon: 'Losos',
        shrimp: 'Kozice',
        tofu: 'Tofu',
        tuna: 'Tuna',
        potato: 'Krompir',
        rice: 'Riž',
        savedRecipes: "Shranjeni recepti",
        filters: "Filtri",
        resetFilters: "Ponastavi filtre",
        tryAgain: "Poskusi znova",
        searchRecipes: "Išči recepte...",
        allergens: "Alergeni",
        cookingTime: "Čas kuhanja",
        addIngredient: "Dodaj sestavino",
        upTo: "Do",
        errorFetchingRecipes: "Prišlo je do napake pri pridobivanju receptov",
        recipeLibrary: 'Knjižnica receptov',
        recipeLibraryTitle: "Knjižnica receptov",
        recipesCount: "{count} receptov",
        searchPlaceholder: "Išči recepte...",
        filterByLetter: "Filtriraj po črki",
        allLetters: "Vse",
        maxCalories: "Maks. kalorije",
        caloriesUnit: "kcal",
        maxCookingTime: "Maks. čas",
        minutesUnit: "min",
        servings: "Porcije",
        minServings: "Min. porcij",
        maxServings: "Maks. porcij",
        selectAllergens: "Izberite alergene",
        typeToSearch: "Vnesite za iskanje...",
        selectNutritions: "Izberite hranilne vrednosti",
        selectIngredients: "Izberite sestavine",
        clearFilters: "Počisti filtre",
        noRecipesMatch: "Noben recept ne ustreza filtrom",
        dairy: "Mlečni izdelki",
        soy: "Soja",
        shellfish: "Školjke",
        fish: "Ribe",
        showFilters: "Prikaži filtre",
        hideFilters: "Skrij filtre",
        viewAllRecipes: "Prikaži vse recepte",
        budgetFriendlyCooking: "Kuhanje za majhen proračun",
        budgetFriendlyDescription: "Ustvarite okusne, proračunu prijazne obroke s 'sous-chaif' z uporabo prilagojenih receptov na podlagi vaših sestavin in preferenc.",
        customRecipeSuggestions: "Prilagojeni predlogi receptov",
        customRecipeDescription: "Delite svoje sestavine, preference in prehranske cilje, in 'sous-chaif' vam bo pripravil prilagojene recepte.",
        secureAndEasy: "Varno in enostavno",
        secureAndEasyDescription: "Vaši podatki so pri nas varni. Uživajte v enostavnem dostopu do prilagojenih receptov in kulinaričnih nasvetov.",
        featureWelcomeTitle: "Dobrodošli v Souschaif!",
        featureWelcomeSubtitle: "Naložite fotografijo sestavin ali hladilnika in takoj prejmite recepte. To okno lahko kadar koli zaprete.",
        featureWelcomeGotIt: "Razumem",
        featureWelcomeMainBadge: "Najpomembneje",
        featureWelcomePhotoTitle: "Naložite fotografijo sestavin ali hladilnika",
        featureWelcomePhotoDescription: "Posnemite ali naložite fotografijo in takoj prejmite recepte na podlagi tega, kar imate doma.",
        featureWelcomeChatDescription: "Postavite vprašanja našemu AI kuharju in takoj prejmite osebne nasvete.",
        featureWelcomeLibraryDescription: "Brskajte med stotinami receptov in filtrirajte po sestavinah, alergenih in času kuhanja.",
        featureWelcomeShoppingDescription: "Samodejno ustvarite nakupovalni seznam iz svojih receptov.",
        smartShoppingList: "Pameten nakupovalni seznam",
        smartShoppingListDescription: "Ustvarite nakupovalne sezname na podlagi priljubljenih receptov.",
        usernameOrMobile: "Uporabniško ime ali mobilna številka",
        rememberMe: "Zapomni si me",
        logIn: "Prijava",
        signingIn: "Prijavljanje...",
        noAccount: "Nimate računa?",
        signUp: "Registracija",
        next: "Naprej",
        skip: "Preskoči",
        defaultNotSubscribed: 'Niste naročeni na to storitev',
        defaultLoginError: 'Vaše naročnine ni mogoče potrditi. Poskusite znova pozneje',
        signup: "Registracija",
        signupIntro: "Ustvarite račun za začetek",
        username: "Uporabniško ime",
        password: "Geslo",
        confirmPassword: "Potrdite geslo",
        signupButton: "Registriraj se",
        signupError: "Napaka pri registraciji",
        alreadySubscribed: "Ste že naročnik?",
        clickHere: "Kliknite tukaj",
        signupSuccess: "Račun ustvarjen",
        passwordRequirements: "Zahteve za geslo",
        minLength: "Najmanj 8 znakov",
        requireUppercase: "Vsaj ena velika črka",
        requireLowercase: "Vsaj ena mala črka",
        requireNumber: "Vsaj ena številka",
        requireSpecial: "Vsaj en poseben znak",
        passwordsMatch: "Gesli se ujemata",
        passwordRequirementsNotMet: "Prosimo, izpolnite vse zahteve za geslo",
        newPassword: "Novo geslo",
        leaveEmptyToKeep: "Pustite prazno za ohranitev trenutnega gesla",
        sessionId: "ID seje",
        createdAt: "Račun ustvarjen",
        errorFetchingUserData: "Napaka pri pridobivanju uporabniških podatkov",
        errorUpdatingUser: "Napaka pri posodabljanju uporabniških podatkov",
        confirmUnsubscribe: "Potrdite odjavo",
        confirmUnsubscribeMessage: "Ali ste prepričani, da se želite odjaviti?",
        confirmPasswordChange: "Potrdite spremembo gesla",
        confirmPasswordChangeMessage: "Ali ste prepričani, da želite spremeniti geslo?",
        yes: "Da",
        cancel: "Prekliči",
        logout: 'Odjava',
        cookingTip: 'Kuharski nasvet',
        continentEurope: 'Evropa',
        continentMiddleEast: 'Bližnji vzhod',
        continentAsia: 'Azija',
        continentAfrica: 'Afrika',
        continentNorthAmerica: 'Severna Amerika',
        continentSouthAmerica: 'Južna Amerika',
        continentOceania: 'Oceanija',
        backToContinents: 'Nazaj na celine',
        downloadRecipe: 'Prenesi recept',
        pdfDownloaded: 'PDF uspešno prenesen!',
        errorDownloadingPdf: 'Napaka pri prenosu PDF.',
        random: 'Naključno',
        mostCommented: 'Najbolj Komentirani',
        mostLiked: 'Najbolj Všečkani',
        newest: 'Najnovejši',
        quickest: 'Najhitrejši',
        lowestCalories: 'Najmanj Kalorij',
        audioFetched: 'Zvok je pripravljen za predvajanje.',
        errorFetchingAudio: 'Napaka pri pridobivanju zvoka. Poskusite znova.',
        loadingAudio: 'Nalaganje zvoka...',
        winePairings: 'Priporočila za Vino',
        errorWinePairing: 'Ni bilo mogoče pridobiti priporočil za vino. Poskusite znova.',
        sharedOn: 'Recept deljen na',
        copiedToClipboard: 'Recept kopiran v odložišče!',
        shareError: 'Recepta ni bilo mogoče deliti.',
        photoTip: 'Za najboljše rezultate naložite jasno fotografijo sestavin ali jedi.',
        noFoodDetected: 'Na vaši fotografiji ni bilo zaznane hrane ali sestavin. Poskusite znova s fotografijo sestavin ali jedi.',
        errorCompressingImage: 'Napaka pri stiskanju slike. Poskusite manjšo fotografijo.',
        askingAboutCookbook: 'Vprašanja o kuharski knjigi:',
        askingAboutRecipe: 'Vprašanja o receptu:',
        submit: 'Pošlji',
        noComments: 'Še ni komentarjev. Bodite prvi, ki komentirate!',
        comparePrices: 'Primerjaj Cene v Supermarketih',
        comparingPrices: 'Primerjava cen...',
        pricesFor: 'Cene za',
        priceComparison: 'Primerjava Cen',
        estimate: 'ocena',
        potentialSavings: 'Možen prihranek',
        cheapestAt: 'Najceneje pri',
        cheapest: 'Najceneje',
        priceDisclaimer: 'Cene so AI ocene in se lahko razlikujejo od dejanskih cen v trgovinah.',
        budget: 'Ugodno',
        midRange: 'Srednji razred',
        premium: 'Premium',
        clearListConfirmTitle: 'Počistiti nakupovalni seznam?',
        clearListConfirmText: 'To bo odstranilo vse izdelke s seznama. Tega dejanja ni mogoče razveljaviti.',
        allergyPreferences: 'Nastavitve alergij',
        allergyPreferencesDescription: 'Spodaj izberite alergene. Recepti, ki jih vsebujejo, bodo skriti iz priporočil.',
        savePreferences: 'Shrani nastavitve',
        saving: 'Shranjujem...',
        preferencesSaved: 'Nastavitve alergij shranjene!',
        errorSavingPreferences: 'Napaka pri shranjevanju nastavitev',
    },
    greek: {
        and: "και",
        validateWeight: "Το βάρος πρέπει να είναι μεταξύ",
        validateHeight: "Το ύψος πρέπει να είναι μεταξύ",
        nutritionGoals: "Διατροφικοί στόχοι",
        safetyAndDisclaimer: "Ασφάλεια και Αποποίηση ευθύνης",
        safetyAndDisclaimerText: "Οι στόχοι είναι εκτιμήσεις και δεν αντικαθιστούν επαγγελματική ιατρική, διατροφική ή διαιτητική συμβουλή. Εάν έχετε προβλήματα υγείας, συμβουλευτείτε έναν επαγγελματία υγείας.",
        male: "Άνδρας",
        female: "Γυναίκα",
        other: "Άλλο",
        allowed: "Επιτρέπεται",
        pleaseEnterAWeight: "Παρακαλώ εισάγετε βάρος",
        pleaseEnterAHeight: "Παρακαλώ εισάγετε ύψος",
        calories: "Θερμίδες",
        protein: "Πρωτεΐνη",
        fat: "Λιπαρά",
        carbs: "Υδατάνθρακες",
        sex: "Φύλο",
        age: "Ηλικία",
        weight: "Βάρος",
        height: "Ύψος",
        activity: "Δραστηριότητα",
        goal: "Στόχος",
        computeGoals: "Υπολογισμός στόχων",
        light: "Ελαφριά",
        moderate: "Μέτρια",
        veryActive: "Πολύ ενεργός",
        extraActive: "Εξαιρετικά ενεργός",
        lose: "Απώλεια",
        maintain: "Διατήρηση",
        gain: "Αύξηση",
        dailyTargets: "Ημερήσιοι στόχοι",
        unableToFetchPrices: 'Αδυναμία φόρτωσης τιμών για το νόμισμα',
        loadingPrices: 'Φόρτωση τιμών',
        currency: 'Νόμισμα',
        latestMarketPrices: 'Τελευταίες τιμές αγοράς',
        countryCurrency: 'EUR',
        startScan: 'Έναρξη σάρωσης',
        scanAnother: 'Σάρωση άλλου',
        scanning: 'Σάρωση',
        vitaminD: 'Βιταμίνη D',
        salt: 'Αλάτι',
        fiber: 'Φυτικές ίνες',
        addedSugars: 'Προστιθέμενα σάκχαρα',
        sugars: 'Σάκχαρα',
        saturatedFat: 'Κορεσμένα λιπαρά',
        energy: 'Ενέργεια',
        amount: 'Ποσότητα',
        productNutrient: 'Θρεπτικό συστατικό',
        productNutritionalValuesPer100g: 'Διατροφική αξία (ανά 100γρ)',
        productIngredients: 'Συστατικά',
        productNutriScore: 'Nutri-Score',
        productBrand: 'Μάρκα',
        scanYourProductBarcode: 'Σαρώστε το barcode του προϊόντος σας!',
        productLookupFailed: 'Η αναζήτηση προϊόντος απέτυχε',
        productNotFoundError: 'Το προϊόν δεν βρέθηκε',
        cameraFailedStartError: 'Η κάμερα απέτυχε να ξεκινήσει',
        profile: 'Προφίλ',
        basicInformation: 'Βασικές πληροφορίες',
        savedRecipes: 'Αποθηκευμένες συνταγές',
        noSavedRecipes: 'Δεν έχετε αποθηκευμένες συνταγές.',
        userData: 'Δεδομένα χρήστη',
        recipeRemoved: 'Η συνταγή {recipeName} αφαιρέθηκε από τα αγαπημένα σας.',
        username: 'Όνομα χρήστη',
        mobileNumber: 'Αριθμός κινητού',
        password: 'Κωδικός πρόσβασης',
        saveChanges: 'Αποθήκευση αλλαγών',
        changesSaved: 'Οι αλλαγές σας αποθηκεύτηκαν.',
        subscriptionInformation: 'Πληροφορίες συνδρομής',
        lastBillingDate: 'Τελευταία ημερομηνία χρέωσης',
        nextBillingDate: 'Επόμενη ημερομηνία χρέωσης',
        subscriptionStarted: 'Η συνδρομή ξεκίνησε',
        timesBilled: 'Φορές χρέωσης',
        serviceName: 'Όνομα υπηρεσίας',
        termsAndConditions: 'Όροι και Προϋποθέσεις',
        viewTermsAndConditions: 'Προβολή Όρων και Προϋποθέσεων',
        pricingInformation: 'Πληροφορίες τιμολόγησης',
        unsubscribe: 'Ακύρωση συνδρομής',
        unsubscribed: 'Έχετε ακυρώσει τη συνδρομή σας.',
        selectLanguage: 'Επιλέξτε τη γλώσσα σας',
        whatToDo: 'Τι θέλετε να κάνετε;',
        takePhoto: 'Λήψη φωτογραφίας',
        uploadPhoto: 'Μεταφόρτωση φωτογραφίας',
        pleaseAddPhotoFirst: 'Παρακαλώ προσθέστε πρώτα μια φωτογραφία ή τραβήξτε μια',
        uploading: 'Δημιουργία των εξατομικευμένων συνταγών σας...',
        loadingTime: 'Αυτό μπορεί να διαρκέσει έως 1 λεπτό...',
        analyzing: 'Η τεχνητή νοημοσύνη αναλύει τη φωτογραφία σας...',
        aiAnalysisResult: 'Αποτέλεσμα ανάλυσης AI:',
        uploadError: 'Παρουσιάστηκε σφάλμα κατά τη μεταφόρτωση της εικόνας.',
        processingError: 'Παρουσιάστηκε σφάλμα κατά την επεξεργασία της εικόνας.',
        numberOfPeople: 'Αριθμός ατόμων',
        timeOfDay: 'Ώρα της ημέρας',
        selectTimeOfDay: 'Επιλέξτε ώρα της ημέρας',
        breakfast: 'Πρωινό',
        morningSnack: 'Πρωινό σνακ',
        lunch: 'Μεσημεριανό',
        afternoonSnack: 'Απογευματινό σνακ',
        dinner: 'Βραδινό',
        dessert: 'Επιδόρπιο',
        lateNightSnack: 'Βραδινό σνακ',
        preferredCuisine: 'Προτιμώμενη κουζίνα',
        selectCuisine: 'Επιλέξτε κουζίνα',
        italian: 'Ιταλική',
        chinese: 'Κινέζικη',
        indian: 'Ινδική',
        mexican: 'Μεξικάνικη',
        french: 'Γαλλική',
        thai: 'Ταϊλανδέζικη',
        japanese: 'Ιαπωνική',
        mediterranean: 'Μεσογειακή',
        spanish: 'Ισπανική',
        greek: 'Ελληνική',
        vietnamese: 'Βιετναμέζικη',
        american: 'Αμερικανική',
        turkish: 'Τουρκική',
        korean: 'Κορεάτικη',
        moroccan: 'Μαροκινή',
        persian: 'Περσική',
        allergies: 'Αλλεργίες',
        selectAllergies: 'Επιλέξτε αλλεργίες',
        gluten: 'Γλουτένη',
        nuts: 'Ξηροί καρποί',
        lactose: 'Λακτόζη',
        soy: 'Σόγια',
        shellfish: 'Οστρακοειδή',
        fish: 'Ψάρι',
        eggs: 'Αυγά',
        peanuts: 'Αράπικα φιστίκια',
        sesame: 'Σουσάμι',
        sulphites: 'Θειώδη',
        mustard: 'Μουστάρδα',
        celery: 'Σέλερι',
        lupin: 'Λούπινο',
        molluscs: 'Μαλάκια',
        cookingTime: 'Χρόνος μαγειρέματος',
        cookingTip: 'Συμβουλή μαγειρέματος:',
        minutes: 'λεπτά',
        caloriesPerServing: 'Θερμίδες ανά μερίδα',
        servings: 'μερίδες',
        allergens: 'Αλλεργιογόνα',
        ingredients: 'Συστατικά',
        instructions: 'Οδηγίες',
        noResultsFound: 'Δεν βρέθηκαν αποτελέσματα',
        search: 'Μεταφόρτωση εικόνας',
        decrease: 'Μείον',
        increase: 'Συν',
        elapsedTime: 'Χρόνος που πέρασε',
        seconds: 'δευτερόλεπτα',
        cameraNotSupported: 'Η κάμερα δεν υποστηρίζεται σε αυτή τη συσκευή',
        nutritions: 'Διατροφικές αξίες',
        sugar: 'Ζάχαρη',
        sodium: 'Νάτριο',
        vitamina: 'Βιταμίνη A',
        vitaminc: 'Βιταμίνη C',
        calcium: 'Ασβέστιο',
        iron: 'Σίδηρος',
        recipeDetails: 'Λεπτομέρειες συνταγής',
        loadMore: 'Φόρτωση περισσότερων συνταγών',
        recipeAlreadySaved: 'Η συνταγή είναι ήδη αποθηκευμένη.',
        recipeSaved: 'Η συνταγή αποθηκεύτηκε με επιτυχία.',
        errorSavingRecipe: 'Σφάλμα κατά την αποθήκευση της συνταγής. Παρακαλώ δοκιμάστε ξανά.',
        recipeShared: 'Η συνταγή κοινοποιήθηκε μέσω {platform}!',
        defaultSaveMessage: 'Η ενέργεια ολοκληρώθηκε με επιτυχία!',
        pleaseLogin: 'Παρακαλώ συνδεθείτε για να συνεχίσετε',
        noIngredientsFound: 'Δεν βρέθηκαν συστατικά για προσθήκη στη λίστα αγορών',
        noValidIngredients: 'Δεν βρέθηκαν έγκυρα συστατικά για προσθήκη',
        addedToShoppingList: 'Προστέθηκε',
        toShoppingList: 'στη λίστα αγορών',
        errorAddingToShoppingList: 'Σφάλμα κατά την προσθήκη στη λίστα αγορών',
        noImageAvailable: 'Δεν υπάρχει διαθέσιμη εικόνα',
        askQuestion: 'Κάντε ερώτηση',
        recipeLibrary: 'Βιβλιοθήκη συνταγών',
        loadNewRandomRecipes: 'Φόρτωση περισσότερων συνταγών',
        loadingRecipes: 'Φόρτωση {count} συνταγών...',
        viewRecipe: 'Προβολή συνταγής',
        share: 'Κοινοποίηση',
        favorite: 'Αγαπημένο',
        close: 'Κλείσιμο',
        whatsapp: 'WhatsApp',
        facebook: 'Facebook',
        twitter: 'Twitter',
        email: 'Email',
        loading: 'Ανάκτηση νέων συνταγών...',
        tetrisTitle: 'Παίξτε Tetris όσο περιμένετε!',
        score: 'Σκορ',
        highScore: 'Υψηλό σκορ',
        gameOver: 'Τέλος παιχνιδιού',
        playAgain: 'Παίξτε ξανά',
        left: 'Αριστερά',
        right: 'Δεξιά',
        down: 'Κάτω',
        rotate: 'Περιστροφή',
        startTetris: 'Παίξτε ένα παιχνίδι Tetris',
        stopOrContinueTetris: 'Οι συνταγές φορτώθηκαν. Θέλετε να σταματήσετε το Tetris και να δείτε τις συνταγές;',
        continueTetris: 'Συνέχεια Tetris',
        playTetris: 'Παίξτε Tetris',
        viewRecipes: 'Προβολή συνταγών',
        recipesLoaded: 'Το SousChaif είναι έτοιμο με τις συνταγές σας!',
        capturePhoto: 'Λήψη φωτογραφίας',
        closeCamera: 'Κλείσιμο κάμερας',
        pictureIngredients: 'Φωτογραφίστε τα συστατικά',
        previewImage: 'Έγκριση εικόνας',
        retake: 'Επανάληψη',
        approve: 'Αποστολή',
        waitingNotice: 'Παίξτε ένα παιχνίδι όσο περιμένετε.',
        name: 'Όνομα',
        newSearchQuestion: 'Αναζήτηση νέων συνταγών;',
        newSearchPrompt: 'Θέλετε να αναζητήσετε νέες συνταγές ή να δείτε τα προηγούμενα αποτελέσματα;',
        searchNewRecipes: 'Αναζήτηση νέων συνταγών',
        seeOldRecipes: 'Προβολή',
        chatBotIntro: 'Καλώς ήρθατε, είμαι ο SousChaif. Πώς μπορώ να σας βοηθήσω σήμερα;',
        chatWithSousChaif: 'Συνομιλία με τον SousChaif',
        typeYourMessage: 'Πληκτρολογήστε το μήνυμά σας...',
        recipeLoaded: 'Η συνταγή φορτώθηκε',
        askAboutRecipe: 'Ρωτήστε για τη συνταγή',
        errorFetchingData: 'Παρουσιάστηκε σφάλμα κατά την ανάκτηση των δεδομένων.',
        whatQuestionWouldYouLikeToAsk: 'Τι ερώτηση θα θέλατε να κάνετε;',
        welcomeBack: 'Καλώς ήρθατε ξανά',
        needHelpWithRecipe: 'Χρειάζεστε βοήθεια με το μαγείρεμα;',
        viewRecipesHome: 'Κάντε την ερώτησή σας',
        popularIngredients: 'Δημοφιλή συστατικά',
        popularCookbooks: 'Δημοφιλή βιβλία συνταγών',
        browseByLetter: 'Περιήγηση ανά γράμμα',
        videoRecipes: 'Συνταγές βίντεο',
        randomRecipes: 'Τυχαίες συνταγές',
        recipesByLetter: 'Συνταγές ανά γράμμα',
        noRecipesFound: 'Δεν βρέθηκαν συνταγές',
        watchVideo: 'Παρακολούθηση βίντεο',
        categories: 'Κατηγορίες',
        areas: 'Περιοχές',
        filterBy: 'Φιλτράρισμα κατά',
        all: 'Όλα',
        beef: 'Μοσχάρι',
        chicken: 'Κοτόπουλο',
        goat: 'Κατσίκι',
        lamb: 'Αρνί',
        miscellaneous: 'Διάφορα',
        pasta: 'Ζυμαρικά',
        pork: 'Χοιρινό',
        seafood: 'Θαλασσινά',
        side: 'Συνοδευτικό',
        starter: 'Ορεκτικό',
        vegan: 'Vegan',
        vegetarian: 'Χορτοφαγικό',
        avocado: 'Αβοκάντο',
        bacon: 'Μπέικον',
        bakingPowder: 'Μπέικιν πάουντερ',
        balsamicVinegar: 'Βαλσάμικο ξύδι',
        basil: 'Βασιλικός',
        basilLeaves: 'Φύλλα βασιλικού',
        basmatiRice: 'Ρύζι μπασμάτι',
        bayLeaf: 'Δάφνη',
        bayLeaves: 'Φύλλα δάφνης',
        beefBrisket: 'Μοσχαρίσιο στήθος',
        beefFillet: 'Μοσχαρίσιο φιλέτο',
        beefGravy: 'Σάλτσα μοσχαριού',
        beefStock: 'Ζωμός μοσχαριού',
        bicarbonateOfSoda: 'Μαγειρική σόδα',
        biryaniMasala: 'Biryani Masala',
        blackPepper: 'Μαύρο πιπέρι',
        blackTreacle: 'Μαύρη μελάσα',
        appleCiderVinegar: 'Ξύδι μήλου',
        asparagus: 'Σπαράγγια',
        aubergine: 'Μελιτζάνα',
        babyPlumTomatoes: 'Ντοματίνια',
        british: 'Βρετανική',
        canadian: 'Καναδική',
        croatian: 'Κροατική',
        dutch: 'Ολλανδική',
        egyptian: 'Αιγυπτιακή',
        filipino: 'Φιλιππινέζικη',
        irish: 'Ιρλανδική',
        jamaican: 'Τζαμαϊκανή',
        kenyan: 'Κενυατική',
        malaysian: 'Μαλαισιανή',
        polish: 'Πολωνική',
        portuguese: 'Πορτογαλική',
        russian: 'Ρωσική',
        syrian: 'Συριακή',
        tunisian: 'Τυνησιακή',
        ukrainian: 'Ουκρανική',
        uruguayan: 'Ουρουγουανή',
        recipes: 'συνταγές',
        Chicken: 'Κοτόπουλο',
        Beef: 'Μοσχάρι',
        Pork: 'Χοιρινό',
        Salmon: 'Σολομός',
        Shrimp: 'Γαρίδες',
        Eggs: 'Αυγά',
        Tofu: 'Τόφου',
        Tuna: 'Τόνος',
        Potato: 'Πατάτα',
        Rice: 'Ρύζι',
        comments: 'Σχόλια',
        addComment: 'Αφήστε ένα σχόλιο',
        noComments: 'Δεν υπάρχουν ακόμη σχόλια. Γίνετε ο πρώτος!',
        submit: 'Υποβολή',
        commentSubmitted: 'Το σχόλιο δημοσιεύτηκε!',
        errorSubmittingComment: 'Σφάλμα κατά τη δημοσίευση του σχολίου.',
        backToWaiting: 'Πίσω',
        shoppingList: 'Λίστα αγορών',
        addItem: 'Προσθήκη είδους',
        add: 'Προσθήκη',
        clearList: 'Εκκαθάριση λίστας',
        addToShoppingList: 'Προσθήκη στη λίστα αγορών',
        quantity: 'Ποσότητα',
        diet: 'Δίαιτα',
        selectDiet: 'Επιλέξτε δίαιτα',
        keto: 'Keto',
        lowCarb: 'Χαμηλών υδατανθράκων',
        paleo: 'Paleo',
        mediterraneanDiet: 'Μεσογειακή',
        dairyFree: 'Χωρίς γαλακτοκομικά',
        glutenFree: 'Χωρίς γλουτένη',
        lowFat: 'Χαμηλών λιπαρών',
        highProtein: 'Υψηλής πρωτεΐνης',
        selectIngredients: 'Επιλέξτε συστατικά',
        salmon: 'Σολομός',
        shrimp: 'Γαρίδες',
        tofu: 'Τόφου',
        tuna: 'Τόνος',
        potato: 'Πατάτα',
        rice: 'Ρύζι',
        filters: "Φίλτρα",
        resetFilters: "Επαναφορά φίλτρων",
        tryAgain: "Δοκιμάστε ξανά",
        searchRecipes: "Αναζήτηση συνταγών...",
        addIngredient: "Προσθήκη συστατικού",
        upTo: "Έως",
        errorFetchingRecipes: "Παρουσιάστηκε σφάλμα κατά την ανάκτηση συνταγών",
        recipeLibraryTitle: "Βιβλιοθήκη συνταγών",
        recipesCount: "{count} συνταγές",
        searchPlaceholder: "Αναζήτηση συνταγών...",
        filterByLetter: "Φιλτράρισμα ανά γράμμα",
        allLetters: "Όλα",
        maxCalories: "Μέγ. θερμίδες",
        caloriesUnit: "kcal",
        maxCookingTime: "Μέγ. χρόνος",
        minutesUnit: "λεπ",
        minServings: "Ελάχ. μερίδες",
        maxServings: "Μέγ. μερίδες",
        selectAllergens: "Επιλέξτε αλλεργιογόνα",
        typeToSearch: "Πληκτρολογήστε για αναζήτηση...",
        selectNutritions: "Επιλέξτε θρεπτικά συστατικά",
        clearFilters: "Εκκαθάριση φίλτρων",
        noRecipesMatch: "Καμία συνταγή δεν ταιριάζει με τα φίλτρα",
        dairy: "Γαλακτοκομικά",
        showFilters: "Εμφάνιση φίλτρων",
        hideFilters: "Απόκρυψη φίλτρων",
        viewAllRecipes: "Προβολή όλων των συνταγών",
        budgetFriendlyCooking: "Οικονομικό μαγείρεμα",
        budgetFriendlyDescription: "Δημιουργήστε νόστιμα και οικονομικά γεύματα με το 'sous-chaif' χρησιμοποιώντας εξατομικευμένες συνταγές βάσει των συστατικών και των προτιμήσεών σας.",
        customRecipeSuggestions: "Προσαρμοσμένες προτάσεις συνταγών",
        customRecipeDescription: "Μοιραστείτε τα συστατικά, τις προτιμήσεις και τους διατροφικούς σας στόχους και το 'sous-chaif' θα σας προσφέρει εξατομικευμένες συνταγές.",
        secureAndEasy: "Ασφαλές και εύκολο",
        secureAndEasyDescription: "Τα δεδομένα σας είναι ασφαλή μαζί μας. Απολαύστε εύκολη πρόσβαση σε εξατομικευμένες συνταγές και συμβουλές μαγειρικής.",
        featureWelcomeTitle: "Καλώς ήρθατε στο Souschaif!",
        featureWelcomeSubtitle: "Ανεβάστε μια φωτογραφία των συστατικών ή του ψυγείου σας και λάβετε συνταγές αμέσως. Μπορείτε να κλείσετε αυτό το παράθυρο ανά πάσα στιγμή.",
        featureWelcomeGotIt: "Κατάλαβα",
        featureWelcomeMainBadge: "Το πιο σημαντικό",
        featureWelcomePhotoTitle: "Ανεβάστε φωτογραφία συστατικών ή ψυγείου",
        featureWelcomePhotoDescription: "Τραβήξτε ή ανεβάστε μια φωτογραφία και λάβετε αμέσως συνταγές βάσει όσων έχετε στο σπίτι.",
        featureWelcomeChatDescription: "Κάντε ερωτήσεις στον σεφ AI μας και λάβετε άμεσα εξατομικευμένες συμβουλές.",
        featureWelcomeLibraryDescription: "Περιηγηθείτε σε εκατοντάδες συνταγές και φιλτράρετε ανά συστατικά, αλλεργιογόνα και χρόνο μαγειρέματος.",
        featureWelcomeShoppingDescription: "Δημιουργήστε αυτόματα λίστα αγορών από τις συνταγές σας.",
        smartShoppingList: "Έξυπνη λίστα αγορών",
        smartShoppingListDescription: "Δημιουργήστε λίστες αγορών βάσει των αγαπημένων σας συνταγών.",
        usernameOrMobile: "Όνομα χρήστη ή αριθμός κινητού",
        rememberMe: "Να με θυμάσαι",
        logIn: "Σύνδεση",
        signingIn: "Σύνδεση...",
        noAccount: "Δεν έχετε λογαριασμό;",
        signUp: "Εγγραφή",
        next: "Επόμενο",
        skip: "Παράλειψη",
        defaultNotSubscribed: 'Δεν είστε συνδρομητής σε αυτή την υπηρεσία',
        defaultLoginError: 'Αδυναμία επαλήθευσης της συνδρομής σας. Παρακαλώ δοκιμάστε αργότερα',
        signup: "Εγγραφή",
        signupIntro: "Δημιουργήστε τον λογαριασμό σας για να ξεκινήσετε",
        confirmPassword: "Επιβεβαίωση κωδικού",
        signupButton: "Δημιουργία λογαριασμού",
        signupError: "Σφάλμα κατά την εγγραφή",
        alreadySubscribed: "Είστε ήδη συνδρομητής;",
        clickHere: "Κάντε κλικ εδώ",
        signupSuccess: "Ο λογαριασμός δημιουργήθηκε με επιτυχία",
        passwordRequirements: "Απαιτήσεις κωδικού",
        minLength: "Τουλάχιστον 8 χαρακτήρες",
        requireUppercase: "Τουλάχιστον ένα κεφαλαίο γράμμα",
        requireLowercase: "Τουλάχιστον ένα πεζό γράμμα",
        requireNumber: "Τουλάχιστον ένας αριθμός",
        requireSpecial: "Τουλάχιστον ένας ειδικός χαρακτήρας",
        passwordsMatch: "Οι κωδικοί ταιριάζουν",
        passwordRequirementsNotMet: "Παρακαλώ καλύψτε όλες τις απαιτήσεις κωδικού",
        newPassword: "Νέος κωδικός",
        leaveEmptyToKeep: "Αφήστε κενό για να διατηρήσετε τον τρέχοντα κωδικό",
        sessionId: "ID συνεδρίας",
        createdAt: "Ο λογαριασμός δημιουργήθηκε",
        errorFetchingUserData: "Σφάλμα κατά την ανάκτηση δεδομένων χρήστη",
        errorUpdatingUser: "Σφάλμα κατά την ενημέρωση δεδομένων χρήστη",
        confirmUnsubscribe: "Επιβεβαίωση ακύρωσης συνδρομής",
        confirmUnsubscribeMessage: "Είστε σίγουροι ότι θέλετε να ακυρώσετε τη συνδρομή σας;",
        confirmPasswordChange: "Επιβεβαίωση αλλαγής κωδικού",
        confirmPasswordChangeMessage: "Είστε σίγουροι ότι θέλετε να αλλάξετε τον κωδικό σας;",
        yes: "Ναι",
        cancel: "Ακύρωση",
        logout: 'Αποσύνδεση',
        continentEurope: 'Ευρώπη',
        continentMiddleEast: 'Μέση Ανατολή',
        continentAsia: 'Ασία',
        continentAfrica: 'Αφρική',
        continentNorthAmerica: 'Βόρεια Αμερική',
        continentSouthAmerica: 'Νότια Αμερική',
        continentOceania: 'Ωκεανία',
        backToContinents: 'Επιστροφή στις ηπείρους',
        downloadRecipe: 'Λήψη συνταγής',
        pdfDownloaded: 'Το PDF λήφθηκε με επιτυχία!',
        errorDownloadingPdf: 'Σφάλμα κατά τη λήψη του PDF.',
        random: 'Τυχαία',
        mostCommented: 'Πιο σχολιασμένα',
        mostLiked: 'Πιο αγαπημένα',
        newest: 'Νεότερα',
        quickest: 'Γρηγορότερα',
        lowestCalories: 'Λιγότερες θερμίδες',
        audioFetched: 'Ο ήχος είναι έτοιμος για αναπαραγωγή.',
        errorFetchingAudio: 'Σφάλμα κατά την ανάκτηση ήχου. Παρακαλώ δοκιμάστε ξανά.',
        loadingAudio: 'Φόρτωση ήχου...',
        winePairings: 'Προτάσεις κρασιού',
        errorWinePairing: 'Αδυναμία λήψης προτάσεων κρασιού. Παρακαλώ δοκιμάστε ξανά.',
        sharedOn: 'Η συνταγή κοινοποιήθηκε στο',
        copiedToClipboard: 'Η συνταγή αντιγράφηκε στο πρόχειρο!',
        shareError: 'Αδυναμία κοινοποίησης της συνταγής.',
        photoTip: 'Για καλύτερα αποτελέσματα, ανεβάστε μια καθαρή φωτογραφία συστατικών ή πιάτου.',
        noFoodDetected: 'Δεν εντοπίστηκε φαγητό ή συστατικά στη φωτογραφία σας. Παρακαλώ δοκιμάστε ξανά με φωτογραφία συστατικών ή πιάτου.',
        errorCompressingImage: 'Σφάλμα συμπίεσης εικόνας. Παρακαλώ δοκιμάστε μια μικρότερη φωτογραφία.',
        askingAboutCookbook: 'Ερωτήσεις για το βιβλίο συνταγών:',
        askingAboutRecipe: 'Ερωτήσεις για τη συνταγή:',
        comparePrices: 'Σύγκριση τιμών σούπερ μάρκετ',
        comparingPrices: 'Σύγκριση τιμών...',
        pricesFor: 'Τιμές για',
        priceComparison: 'Σύγκριση τιμών',
        estimate: 'εκτίμηση',
        potentialSavings: 'Πιθανή εξοικονόμηση',
        cheapestAt: 'Φθηνότερα στο',
        cheapest: 'Φθηνότερο',
        priceDisclaimer: 'Οι τιμές είναι εκτιμήσεις AI και μπορεί να διαφέρουν από τις πραγματικές τιμές καταστημάτων.',
        budget: 'Οικονομικό',
        midRange: 'Μεσαία κατηγορία',
        premium: 'Premium',
        clearListConfirmTitle: 'Εκκαθάριση λίστας αγορών;',
        clearListConfirmText: 'Αυτό θα αφαιρέσει όλα τα είδη από τη λίστα σας. Δεν μπορεί να αναιρεθεί.',
        allergyPreferences: 'Προτιμήσεις αλλεργιών',
        allergyPreferencesDescription: 'Επιλέξτε τα αλλεργιογόνα σας παρακάτω. Οι συνταγές που τα περιέχουν θα αποκρύπτονται από τις προτάσεις.',
        savePreferences: 'Αποθήκευση προτιμήσεων',
        saving: 'Αποθήκευση...',
        preferencesSaved: 'Οι προτιμήσεις αλλεργιών αποθηκεύτηκαν!',
        errorSavingPreferences: 'Σφάλμα κατά την αποθήκευση προτιμήσεων',
    }

});
